var Cs = Object.defineProperty, Es = Object.defineProperties;
var _s = Object.getOwnPropertyDescriptors;
var Jt = Object.getOwnPropertySymbols;
var ur = Object.prototype.hasOwnProperty, mr = Object.prototype.propertyIsEnumerable;
var cr = (t, e, n) => e in t ? Cs(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, H = (t, e) => {
  for (var n in e || (e = {}))
    ur.call(e, n) && cr(t, n, e[n]);
  if (Jt)
    for (var n of Jt(e))
      mr.call(e, n) && cr(t, n, e[n]);
  return t;
}, G = (t, e) => Es(t, _s(e));
var en = (t, e) => {
  var n = {};
  for (var r in t)
    ur.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && Jt)
    for (var r of Jt(t))
      e.indexOf(r) < 0 && mr.call(t, r) && (n[r] = t[r]);
  return n;
};
var ot = (t, e, n) => new Promise((r, o) => {
  var a = (d) => {
    try {
      l(n.next(d));
    } catch (c) {
      o(c);
    }
  }, i = (d) => {
    try {
      l(n.throw(d));
    } catch (c) {
      o(c);
    }
  }, l = (d) => d.done ? r(d.value) : Promise.resolve(d.value).then(a, i);
  l((n = n.apply(t, e)).next());
});
import "./style.css";
import As, { createContext as mt, useState as w, useEffect as S, useCallback as J, useMemo as $, useContext as P, useRef as be, useImperativeHandle as Rs, useLayoutEffect as Ds, Fragment as It } from "react";
import { useViewport as Ln, useHttpApi as ve, useUnionText as O, Container as te, Row as W, Col as F, Form as Rr, Flex as B, Field as Pt, Input as vt, Button as ie, IconButton as On, InfoCircleIcon as pt, Modal as Je, ExternalContent as kt, Element as L, CheckCircleIcon as zs, Picture as Et, InfoCircleSolidIcon as un, Box as Dr, Checkbox as zr, Badge as _t, ExclamationTriangleIcon as Ls, CheckboxGroup as Fs, Content as Bs, ErrorBoundary as Gt, Alert as Ge, Price as Ne, RadioGroup as Fn, Radio as Bn, ComboBox as rn, MinusIcon as Hs, PlusIcon as Us, usePrevious as $s, Breadcrumbs as De, useSessionHandler as Vs, UnionPortlet as Gs, RouterWrapper as Qs } from "@o2-shared/react-components";
import { useNavigate as je, useLocation as Hn, useSearchParams as mn, Routes as Pn, Route as fe, HashRouter as Ws } from "react-router-dom";
import { Badge as Lr, Modal as Ye, Box as xt, Swiper as Un, SwiperSlide as $n, ToastContainer as Ys, Toast as Zs, Carousel as Xs, Alert as ye, Button as ge, Picture as Vn, Icon as Q, Slider as Ks, Radio as qe, RadioGroup as pn, Input as Xt, Breadcrumbs as At, BreadcrumbsItem as Rt, Select as qs, Tooltip as tn, Dropdown as Fr } from "@o2-shared/react-components/wc";
import { Formik as Tt, useFormikContext as ee, Field as Oe, Form as Kt } from "formik";
var Br = { exports: {} }, hn = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Js = As, eo = Symbol.for("react.element"), to = Symbol.for("react.fragment"), no = Object.prototype.hasOwnProperty, ro = Js.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, so = { key: !0, ref: !0, __self: !0, __source: !0 };
function Hr(t, e, n) {
  var r, o = {}, a = null, i = null;
  n !== void 0 && (a = "" + n), e.key !== void 0 && (a = "" + e.key), e.ref !== void 0 && (i = e.ref);
  for (r in e)
    no.call(e, r) && !so.hasOwnProperty(r) && (o[r] = e[r]);
  if (t && t.defaultProps)
    for (r in e = t.defaultProps, e)
      o[r] === void 0 && (o[r] = e[r]);
  return { $$typeof: eo, type: t, key: a, ref: i, props: o, _owner: ro.current };
}
hn.Fragment = to;
hn.jsx = Hr;
hn.jsxs = Hr;
Br.exports = hn;
var s = Br.exports;
const oo = {
  crossSell: {
    programs: [],
    devices: [],
    addons: [],
    cardinalityLimitReached: !1,
    containsDatahome: !1
  },
  addons: [],
  setAddons: () => {
  },
  refreshCrossSell: () => {
  },
  crossSellLoading: !1
}, Gn = mt(oo), ao = ({ crossSell: t, refreshCrossSell: e, crossSellLoading: n, children: r }) => {
  const [o, a] = w([]), i = t.addons;
  return S(() => {
    if (i != null && i.length) {
      const l = i.map((d) => G(H({}, d), {
        checked: !!d.quoteItemId
        //pre-check addons with non-null quoteItemId
      }));
      a(l);
    }
  }, [i]), /* @__PURE__ */ s.jsx(Gn.Provider, { value: { crossSell: t, addons: o, setAddons: a, refreshCrossSell: e, crossSellLoading: n }, children: r });
}, io = {
  submitText: "Pokračovať do košíka",
  goToCart: "Prejst do košíka",
  quoteNumberError: "Nie je možné zobraziť stránku bez čísla kvóty.",
  monthlyPrice: "$price$ € mes.",
  oneTimePrice: "$price$ €",
  learnMore: "Zistiť viac",
  setTopBox: {
    checkbox: "Mám záujem o zariadenie",
    price: "Cena zariadenia $price$ €",
    description: "Prečo potrebujem TV box?",
    modal: {
      subtitle: "Výkonný TV Box vybavený systémom Andorid a podporou 4K rozlíšenia.",
      list: {
        title: "Hlavné výhody",
        item1: "vychutnajte si O2 TV, HBO MAX, Netflix, Disney+, Amazon Prime v tej najlepšej kvalite",
        item2: "integrovaný obchod Google Play poskytuje prístup k streamovacím službám, hrám a aplikáciám",
        item3: "rýchle a komfortné ovládanie zabezpečí diaľkový ovládač s Bluetooth a hlasovým ovládaním"
      },
      description1: "Zariadenie ponúka bohaté možnosti konektivity - <strong>dvojpásmové pripojenie pomocou Wi-Fi, Chromecast, Google Asistent, Bluetooth</strong>.",
      description2: "Vďaka 2 portom USB, portu HDMI, ethernetovému portu a digitálnemu audio výstupu, bude vaše sledovanie TV jednoduché a používateľsky príjemné."
    }
  }
}, lo = {
  breadcrumbs: {
    back: "Späť na výber internetu"
  },
  title: "Máte záujem o preplatenie zmluvnej pokuty?",
  fineAmount: "Ak ste viazaný u vášho operátora, po zrušení aktuálneho internetového pripojenia vám preplatíme zmluvnú pokutu až do výšky $totalPrice$ €.",
  learnMore: "Zistiť viac",
  detailsModal: {
    title: "Ako funguje preplatenie zmluvnej pokuty?",
    items: [
      'Keď vám váš starý operátor doručí záverečnú <strong>faktúru so zmluvnou pokutou, zašlite nám ju na</strong>&nbsp;<a href="mailto:udaje@o2.sk">udaje@o2.sk</a>.',
      "<strong>Celkovú sumu</strong> na preplatenie zmluvnej pokuty so službou Vykúpenie z viazanosti <strong>vám pošleme na váš bankový účet</strong>. Vo faktúre vám túto <strong>sumu rozdelíme na mesačné splátky vo výške 4 €, voči ktorým sa zároveň bude uplatňovať zľava 4 € mesačne</strong> z vášho paušálu. <strong>Za zmluvnú pokutu tak nezaplatíte ani euro navyše</strong>."
    ]
  },
  continue: "Pokračovať"
}, co = {
  WEEKLY: " týž.",
  MONTHLY: " mes.",
  DEFAULT: ""
}, uo = {
  breadcrumbs: {
    backToChooseInternet: "Späť na výber internetu"
  },
  errorBoundaryDevice: "Pri načítavaní dát nastala chyba.",
  missingQuoteError: "Nie je možné zobraziť stránku bez kvóty.",
  noRoutersError: "Nepodarilo sa načítať žiadne zariadenia.",
  title: "Výber zariadenia",
  extenders: {
    title: "Máte veľkú domácnosť?",
    more: "Zistiť viac"
  },
  learnMore: "Zistiť viac",
  nextStep: "Pokračovať"
}, mo = {
  breadcrumbs: {
    back: "Späť na môj výber"
  },
  title: "Vyberte spôsob platby za zariadenie",
  subtitle: "Alebo vyberte možnosť pokračovať s vlastným zariadením.",
  payments: {
    O2_MOBIL: "Kúpiť na splátky",
    CASH: "Kúpiť za plnú sumu",
    OWN_DEVICE: "Mám vlastné zariadenie"
  },
  continue: "Pokračovať"
}, po = {
  title: "Nákup na splátky k paušálu",
  existingSim: "Na mojom čísle",
  newSim: "Prenos čísla / nové číslo",
  newCustomer: "Nový zakazník",
  tariff: "Paušál",
  tariffDetail: "Detail paušálu",
  tariffChange: "Váš paušál sa zmení",
  budgetIncrease: "Zľava na zariadenia sa vám zvýší o $amount$ € mesačne.",
  budgetDecrease: "Zľava na zariadenia sa vám však zníži o $amount$ € mesačne.",
  goodToKnow: "Dobré vedieť",
  canUseSliderText: "Zľavy na zariadenia sa automaticky uplatnia neskôr pri nákupe. Rovnako aj výšku akontácie (úvodnej platby) si môžete upraviť neskôr pri nákupe.",
  tripletsHeading: "Neprehliadnite",
  tripletsText: "Finálna cena za všetky tri zariadenia (telefón + zariadenie za 1 € + O2 pods za 1 €) spolu s mesačným poplatkom za paušál bude zobrazená v nákupnom košíku.  ",
  buyMoreStuff: "Aby ste si mohli kúpiť zariadenie na splátky k paušálu, je potrebné pridať ďalšie zariadenie v hodnote aspoň $amount$ €",
  continue: "Pokračovať",
  addToCart: "Pridať do košíka",
  pricingDropdownHeading: "Spolu mesačne",
  advancePayment: "Akontácia",
  advancePaymentTooltip: "Akontácia (úvodná platba za zariadenie) je suma, ktorú zaplatíte na začiatok za zariadenia v košíku. Je prednastavená na odporúčanú hodnotu.",
  missingHwDevicesError: "Nie je možné zobraziť stránku bez vybratého zariadenia."
}, ho = {
  heading: "Výborne, máte vybratý program",
  description: "Na akom telefónnom čísle si prajete program aktivovať?",
  portinBuyOutTitle: "Chcete preplatiť zmluvnú pokutu so službou Vykúpenie z viazanosti?",
  portinBuyOutDescription: "Ak ste viazaný u vášho operátora, po zrušení aktuálneho paušálu vám preplatíme zmluvnú pokutu až do výšky 120 €.",
  portinBuyOutModal: {
    moreDetail: "Zistiť viac",
    title: "Ako funguje preplatenie zmluvnej pokuty?",
    firstPoint: 'Keď vám váš starý operátor doručí záverečnú <b>faktúru so zmluvnou pokutou, zašlite nám ju na <a href="mailto:udaje@o2.sk">udaje@o2.sk</a></b>.',
    secondPoint: "<b>Celkovú sumu</b> na preplatenie zmluvnej pokuty so službou Vykúpenie z viazanosti <b>vám pošleme na váš bankový účet</b>. Vo faktúre vám túto <b>sumu rozdelíme na mesačné splátky vo výške 4 €, voči ktorým sa zároveň bude uplatňovať zľava 4 € mesačne</b> z vášho paušálu. <b>Za zmluvnú pokutu tak nezaplatíte ani euro navyše.</b>",
    thirdPoint: "<b>Preplatenie</b> zmluvnej pokuty <b>sa uplatňuje vo výške 4 € mesačne</b> po dobu, <b>kým suma nedosiahne celkovú výšku zmluvnej pokuty</b> (maximálne však do 120 €)."
  },
  changeTariff: "Zmeniť program",
  alreadyActive: "Už máte aktívny $tariff$. ",
  alreadyActiveDesc: "Pre zmenu programu prosím zvoľte iný program.",
  alreadyActiveHowItWorks: "Ako prebieha zmena programu?",
  alreadyActiveModalDesc: "<ol><li>Zmenu programu začneme spracovávať hneď po vytvorení objednávky.</li><li>Zmena sa zvyčajne prejaví v priebehu niekoľkých minút.</li><li>O úspešnej zmene programu vás budeme informovať SMS správou.</li></ol>",
  alreadyActiveModalTariffDowngradeDesc: "<ol><li>Zmenu programu začneme spracovávať hneď po vytvorení objednávky.</li><li>Zmena sa prejaví na konci zúčtovacieho obdobia.</li><li>O úspešnej zmene programu vás budeme informovať SMS správou.</li></ol>",
  alreadyActiveModalHint: "Zmeniť program si môžete raz za zúčtovacie obdobie.",
  fenixHowItWorks: "Vyskladali sme vám špeciálnu ponuku nového O2 Paušálu",
  goodToKnow: "Dobré vedieť",
  readMore: "Zistiť viac",
  learnMore: "Zistiť viac",
  desiredMsisdn: "Nové číslo",
  desiredMsisdnDesc: "Mám záujem o nové telefónne číslo",
  desiredMsisdnButton: "Chcem si vybrať číslo",
  desiredMsisdnHowItWorks: "Ako prebieha aktivácia nového čísla?",
  desiredMsisdnModalDesc: "<ol><li>Po vytvorení objednávky vám e-mailom zašleme sprievodné dokumenty k nahliadnutiu.</li><li>Dokumenty podpíšete u kuriéra alebo v predajni pri vyzdvihnutí SIM karty.</li><li>Vašu novú SIM kartu aktivujeme v priebehu pár minút od podpísania dokumentov.</li></ol>",
  desiredMsisdnInput: "Telefónne číslo",
  desiredMsisdnInputPlaceholder: "09** *** ***",
  desiredMsisdnInputDescription: "Zadajte aspoň 3 číslice.",
  desiredMsisdnValidations: {
    minLength: "Zadajte aspoň 3 číslice.",
    maxLength: "Zadajte najviac 10 číslic.",
    format: "Povolené znaky sú len 0 - 9.",
    notAvailable: "Ľutujeme, nenašli sme voľné číslo."
  },
  desiredMsisdnRandom: {
    heading: "Dobré vedieť",
    paragraph1: "Náhodne pridelené telefónne číslo nie je spoplatnené. Ak máte záujem o vlastné číslo, výber bude spoplatnený sumou 10,25 € alebo 338,25 € pri zlatom čísle.",
    paragraph2: "Ak máte rezervované číslo, napíšte ho do poľa a následne overte cez PUN kód.",
    button: "Chcem náhodné číslo"
  },
  desiredMsisdnModal: {
    heading: "Výber vlastného čísla",
    description: {
      isGold: "Poplatok za zlaté telefónne číslo $fee$ €",
      default: "Poplatok za výber telefónneho čísla $fee$ €"
    },
    button: "Vybrať číslo",
    cancel: "Zrušiť"
  },
  desiredMsisdnFee: {
    product: {
      isGold: "Zlaté telefónne číslo",
      default: "Výber telefónneho čísla"
    },
    total: "$fee$ €"
  },
  desiredMsisdnPun: {
    heading: "Vybraté číslo je rezervované",
    description: "Pre pokračovanie použite kód, ktorý ste obdržali od asistenta pri rezervácii čísla.",
    input: "Rezervačný kód",
    maxLength: "Zadajte najviac 8 číslic.",
    format: "Povolené znaky sú len písmená bez diakritiky a čísla.",
    incorrect: "Ľutujeme, zadaný kód je nesprávny."
  },
  deposit: {
    heading: "Inicializačná zábezpeka",
    more: "Zistiť viac",
    description: "Zábezpeka je vratná záloha vo výške 10 €, ktorá vám môže byť automaticky pripočítaná k nákupu po zadaní osobných údajov.<br />Zábezpeku vám vrátime po riadnom uhradení troch faktúr tak, že sa postupne odpočíta v nasledujúcich faktúrach."
  },
  portin: "Prenos čísla do O2",
  portinDesc: "Zmena operátora",
  portinMsisdn: "Telefónne číslo",
  portinChangeMsisdn: "Zmeniť číslo",
  portinMsisdnDesc: "Číslo si následne overíme",
  portinHowItWorks: "Ako prebieha prenos čísla?",
  portinModalDesc: "<ol><li>Uistite sa, že zadané telefónne číslo a osobné údaje v rámci nákupu sú rovnaké ako u súčasného operátora.</li><li>Vašu novú SIM kartu vám doručí kuriér. Podpíše s vami aj potrebné dokumenty.</li><li>Hneď ako od kuriéra dostaneme podpísané dokumenty (doručenie trvá minimálne 2 pracovné dni), spracujeme žiadosť a začína plynúť lehota na prenos čísla (4 pracovné dni).</li><li>O úspešnom prenesení čísla vás budeme informovať SMS správou. Následne si jednoducho vymeníte starú SIM kartu vo svojom telefóne za novú.</li></ol>",
  portinModalHint: "Počas prenosu môžete svoje existujúce telefónne číslo využívať bez prerušenia.",
  portinBuyout: {
    description: "Zadajte číslo účtu, na ktorý vám pošleme peniaze za preplatenie zmluvnej pokuty.",
    ibanlabel: "Číslo účtu",
    ibanPlaceholder: "Číslo vášho účtu",
    ibanInvalid: "Povolená dĺžka je 24 znakov, príklad: SK77 8180 0000 0001 2312 3123"
  },
  missingQuoteError: "Nie je možné zobraziť stránku bez vybratého tarifu.",
  cancel: "Zrušiť",
  confirm: "Potvrdiť",
  continue: "Pokračovať",
  addToCart: "Pridať do košíka",
  required: "Toto pole je vyžadované.",
  activationError: "Vybrané telefónne číslo nie je možné použiť.",
  portinError: {
    O2_CUSTOMER: "Už ste zákazníkom O2.",
    VIRTUAL_PORTIN_NOT_ALLOWED: "Prenos čísla je možný len na existujúce číslo cez Moje O2.",
    O2BS_CUSTOMER: "Číslo nie je možné preniesť.",
    MULTIPLE_OPERATORS: "V rámci jednej objednávky si môžete preniesť čísla len od jedného operátora.",
    PORTIN_ALREADY_REQUESTED: "O prenos tohto čísla ste už požiadali.",
    OPERATOR_NOT_FOUND: "Zadané číslo je neplatné.",
    DEFAULT: "Číslo momentálne nie je možné overiť."
  },
  error: "Tarif nie je povolený k aktivácii"
}, Qn = {
  error: "Nastala chyba pri načítavaní údajov zo servera. Skúste neskôr prosím.",
  notFound: 'Prepáčte, pri načítaní stránky sa niečo pokazilo. Požadovaný produkt ($entity$) si prosím skúste vyhľadať na <a href="https://www.o2.sk/">hlavnej stránke.</a>',
  breadcrumb: "Späť na môj výber",
  errorConfirm: "Áno, vymeniť",
  confirm: "Potvrdiť",
  errorCancelProgram: "Nie, ponechať program v košíku",
  errorCancel: "Nie, ponechať",
  cancel: "Zrušiť",
  alreadyInOrderTitle: "Vymeniť program v košíku?",
  alreadyInOrderDesc: "Zmena programu na čísle $msisdn$ je už v košíku s programom $tariff$.",
  alreadyInOrderSubTitle: "Chcete vymeniť program za:",
  notEligibleWithProgramTitle: "Vymeniť položky v košíku?",
  notEligibleWithProgramDesc: "$tariff$ nie je možné kúpiť s iným programom alebo tovarom.",
  duplicatedPortinTitle: "Vymeniť program v košíku?",
  duplicatedPortinDesc: "Prenos čísla $msisdn$ je už v košíku s programom $tariff$.",
  duplicatedPortinSubTitle: "Chcete vymeniť program za:",
  skuCanBeLostTitle: "Naozaj si prajete zmeniť svoj program?",
  skuCanBeLostDescWithDate: "Zmena je bezplatná a prebehne $date$. <strong>Vaše aktuálne zľavy, predplatné, balíčky a služby sa prenesú iba v prípade, ak ich je možné uplatniť aj na nový program.</strong> Nespotrebované dáta sa na nový program neprenesú.",
  skuCanBeLostDesc: "Zmena je bezplatná a prebehne zvyčajne v priebehu pár minút. <strong>Vaše aktuálne zľavy, predplatné, balíčky a služby sa prenesú iba v prípade, ak ich je možné uplatniť aj na nový program.</strong> Nespotrebované dáta sa na nový program neprenesú.",
  skuCanBeLostSubTitle: "Predplatné, balíčky a služby, o ktoré prídete: ",
  changedAddonsTitle: "Zmení sa:",
  discountedAddonEyeCatcher: "Za zvýhodnenú cenu",
  notCompatibleTitle: "Vymeniť položky v košíku?",
  notCompatibleDesc: "$tariff$ nie je možné kúpiť s iným programom alebo tovarom. Prajete si položky z košíka nahradiť?",
  PRICE_LEVEL_DECOMMISSIONED: {
    heading: "Informácia o predplatnom",
    text: 'Ak si program zmeníte, tak vám bude predplatné v cene paušálu deaktivované. Aktivovať si ho môžete neskôr v <a href="https://link.o2.sk/o2aplikacia">O2 aplikácii</a> už iba za doplatok. Vaše prihlasovacie údaje u poskytovateľa zostanú zachované. Kompletné informácie o predplatnom nájdete na: <a href="https://www.o2.sk/predplatne">www.o2.sk/predplatne</a>'
  }
};
// istanbul ignore file -- @preserve
const Ur = "PT_POSTPAID_PROGRAM", fo = "PS_PROGRAMS_SIMPACK", go = ["modern", "old"], vo = 4, Be = 24, pr = 40, xo = "/delegate/web-content?sid=2355222&tag=";
var nn = /* @__PURE__ */ ((t) => (t.O2TV = "cross_sell_header_o2tv", t.DATAHOME = "cross_sell_header_datahome", t.DEFAULT = "cross_sell_header_default", t))(nn || {});
const bo = "/delegate/web-content?sid=2355222&tag=", yo = "cross_sell_category_description_", Qe = {
  buy: "Pridať do košíka",
  buyHwInstallments: "Na splátky",
  buyHwFullPrice: "Za plnú sumu",
  addToCartInstallments: "Pridať na splátky",
  addToCartFullPrice: "Pridať za plnú sumu",
  added: "Pridané",
  outOfStock: "Tovar nie je na sklade",
  description: `K vášmu výberu sa môže hodiť aj niečo naviac. Vyberte si z
    ponuky služieb
    <br class="d-none d-xl-block">
    alebo nových zariadení.`,
  quoteNumberError: "Nie je možné zobraziť stránku bez čísla kvóty.",
  addMaterialPlaceholder: "Naskenovať produkt",
  addMaterialTooltip: "Zadajte sériové číslo alebo EAN kód produktu",
  learnMore: "Zistiť viac",
  scannerPlaceholder: "Naskenovať produkt",
  hwTitle: "Zariadenia a príslušenstvo",
  oneTimePrice: "$price$ €",
  programsTitle: "Mobilné služby",
  devicesTitle: "Najčastejšie kupované príslušenstvo",
  addons: "Balíčky",
  addonDetails: "Detaily balíčka",
  openSetTopBoxDetail: "Otvoriť detail set-top boxu",
  addTo: "Pridať k $productName$",
  addToAria: "$productName$",
  addOneMore: "Pridať ďalšie",
  addOneMoreAria: "",
  addToCart: "Pridať do košíka",
  addToCartAria: "",
  whySetTopBox: "Prečo potrebujem TV box?",
  close: "Zavrieť",
  closeAria: "",
  validUntil: " do $date$",
  goToCart: "Prejsť do košíka",
  goToCartAria: "",
  continue: "Pokračovať",
  continueAria: "",
  search: "Hľadať",
  searchAria: "",
  searchPlaceholder: "Vyhľadať a pridať produkt",
  searchDescription: "Zadajte sériové číslo alebo EAN kód produktu",
  addProductFailed: "Produkt <b>nebol pridaný</b> do košíka, skúste to prosím znova."
}, Mn = {
  DEFAULT_MESSAGE: "Ľutujeme, nepodarilo sa vložiť tovar do košíka, skúste prosím neskôr.",
  DEFAULT_MESSAGE_TITLE: "Niečo sa pokazilo",
  REQUIRED: "Povinný údaj",
  MIN_LENGTH: "Minimálna dĺžka je $length$ znakov",
  MAX_LENGTH: "Maximálna dĺžka je $length$ znakov",
  QUERY_INVALID: "Zadaný kód nie je validný EAN/SN",
  DEFAULT_BUTTON_TEXT: "Pokračovať",
  INCOMPATIBLE_MATERIAL: "Tovar nie je kúpiteľný samostatne, bez náväznosti na iný produkt.",
  INVALID_EAN_SN: "Zadaný kód je neplatný",
  NOT_FOUND: "Zadaný kód je neplatný",
  OUT_OF_STOCK: "Tovar nie je na sklade"
}, jo = {
  devicePrice_O2_EXTRA: "Cena zariadenia",
  devicePrice_SMARTWATCH: "Cena smart hodiniek",
  devicePrice_MOBILE_PHONES: "Cena telefónu",
  devicePrice_TABLETS: "Cena tabletu",
  devicePrice_ACCESSORIES: "Cena príslušenstva"
}, ko = {
  title: "Výška akontácie",
  subTitle: "Upravte si hodnotu akontácie podľa vašich predstáv.",
  instalationAmountText: "Splátka za zariadenia",
  monthlyAmountValue: "$amount$ € mes.",
  instalationTotalPriceText: "Spolu $installmentTotalPrice$ € za $installmentCount$ mes.",
  instalationAmountTooltip: "Celková suma splácania je rozdiel medzi cenou zariadení a zvolenou akontáciou. Táto suma je rozdelená na $installmentCount$ mesiacov a minimálna hodnota mesačnej splátky je $installmentValue$ €. Splátka musí byť v násobkoch $installmentValue$ €. V prípade, že celkovú sumu splácania nie je možné rozdeliť na presný násobok $installmentValue$ €, bude zvyšok čiastky započítaný do akontácie.",
  sumOfUsedBonusesText: "Zľava na zariadenia",
  usedBonusesTooltip: `Zľava na zariadenia sa uplatňuje vo forme zľavy z mesačného poplatku za vybraný program, vďaka čomu za zariadenie zaplatíte menej.
Ak zvolíte sumu mesačnej splátky nižšiu, ako je výška Zľavy na zariadenia, nebude uplatnená celá zľava, avšak nevyčerpanú časť môžete využiť pri ďalšom nákupe.`,
  bonusAmount: "-$amount$ € mes.",
  chosenAdvancePayment: "Akontácia",
  chosenAdvancePaymentTooltip: "Akontácia (úvodná platba za zariadenie) je suma, ktorú zaplatíte na začiatok za zariadenia v košíku. Je prednastavená na odporúčanú hodnotu.",
  hintHeading: "Dobré vedieť",
  hint1: "Vaša Zľava na zariadenia Vám v plnej výške pokrýva cenu zariadení. Mesačne nemusíte platiť nič navyše. Ak chcete využiť celú Zľavu na zariadenia, vyberte si ďalšie zariadenie z našej ponuky.",
  hint2: `Vami zvolená akontácia je nižšia ako odporúčaná hodnota.
Pri následnom schvaľovaní objednávky sa môže stať, že bude požadovaná vyššia hodnota akontácie, ako ste zvolili.`,
  hint3: `Je nastavená odporúčaná výška akontácie.
Objednávky podliehajú následnému schvaľovaniu a pri tejto alebo vyššej sume je vyššia pravdepodobnosť, že vaša objednávka bude schválená bez dodatočného navýšenia akontácie.`,
  hint4: "Objednávky podliehajú následnému schvaľovaniu a výnimočne sa môže stať, že bude požadovaná vyššia hodnota akontácie, ako ste zvolili.",
  hint5: "Pri vami zvolenej výške akontácie nezaplatíte za zariadenia mesačne nič navyše. Mesačnú splátku pokryje Zľava na zariadenia. Objednávky podliehajú následnému schvaľovaniu a výnimočne môže byť požadovaná vyššia hodnota akontácie, ako ste zvolili.",
  hint6: "Pri vami zvolenej výške akontácie nevyužijete celú Zľavu na zariadenia. Pre využitie plnej zľavy znížte výšku akontácie. Objednávky podliehajú následnému schvaľovaniu a výnimočne môže byť požadovaná vyššia hodnota akontácie, ako ste zvolili.",
  hint7: `Je nastavená odporúčaná výška akontácie. Pri tejto výške akontácie nezaplatíte za zariadenia mesačne nič navyše. Mesačnú splátku pokryje Zľava na zariadenia.
Objednávky podliehajú následnému schvaľovaniu a pri tejto alebo vyššej sume je vyššia pravdepodobnosť, že vaša objednávka bude schválená bez dodatočného navýšenia akontácie.`,
  hint8: `Vami zvolená akontácia je nižšia ako odporúčaná hodnota.
Pri následnom schvaľovaní objednávky sa môže stať, že bude požadovaná vyššia hodnota akontácie, ako ste zvolili. Pri vami zvolenej výške akontácie alebo vyššej akontácie, nezaplatíte za zariadenia mesačne nič navyše. Mesačnú splátku pokryje Zľava na zariadenia.`,
  hint9: `Vami zvolená akontácia je nižšia ako odporúčaná hodnota.
Pri následnom schvaľovaní objednávky sa môže stať, že bude požadovaná vyššia hodnota akontácie, ako ste zvolili. Vaša Zľava na zariadenia Vám v plnej výške pokrýva cenu zariadení. Mesačne nemusíte platiť nič navyše. Ak chcete Zľavu na zariadenia využiť celú, vyberte si ďalšie zariadenie z našej ponuky.`,
  hint10: `Je nastavená odporúčaná výška akontácie. Objednávky podliehajú následnému schvaľovaniu a pri tejto alebo vyššej sume je vyššia pravdepodobnosť, že vaša objednávka bude schválená bez dodatočného navýšenia akontácie.
Zľava na zariadenia Vám v plnej výške pokrýva cenu zariadení. Mesačne nemusíte platiť nič navyše. Ak chcete Zľavu na zariadenia využiť celú, vyberte si ďalšie zariadenie z našej ponuky.`,
  submitText: "Pokračovať do košíka"
}, To = {
  breadcrumbs: {
    backToChooseInternet: "Späť na výber internetu"
  },
  title: "Vyberte spôsob inštalácie",
  errorBoundaryDevice: "Pri načítavaní dát nastala chyba.",
  missingQuoteError: "Nie je možné zobraziť stránku bez kvóty.",
  installation: {
    title: "Spôsob inštalácie",
    boxContent: "Profesionálna inštalácia s odborným poradenstvom u vás doma",
    learnMore: "Ako to funguje?",
    label: {
      SELF_SERVICE: "O2 router si zvládnem zapojiť sám",
      TECHNICIAN: "Zapojenie O2 routra nechám na O2 technika"
    },
    hint: {
      SELF_SERVICE: '<ul class="ul"><li><b>Jednoduché zapojenie</b> pomocou návodu a kábla v balení.</li><li>Internet je pripravený na používanie v rozmedzí od <b>niekoľkých minút do&nbsp;niekoľkých hodín.</b></li><li>V prípade potreby môžete zavolať na Linku technickej podpory 0949&nbsp;949&nbsp;966.</li></ul>',
      TECHNICIAN: '<ul class="ul"><li>O nič sa nemusíte starať, všetko zapojí náš technik.</li><li>Internet je pripravený na používanie <b>zvyčajne v rozpätí 2-5 dní.</b></li><li>V prípade potreby vám <b>pomôže rozšíriť signál</b> po celej domácnosti.</li><li>Ak si objednáte aj O2 TV, pomôže vám s jej zapojením a spustením.</li></ul>'
    },
    recomended: "Odporúčame"
  },
  nextStep: "Pokračovať",
  installMethodModal: {
    title: "Ako to funguje?",
    steps: {
      SELF_SERVICE: {
        O2_INTERNET_ORDER: {
          title: "1. Podpis zmluvných dokumentov a prevzatie zariadenia",
          content: "Po dokončení objednávky prebehne podpis zmlúv súčasne s prevzatím zariadenia (O2 router), buď priamo v predajni, alebo pri doručení kuriérom."
        },
        OPTIC_SOCKET_ACTIVATION: {
          title: "2. Aktivácia optickej prípojky",
          content: "Ozve sa vám technik partnera, s ktorým si dohodnete dátum a čas jeho návštevy."
        },
        WIFI_ROUTER_INSTALLATION: {
          title: "3. Zapojenie O2 routera",
          content: "Podľa návodu v balení si jednoducho pripojíte O2 router. V prípade potreby je tu pre vás Linka technickej podpory 0949 949 966."
        },
        DONE: {
          title: "4. Hotovo",
          content: "Váš O2 Internet bude pripravený na používanie v rozmedzí od niekoľkých minút do niekoľkých hodín. Vo výnimočných prípadoch do 24 hodín."
        }
      },
      TECHNICIAN: {
        O2_INTERNET_ORDER: {
          title: "1. Podpis zmluvných dokumentov a prevzatie zariadenia",
          content: "Po dokončení objednávky prebehne podpis zmlúv súčasne s prevzatím zariadenia (O2 router) buď priamo v predajni alebo pri doručení kuriérom."
        },
        OPTIC_SOCKET_ACTIVATION: {
          title: "2. Aktivácia optickej prípojky",
          content: "Ozve sa vám technik partnera, s ktorým si dohodnete dátum a čas jeho návštevy."
        },
        WIFI_ROUTER_INSTALLATION: {
          title: "3. Zapojenie O2 routera",
          content: "Následne sa vám ozve O2 technik, ktorý vám pripojí O2 router a pripraví internet na používanie."
        },
        DONE: {
          title: "4. Hotovo",
          content: "Váš O2 Internet bude pripravený na používanie v rozmedzí od niekoľkých minút do niekoľkých hodín."
        }
      },
      DATAHOME: {
        O2_INTERNET_ORDER: {
          title: "1. Objednajte si O2 Internet",
          content: "O2 Internet na doma si rýchlo a jednoducho vyberiete a objednáte na našej stránke."
        },
        OPTIC_SOCKET_ACTIVATION: {
          title: "2. Kontaktujeme vás",
          content: "Nasledujúci pracovný deň po objednávke vás kontaktuje technik a dohodne si s vami termín inštalácie."
        },
        WIFI_ROUTER_INSTALLATION: {
          title: "3. Inštalácia O2 Internetu",
          content: "Navštívi vás technik, donesie so sebou potrebné zariadenia, vykoná inštaláciu O2 Internetu a zabezpečí podpísanie Zmluvy o pripojení."
        }
      }
    }
  }
}, wo = {
  breadcrumbs: {
    back: "Späť na výber internetu"
  },
  title: "Na vašej adrese evidujeme všetky prípojky obsadené",
  contactUsTitle: "Kontaktujte nás",
  contactUsText: "Navštívte našu <b>O2 Predajňu</b> alebo nás <b>kontaktujte online</b>. Naši kolegovia vám radi pomôžu.",
  buttonStores: "Zobraziť O2 Predajne",
  buttonStoresAria: "",
  buttonContactUs: "Kontaktujte nás online",
  buttonContactUsAria: ""
}, Io = {
  breadcrumbs: {
    back: "Späť na výber internetu"
  },
  title: "Na vašej adrese evidujeme všetky prípojky obsadené",
  subtitle: "Zvážte prosím tieto možnosti:",
  checkAddress: {
    title: "1. Skontrolujte správnosť zadanej adresy",
    text: "Ak ste zadali nesprávnu adresu, upravte si ju a pokračujte v procese.",
    link: "Upraviť adresu"
  },
  portation: {
    title: "2. Zákazník má pravdepodobne aktívny internet u iného poskytovateľa",
    text: "Ak zákazník využíva internet od iného poskytovateľa ale chce prejsť do O2, pokračujte v procese.",
    link: "Chcem prejsť do O2"
  }
}, No = {
  breadcrumbs: {
    back: "Späť na výber internetu"
  },
  title: "Potrebujeme vedieť viac",
  moreInfo: "Ako to funguje?",
  yourAddress: "Vaša adresa: ",
  floor: {
    title: "Na akom poschodí bývate?",
    floorLabel: "Poschodie bytu",
    placeholder: "Vyberte",
    inputPlaceholder: "Vyplňte",
    apartmentLabel: "Označenie bytu"
  },
  eic: {
    title: "Aký je váš EIC kód pre inštaláciu optickej prípojky?",
    eicLabel: "EIC kód",
    placeholder: "Napr. 24ZVSxxxxxxxxxxx",
    moreInfo: "Kde nájdem EIC kód?",
    modal: {
      heading: "Kde nájdem EIC kód?",
      text: '<p class="text-gray-medium">EIC kód je identifikátor používaný pre identifikáciu služby na konkrétnom mieste, využívanú konkrétnym užívateľom. Nachádza sa na faktúre od vášho distribútora elektrickej energie. </p><p class="mt-4 mb-3">Príklad zobrazenia EIC kódu na faktúre:</p><img src="https://www.o2static.sk/media/products/d9493381-598c-472a-b062-8fd758ceec19/full-image.webp" style="width: 100%;height: auto;max-width: 100%;" /><p class="mt-5 text-gray-medium">Zobrazenie na faktúre sa môže zmeniť. Stav platný k: 15.10.2024 </p>'
    }
  },
  required: "Povinný údaj",
  continue: "Pokračovať",
  continueAria: ""
}, So = {
  breadcrumbs: {
    back: "Späť na výber internetu"
  },
  title: "Využívate na vašej adrese internet?",
  moreInfo: "Ako to funguje?",
  PORT_IN: {
    label: "Áno, využívam",
    labelSecondary: "Využívam internet od iného poskytovateľa, ale chcem prejsť do O2",
    alert: '<p class="mb-3 text-brand"><b>Prenos internetu do O2 je jednoduchý:</b></p><ul class="ul"><li>Všetko zariadime za Vás.</li><li>Službu prenesieme v najskoršom možnom termíne.</li><li>Neplatíte za dve služby naraz.</li><li>Zmluvnú pokutu až do výšky 120 € nechajte na nás.</li><li>Bez internetu môžete byť maximálne 24 hodín.</li></ul>',
    moreInfoModal: {
      DATAHOME: {
        S1: {
          title: "1. Podpis Žiadosti o prenos internetu a zmluvných dokumentov",
          content: "Prebehne súčasne s prevzatím zariadenia buď priamo v predajni, alebo pri doručení kuriérom."
        },
        S2: {
          title: "2. Kontaktujeme vás",
          content: "Nasledujúci pracovný deň po objednávke vás kontaktuje technik a dohodne si s vami termín inštalácie."
        },
        S3: {
          title: "3. Inštalácia O2 Internetu",
          content: "Navštívi vás technik, donesie so sebou potrebné zariadenia, vykoná inštaláciu O2 Internetu a zabezpečí podpísanie Zmluvy o pripojení."
        },
        S4: {
          title: "4. Zrušenie služby u pôvodného poskytovateľa prebehne automaticky",
          content: "To znamená, že neplatíte za 2 služby naraz."
        }
      },
      DATAHOME_CABLE: {
        S1: {
          title: "1. Podpis Žiadosti o prenos internetu, zmluvných dokumentov a prevzatie zariadenia",
          content: "Po dokončení objednávky prebehne podpis zmlúv súčasne s prevzatím zariadenia (O2 router) buď priamo v predajni alebo pri doručení kuriérom."
        },
        S2: {
          title: "2. Aktivácia optickej prípojky",
          content: "Po dokončení objednávky prebehne podpis zmlúv súčasne s prevzatím zariadenia (O2 router) buď priamo v predajni, alebo pri doručení kuriérom."
        },
        S3: {
          title: "3. Zapojenie O2 routera",
          content: "V ďalšom kroku objednávky si vyberiete zapojenie O2 routera O2 technikom alebo si O2 router jednoducho pripojíte podľa návodu sami."
        },
        S4: {
          title: "4. O2 Internet optikou môžete využívať",
          content: "Váš O2 Internet bude pripravený na používanie v rozmedzí od niekoľkých minút do niekoľkých hodín. Vo výnimočných prípadoch do 24 hodín."
        },
        S5: {
          title: "5. Zrušenie služby u pôvodného poskytovateľa prebehne automaticky",
          content: "To znamená, že neplatíte za 2 služby naraz."
        }
      }
    }
  },
  NO_PORT_IN: {
    label: "Nie, nevyužívam",
    labelSecondary: "Chcem si založiť nový O2 Internet",
    alert: "Vyberte v prípade, ak si chcete zriadiť na svojej adrese novú internetovú službu.",
    moreInfoModal: {
      DATAHOME: {
        S1: {
          title: "1. Objednajte si O2 Internet",
          content: "O2 Internet vzduchom si rýchlo a jednoducho vyberiete a objednáte na našej stránke."
        },
        S2: {
          title: "2. Kontaktujeme vás",
          content: "Nasledujúci pracovný deň po objednávke vás kontaktuje technik a dohodne si s vami termín inštalácie."
        },
        S3: {
          title: "3. Inštalácia O2 Internetu",
          content: "Navštívi vás technik, donesie so sebou potrebné zariadenia, vykoná inštaláciu O2 Internetu a zabezpečí podpísanie Zmluvy o pripojení."
        }
      },
      DATAHOME_CABLE: {
        S1: {
          title: "1. Podpis zmluvných dokumentov a prevzatie zariadenia",
          content: "Po dokončení objednávky prebehne podpis zmlúv súčasne s prevzatím zariadenia (O2 router) buď priamo v predajni, alebo pri doručení kuriérom."
        },
        S2: {
          title: "2. Aktivácia optickej prípojky",
          content: "Ozve sa vám technik partnera, s ktorým si dohodnete dátum a čas jeho návštevy."
        },
        S3: {
          title: "3. Zapojenie O2 routera",
          content: "V ďalšom kroku objednávky si vyberiete zapojenie O2 routera O2 technikom alebo si O2 router jednoducho pripojíte podľa návodu sami."
        },
        S4: {
          title: "4. Hotovo",
          content: "Váš O2 Internet bude pripravený na používanie v rozmedzí od niekoľkých minút do niekoľkých hodín. Vo výnimočných prípadoch do 24 hodín."
        }
      }
    }
  },
  continue: "Pokračovať",
  continueAria: ""
}, Oo = {
  breadcrumbs: {
    back: "Späť na výber internetu"
  },
  title: "Kto je váš aktuálny poskytovateľ internetu?",
  moreInfo: "Ako to funguje?",
  otherOperator: {
    donorCode: "Aktuálny poskytovateľ",
    donorCodePlaceholder: "Vyberte súčasného poskytovateľa",
    donorServiceId: "Identifikátor služby",
    donorServiceIdPlaceholder: "Príklad: FS5H85VSF",
    donorServiceIdMoreInfo: "Kde nájdem Identifikátor služby?",
    alert: {
      heading: "Skontrolujte správnosť údajov",
      text: "Ak potrebujete pomôcť, <b>kontaktujte nás online</b> alebo navštívte našu <b>O2 Predajňu</b>. Naši kolegovia vám radi pomôžu.",
      textAssistant: "Obe polia dôkladne porovnajte s faktúrou zákazníka."
    },
    serviceIdDescription: {
      heading: "Identifikátor služby",
      defaultHtmlDescription: "Môže mať rôzne podoby, napríklad <b>telefónne číslo, variabilný symbol, číslo účastníka, referenčné číslo služby alebo iný špecifický kód</b>. Nachádza sa na faktúre od poskytovateľa vášho internetového pripojenia. V prípade nejasností sa obráťte na vášho aktuálneho poskytovateľa."
    }
  },
  donorServiceIdUnrecognized: "Identifikátor služby nebol rozpoznaný",
  continue: "Pokračovať",
  continueAria: ""
}, Po = {
  heading: "Prihláste sa a urýchlite svoju objednávku",
  description: "Ak už ste naším zákazníkom, prihláste sa a vďaka predvyplneným formulárom vybavíte všetko rýchlejšie.",
  submit: "Prihlásiť sa",
  cancel: "Pokračovať ako nový zákazník"
}, Mo = {
  breadcrumbs: {
    backToChooseInternet: "Späť na výber internetu"
  },
  missingQuoteError: "Nie je možné zobraziť stránku bez kvóty.",
  title: "Vaše zariadenie",
  serialNumber: {
    label: "Zadajte sériové číslo vášho O2 zariadenia",
    validations: {
      NOT_O2_HW: "Zariadenie nie je zakúpené v O2",
      NOT_IO_HW: "Zariadenie nie je kompatibilné so zvolenou technológiou internetu",
      OK: ""
    },
    validationError: "Nepodarilo sa overiť sériové číslo",
    required: "Sériové číslo je vyžadované."
  },
  nextStep: "Pokračovať"
}, q = {
  DEFAULT: "/",
  CHOOSE_TARIFF: "/na-splatky",
  CHOOSE_TRANSACTION: "/typ-aktivacie",
  HW_SLIDER: "/akontacia",
  CART: "/kosik",
  CHOOSE_DEVICE_PAYMENT: "/vyber-platby-za-zariadenie",
  OWN_DEVICE: "/vlastne-zariadenie",
  INSTALLATION_METHOD: "/sposob-instalacie",
  CHOOSE_ROUTER: "/vyber-zariadenia",
  ADDONS: "/balicky-a-sluzby",
  CROSS_SELL: "/cross-sell",
  INTERNET_PORT_IN: "/prenos-internetu",
  INTERNET_PORT_IN_OPERATOR: "/aktualny-poskytovatel-internetu",
  INTERNET_MORE_INFO: "/internet-viac-info",
  INTERNET_ERROR: "/internet-error",
  INTERNET_ERROR_ASSISTANT: "/internet-error-pre-asistenta",
  CHOOSE_BUYOUT: "/preplatenie-zmluvnej-pokuty",
  LR_CART: "/e-shop/kosik",
  TV_STANDALONE_CHOOSE_HARDWARE: "/tv-zariadenia"
}, Co = [
  "DEFAULT",
  "ADDONS",
  "CHOOSE_TARIFF",
  "CHOOSE_TRANSACTION",
  "HW_SLIDER",
  "CHOOSE_DEVICE_PAYMENT",
  "OWN_DEVICE",
  "INSTALLATION_METHOD",
  "CHOOSE_ROUTER",
  "INTERNET_PORT_IN",
  "INTERNET_PORT_IN_OPERATOR",
  "INTERNET_MORE_INFO",
  "INTERNET_ERROR",
  "INTERNET_ERROR_ASSISTANT",
  "CHOOSE_BUYOUT",
  "CROSS_SELL",
  "TV_STANDALONE_CHOOSE_HARDWARE"
], Eo = [
  'Samsung Smart TV (s Tizen OS, vyrobený v roku 2018 alebo neskôr - <a href="https://www.o2.sk/documents/2355222/147179138/Samsung-TV_dostupnost-aplikacie-O2-TV_web.pdf">zoznam modelov</a>',
  "LG Smart TV (s WebOS 4.0 a vyššie).",
  "Smart TV s operačným systémom Android TV 9.0 a vyššie, ktorý je vybavený minimálne 1,5 GB RAM - operačnej pamäte (napr. TV Sony, Philips, TCL a iné vyrobené po roku 2019).",
  "Set Top Box s operačným systémom Android TV 9.0 a vyššie, ktorý je vybavený minimálne 1,5 GB RAM - operačnej pamäte (napr. Xiaomi Mi Box S, Xiaomi Mi TV Stick 4K, Nvidia Shield, Nokia Streaming Box 8000, Mecool KM2 Plus, Strong LEAP S1, Strong LEAP S3, Strong LEAP S3+)."
], _o = [
  "Starší televízor, ktorý nepodporuje sťahovanie aplikácii.",
  "Smart TV bez operačných systémov: Samsung Tizen, LG Web OS, Android TV.",
  "Starší Smart TV s operačným systémom Android TV 8 a nižšie alebo Smart TV, ktorá je staršia ako 6 rokov."
], Ao = {
  heading: "Na akom zariadení budete sledovať O2 TV?",
  radioContent: {
    modern: {
      title: "Smart TV, notebook, tablet alebo mobil",
      description: "Nepotrebujete Set Top Box.",
      helper: "Overte si podporované zariadenia",
      modal: {
        heading: "Podporované zariadenia",
        description: {
          title: "O2 TV môžete sledovať na rôznych zariadeniach a preto Set Top Box nebudete potrebovať, ak používate:",
          points: Eo
        }
      }
    },
    old: {
      title: "Televízor starší ako 5 rokov",
      description: "Potrebujete Set Top Box (pre každý televízor samostatný box. O2 TV však stále môžete sledovať aj na iných smart zariadeniach.",
      helper: "Kedy potrebujem Set Top Box?",
      modal: {
        heading: "Kedy potrebujem Set Top Box?",
        description: {
          title: "Set Top Box potrebujete, ak používate:",
          points: _o
        }
      }
    }
  },
  setTopBoxCard: {
    modal: {
      description: {
        heading: "Popis zariadenia:"
      },
      advantages: {
        heading: "Výhody:"
      }
    }
  },
  button: {
    submit: "Pokračovať",
    submitAria: ""
  },
  breadcrumbs: {
    back: "Späť na prihlásenie"
  },
  ariaLabels: {
    increaseCounterButton: "zvýšenie množstva settopboxu",
    decreaseCounterButton: "zníženie množstva settopboxu",
    setTopBoxCardPicture: "obrázok settopboxu a informačné tlačidlo",
    setTopBoxCardInfoButton: "Zobraziť viac informácií o televízore",
    seTopBoxCounterAmount: "množstvo settopboxov",
    radioGroup: "výber settopboxov pre telku"
  },
  errors: {
    setTopBoxData: "Pri načítavaní dát nastala chyba.",
    nextStepSubmit: "Pri spracovaní dát nastala chyba."
  }
}, Ro = {
  incrementProgramItemsInBasket: () => {
  },
  incrementDeviceItemsInBasket: () => {
  },
  onManuallyAddedItem: () => {
  },
  manuallyAddedPrograms: [],
  manuallyAddedDevices: []
}, Dt = mt(Ro), Do = ({ children: t }) => {
  const [e, n] = w([]), [r, o] = w([]), a = (c) => !!c.categories.find((u) => [Ur, fo].includes(u.businessId)), i = J((c) => {
    a(c) ? n((u) => u.map((m) => m.seoId).includes(c.seoId) ? [...u] : [G(H({}, c), { addedViaEanCode: !0 }), ...u]) : o((u) => u.map((m) => m.seoId).includes(c.seoId) ? [...u] : [G(H({}, c), { addedViaEanCode: !0 }), ...u]);
  }, []), l = J((c) => {
    n((u) => u.map((m) => m.seoId === c ? G(H({}, m), { itemsInBasket: m.itemsInBasket ? m.itemsInBasket + 1 : 1 }) : H({}, m)));
  }, []), d = J((c) => {
    o((u) => u.map((m) => m.seoId === c ? G(H({}, m), { itemsInBasket: m.itemsInBasket ? m.itemsInBasket + 1 : 1 }) : H({}, m)));
  }, []);
  return /* @__PURE__ */ s.jsx(
    Dt.Provider,
    {
      value: {
        onManuallyAddedItem: i,
        incrementProgramItemsInBasket: l,
        incrementDeviceItemsInBasket: d,
        manuallyAddedPrograms: e,
        manuallyAddedDevices: r
      },
      children: t
    }
  );
}, zo = {
  crossSell: {
    programs: [],
    devices: [],
    addons: [],
    cardinalityLimitReached: !1,
    containsDatahome: !1
  },
  refreshCrossSell: () => {
  },
  crossSellLoading: !1
}, Wn = mt(zo), Lo = ({ crossSell: t, refreshCrossSell: e, crossSellLoading: n, children: r }) => /* @__PURE__ */ s.jsx(
  Wn.Provider,
  {
    value: {
      crossSell: t,
      refreshCrossSell: e,
      crossSellLoading: n
    },
    children: r
  }
), Fe = mt({
  isLoading: void 0,
  setIsLoading: () => {
  }
}), $r = mt({
  askedForLogin: !1,
  setAskedForLogin: () => {
  }
}), K = mt({
  namespace: "",
  config: {
    assistantSignedIn: !1,
    hwSliderModelUrl: "",
    processItemsChangeUrl: "",
    chooseTransactionModelUrl: "",
    validatePortinUrl: "",
    ownDeviceModelUrl: "",
    ownDeviceSerialNumberUrl: "",
    chooseRouterModelUrl: "",
    installationMethodModelUrl: "",
    nextStateUrl: "",
    chooseTariffModelUrl: "",
    chooseBuyOutModelUrl: "",
    tariffDetailUrl: "",
    chooseInternetUrl: "",
    crossSellModelUrl: "",
    crossSellActionUrl: "",
    dataHomeAddonChangeUrl: "",
    chooseBuyOutUrl: "",
    articleSearchUrl: "",
    chooseInternetProgramUrl: "",
    canAddMaterial: !1,
    hideButtonsUrl: "",
    crossSellScanUrl: "",
    internetPortInUrl: "",
    internetPortInOperatorUrl: "",
    pricingInfoUrl: ""
  }
}), ne = mt({
  quote: void 0,
  setQuote: () => {
  },
  initialized: !1
});
// istanbul ignore file -- @preserve
const et = () => {
  const t = Ln();
  return ["base", "sm", "md"].includes(t);
}, Fo = () => {
  const [t, e] = w(localStorage.getItem("askedForLogin") === "true"), n = () => {
    localStorage.setItem("askedForLogin", "false");
  };
  return S(() => (localStorage.setItem("askedForLogin", t.toString()), window.addEventListener("o2logout", n), () => {
    window.removeEventListener("o2logout", n);
  }), [t]), { askedForLogin: t, setAskedForLogin: e };
};
var Bo = Object.defineProperty, Ho = Object.defineProperties, Uo = Object.getOwnPropertyDescriptors, hr = Object.getOwnPropertySymbols, $o = Object.prototype.hasOwnProperty, Vo = Object.prototype.propertyIsEnumerable, Cn = (t, e, n) => e in t ? Bo(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, Go = (t, e) => {
  for (var n in e || (e = {}))
    $o.call(e, n) && Cn(t, n, e[n]);
  if (hr)
    for (var n of hr(e))
      Vo.call(e, n) && Cn(t, n, e[n]);
  return t;
}, Qo = (t, e) => Ho(t, Uo(e)), A = (t, e, n) => (Cn(t, typeof e != "symbol" ? e + "" : e, n), n);
const Vr = 6048e5, Wo = 6e4, Yo = 36e5, Zo = 1e3, fr = Symbol.for("constructDateFrom");
function Pe(t, e) {
  return typeof t == "function" ? t(e) : t && typeof t == "object" && fr in t ? t[fr](e) : t instanceof Date ? new t.constructor(e) : new Date(e);
}
function Me(t, e) {
  return Pe(e || t, t);
}
function Gr(t, e, n) {
  const r = Me(t, n == null ? void 0 : n.in);
  return isNaN(e) ? Pe((n == null ? void 0 : n.in) || t, NaN) : (e && r.setDate(r.getDate() + e), r);
}
let Xo = {};
function fn() {
  return Xo;
}
function dt(t, e) {
  var n, r, o, a, i, l, d, c;
  const u = fn(), m = (c = (d = (a = (o = e == null ? void 0 : e.weekStartsOn) != null ? o : (r = (n = e == null ? void 0 : e.locale) == null ? void 0 : n.options) == null ? void 0 : r.weekStartsOn) != null ? a : u.weekStartsOn) != null ? d : (l = (i = u.locale) == null ? void 0 : i.options) == null ? void 0 : l.weekStartsOn) != null ? c : 0, v = Me(t, e == null ? void 0 : e.in), b = v.getDay(), f = (b < m ? 7 : 0) + b - m;
  return v.setDate(v.getDate() - f), v.setHours(0, 0, 0, 0), v;
}
function Mt(t, e) {
  return dt(t, Qo(Go({}, e), { weekStartsOn: 1 }));
}
function Ko(t, e) {
  const n = Me(t, e == null ? void 0 : e.in), r = n.getFullYear(), o = Pe(n, 0);
  o.setFullYear(r + 1, 0, 4), o.setHours(0, 0, 0, 0);
  const a = Mt(o), i = Pe(n, 0);
  i.setFullYear(r, 0, 4), i.setHours(0, 0, 0, 0);
  const l = Mt(i);
  return n.getTime() >= a.getTime() ? r + 1 : n.getTime() >= l.getTime() ? r : r - 1;
}
function Qr(t) {
  const e = Me(t), n = new Date(
    Date.UTC(
      e.getFullYear(),
      e.getMonth(),
      e.getDate(),
      e.getHours(),
      e.getMinutes(),
      e.getSeconds(),
      e.getMilliseconds()
    )
  );
  return n.setUTCFullYear(e.getFullYear()), +t - +n;
}
function qo(t, e) {
  const n = Ko(t, e), r = Pe((e == null ? void 0 : e.in) || t, 0);
  return r.setFullYear(n, 0, 4), r.setHours(0, 0, 0, 0), Mt(r);
}
function Jo(t, e) {
  const n = Me(t, e == null ? void 0 : e.in), r = +Mt(n) - +qo(n);
  return Math.round(r / Vr) + 1;
}
function Wr(t, e) {
  var n, r, o, a, i, l, d, c;
  const u = Me(t, e == null ? void 0 : e.in), m = u.getFullYear(), v = fn(), b = (c = (d = (a = (o = e == null ? void 0 : e.firstWeekContainsDate) != null ? o : (r = (n = e == null ? void 0 : e.locale) == null ? void 0 : n.options) == null ? void 0 : r.firstWeekContainsDate) != null ? a : v.firstWeekContainsDate) != null ? d : (l = (i = v.locale) == null ? void 0 : i.options) == null ? void 0 : l.firstWeekContainsDate) != null ? c : 1, f = Pe((e == null ? void 0 : e.in) || t, 0);
  f.setFullYear(m + 1, 0, b), f.setHours(0, 0, 0, 0);
  const k = dt(f, e), h = Pe((e == null ? void 0 : e.in) || t, 0);
  h.setFullYear(m, 0, b), h.setHours(0, 0, 0, 0);
  const p = dt(h, e);
  return +u >= +k ? m + 1 : +u >= +p ? m : m - 1;
}
function ea(t, e) {
  var n, r, o, a, i, l, d, c;
  const u = fn(), m = (c = (d = (a = (o = e == null ? void 0 : e.firstWeekContainsDate) != null ? o : (r = (n = e == null ? void 0 : e.locale) == null ? void 0 : n.options) == null ? void 0 : r.firstWeekContainsDate) != null ? a : u.firstWeekContainsDate) != null ? d : (l = (i = u.locale) == null ? void 0 : i.options) == null ? void 0 : l.firstWeekContainsDate) != null ? c : 1, v = Wr(t, e), b = Pe((e == null ? void 0 : e.in) || t, 0);
  return b.setFullYear(v, 0, m), b.setHours(0, 0, 0, 0), dt(b, e);
}
function ta(t, e) {
  const n = Me(t, e == null ? void 0 : e.in), r = +dt(n, e) - +ea(n, e);
  return Math.round(r / Vr) + 1;
}
function na(t, e) {
  const n = Me(t, e == null ? void 0 : e.in).getDay();
  return n === 0 ? 7 : n;
}
let ra = class {
  constructor() {
    A(this, "subPriority", 0);
  }
  validate(e, n) {
    return !0;
  }
};
class sa extends ra {
  constructor(e, n, r, o, a) {
    super(), this.value = e, this.validateValue = n, this.setValue = r, this.priority = o, a && (this.subPriority = a);
  }
  validate(e, n) {
    return this.validateValue(e, this.value, n);
  }
  set(e, n, r) {
    return this.setValue(e, n, this.value, r);
  }
}
class Y {
  run(e, n, r, o) {
    const a = this.parse(e, n, r, o);
    return a ? {
      setter: new sa(
        a.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: a.rest
    } : null;
  }
  validate(e, n, r) {
    return !0;
  }
}
class oa extends Y {
  constructor() {
    super(...arguments), A(this, "priority", 140), A(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(e, n, r) {
    switch (n) {
      case "G":
      case "GG":
      case "GGG":
        return r.era(e, { width: "abbreviated" }) || r.era(e, { width: "narrow" });
      case "GGGGG":
        return r.era(e, { width: "narrow" });
      case "GGGG":
      default:
        return r.era(e, { width: "wide" }) || r.era(e, { width: "abbreviated" }) || r.era(e, { width: "narrow" });
    }
  }
  set(e, n, r) {
    return n.era = r, e.setFullYear(r, 0, 1), e.setHours(0, 0, 0, 0), e;
  }
}
const ce = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, He = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function ue(t, e) {
  return t && {
    value: e(t.value),
    rest: t.rest
  };
}
function se(t, e) {
  const n = e.match(t);
  return n ? {
    value: parseInt(n[0], 10),
    rest: e.slice(n[0].length)
  } : null;
}
function Ue(t, e) {
  const n = e.match(t);
  if (!n)
    return null;
  if (n[0] === "Z")
    return {
      value: 0,
      rest: e.slice(1)
    };
  const r = n[1] === "+" ? 1 : -1, o = n[2] ? parseInt(n[2], 10) : 0, a = n[3] ? parseInt(n[3], 10) : 0, i = n[5] ? parseInt(n[5], 10) : 0;
  return {
    value: r * (o * Yo + a * Wo + i * Zo),
    rest: e.slice(n[0].length)
  };
}
function Yr(t) {
  return se(ce.anyDigitsSigned, t);
}
function le(t, e) {
  switch (t) {
    case 1:
      return se(ce.singleDigit, e);
    case 2:
      return se(ce.twoDigits, e);
    case 3:
      return se(ce.threeDigits, e);
    case 4:
      return se(ce.fourDigits, e);
    default:
      return se(new RegExp("^\\d{1," + t + "}"), e);
  }
}
function Zr(t, e) {
  switch (t) {
    case 1:
      return se(ce.singleDigitSigned, e);
    case 2:
      return se(ce.twoDigitsSigned, e);
    case 3:
      return se(ce.threeDigitsSigned, e);
    case 4:
      return se(ce.fourDigitsSigned, e);
    default:
      return se(new RegExp("^-?\\d{1," + t + "}"), e);
  }
}
function Yn(t) {
  switch (t) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function Xr(t, e) {
  const n = e > 0, r = n ? e : 1 - e;
  let o;
  if (r <= 50)
    o = t || 100;
  else {
    const a = r + 50, i = Math.trunc(a / 100) * 100, l = t >= a % 100;
    o = t + i - (l ? 100 : 0);
  }
  return n ? o : 1 - o;
}
function Kr(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
class aa extends Y {
  constructor() {
    super(...arguments), A(this, "priority", 130), A(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(e, n, r) {
    const o = (a) => ({
      year: a,
      isTwoDigitYear: n === "yy"
    });
    switch (n) {
      case "y":
        return ue(le(4, e), o);
      case "yo":
        return ue(
          r.ordinalNumber(e, {
            unit: "year"
          }),
          o
        );
      default:
        return ue(le(n.length, e), o);
    }
  }
  validate(e, n) {
    return n.isTwoDigitYear || n.year > 0;
  }
  set(e, n, r) {
    const o = e.getFullYear();
    if (r.isTwoDigitYear) {
      const i = Xr(
        r.year,
        o
      );
      return e.setFullYear(i, 0, 1), e.setHours(0, 0, 0, 0), e;
    }
    const a = !("era" in n) || n.era === 1 ? r.year : 1 - r.year;
    return e.setFullYear(a, 0, 1), e.setHours(0, 0, 0, 0), e;
  }
}
class ia extends Y {
  constructor() {
    super(...arguments), A(this, "priority", 130), A(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(e, n, r) {
    const o = (a) => ({
      year: a,
      isTwoDigitYear: n === "YY"
    });
    switch (n) {
      case "Y":
        return ue(le(4, e), o);
      case "Yo":
        return ue(
          r.ordinalNumber(e, {
            unit: "year"
          }),
          o
        );
      default:
        return ue(le(n.length, e), o);
    }
  }
  validate(e, n) {
    return n.isTwoDigitYear || n.year > 0;
  }
  set(e, n, r, o) {
    const a = Wr(e, o);
    if (r.isTwoDigitYear) {
      const l = Xr(
        r.year,
        a
      );
      return e.setFullYear(
        l,
        0,
        o.firstWeekContainsDate
      ), e.setHours(0, 0, 0, 0), dt(e, o);
    }
    const i = !("era" in n) || n.era === 1 ? r.year : 1 - r.year;
    return e.setFullYear(i, 0, o.firstWeekContainsDate), e.setHours(0, 0, 0, 0), dt(e, o);
  }
}
class la extends Y {
  constructor() {
    super(...arguments), A(this, "priority", 130), A(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, n) {
    return Zr(n === "R" ? 4 : n.length, e);
  }
  set(e, n, r) {
    const o = Pe(e, 0);
    return o.setFullYear(r, 0, 4), o.setHours(0, 0, 0, 0), Mt(o);
  }
}
class da extends Y {
  constructor() {
    super(...arguments), A(this, "priority", 130), A(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(e, n) {
    return Zr(n === "u" ? 4 : n.length, e);
  }
  set(e, n, r) {
    return e.setFullYear(r, 0, 1), e.setHours(0, 0, 0, 0), e;
  }
}
class ca extends Y {
  constructor() {
    super(...arguments), A(this, "priority", 120), A(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, n, r) {
    switch (n) {
      case "Q":
      case "QQ":
        return le(n.length, e);
      case "Qo":
        return r.ordinalNumber(e, { unit: "quarter" });
      case "QQQ":
        return r.quarter(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.quarter(e, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQQ":
        return r.quarter(e, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return r.quarter(e, {
          width: "wide",
          context: "formatting"
        }) || r.quarter(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.quarter(e, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(e, n) {
    return n >= 1 && n <= 4;
  }
  set(e, n, r) {
    return e.setMonth((r - 1) * 3, 1), e.setHours(0, 0, 0, 0), e;
  }
}
class ua extends Y {
  constructor() {
    super(...arguments), A(this, "priority", 120), A(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, n, r) {
    switch (n) {
      case "q":
      case "qq":
        return le(n.length, e);
      case "qo":
        return r.ordinalNumber(e, { unit: "quarter" });
      case "qqq":
        return r.quarter(e, {
          width: "abbreviated",
          context: "standalone"
        }) || r.quarter(e, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqqq":
        return r.quarter(e, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return r.quarter(e, {
          width: "wide",
          context: "standalone"
        }) || r.quarter(e, {
          width: "abbreviated",
          context: "standalone"
        }) || r.quarter(e, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(e, n) {
    return n >= 1 && n <= 4;
  }
  set(e, n, r) {
    return e.setMonth((r - 1) * 3, 1), e.setHours(0, 0, 0, 0), e;
  }
}
class ma extends Y {
  constructor() {
    super(...arguments), A(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]), A(this, "priority", 110);
  }
  parse(e, n, r) {
    const o = (a) => a - 1;
    switch (n) {
      case "M":
        return ue(
          se(ce.month, e),
          o
        );
      case "MM":
        return ue(le(2, e), o);
      case "Mo":
        return ue(
          r.ordinalNumber(e, {
            unit: "month"
          }),
          o
        );
      case "MMM":
        return r.month(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.month(e, { width: "narrow", context: "formatting" });
      case "MMMMM":
        return r.month(e, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return r.month(e, { width: "wide", context: "formatting" }) || r.month(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.month(e, { width: "narrow", context: "formatting" });
    }
  }
  validate(e, n) {
    return n >= 0 && n <= 11;
  }
  set(e, n, r) {
    return e.setMonth(r, 1), e.setHours(0, 0, 0, 0), e;
  }
}
class pa extends Y {
  constructor() {
    super(...arguments), A(this, "priority", 110), A(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, n, r) {
    const o = (a) => a - 1;
    switch (n) {
      case "L":
        return ue(
          se(ce.month, e),
          o
        );
      case "LL":
        return ue(le(2, e), o);
      case "Lo":
        return ue(
          r.ordinalNumber(e, {
            unit: "month"
          }),
          o
        );
      case "LLL":
        return r.month(e, {
          width: "abbreviated",
          context: "standalone"
        }) || r.month(e, { width: "narrow", context: "standalone" });
      case "LLLLL":
        return r.month(e, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return r.month(e, { width: "wide", context: "standalone" }) || r.month(e, {
          width: "abbreviated",
          context: "standalone"
        }) || r.month(e, { width: "narrow", context: "standalone" });
    }
  }
  validate(e, n) {
    return n >= 0 && n <= 11;
  }
  set(e, n, r) {
    return e.setMonth(r, 1), e.setHours(0, 0, 0, 0), e;
  }
}
function ha(t, e, n) {
  const r = Me(t, n == null ? void 0 : n.in), o = ta(r, n) - e;
  return r.setDate(r.getDate() - o * 7), Me(r, n == null ? void 0 : n.in);
}
class fa extends Y {
  constructor() {
    super(...arguments), A(this, "priority", 100), A(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(e, n, r) {
    switch (n) {
      case "w":
        return se(ce.week, e);
      case "wo":
        return r.ordinalNumber(e, { unit: "week" });
      default:
        return le(n.length, e);
    }
  }
  validate(e, n) {
    return n >= 1 && n <= 53;
  }
  set(e, n, r, o) {
    return dt(ha(e, r, o), o);
  }
}
function ga(t, e, n) {
  const r = Me(t, n == null ? void 0 : n.in), o = Jo(r, n) - e;
  return r.setDate(r.getDate() - o * 7), r;
}
class va extends Y {
  constructor() {
    super(...arguments), A(this, "priority", 100), A(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, n, r) {
    switch (n) {
      case "I":
        return se(ce.week, e);
      case "Io":
        return r.ordinalNumber(e, { unit: "week" });
      default:
        return le(n.length, e);
    }
  }
  validate(e, n) {
    return n >= 1 && n <= 53;
  }
  set(e, n, r) {
    return Mt(ga(e, r));
  }
}
const xa = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], ba = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class ya extends Y {
  constructor() {
    super(...arguments), A(this, "priority", 90), A(this, "subPriority", 1), A(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, n, r) {
    switch (n) {
      case "d":
        return se(ce.date, e);
      case "do":
        return r.ordinalNumber(e, { unit: "date" });
      default:
        return le(n.length, e);
    }
  }
  validate(e, n) {
    const r = e.getFullYear(), o = Kr(r), a = e.getMonth();
    return o ? n >= 1 && n <= ba[a] : n >= 1 && n <= xa[a];
  }
  set(e, n, r) {
    return e.setDate(r), e.setHours(0, 0, 0, 0), e;
  }
}
class ja extends Y {
  constructor() {
    super(...arguments), A(this, "priority", 90), A(this, "subpriority", 1), A(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, n, r) {
    switch (n) {
      case "D":
      case "DD":
        return se(ce.dayOfYear, e);
      case "Do":
        return r.ordinalNumber(e, { unit: "date" });
      default:
        return le(n.length, e);
    }
  }
  validate(e, n) {
    const r = e.getFullYear();
    return Kr(r) ? n >= 1 && n <= 366 : n >= 1 && n <= 365;
  }
  set(e, n, r) {
    return e.setMonth(0, r), e.setHours(0, 0, 0, 0), e;
  }
}
function Zn(t, e, n) {
  var r, o, a, i, l, d, c, u;
  const m = fn(), v = (u = (c = (i = (a = n == null ? void 0 : n.weekStartsOn) != null ? a : (o = (r = n == null ? void 0 : n.locale) == null ? void 0 : r.options) == null ? void 0 : o.weekStartsOn) != null ? i : m.weekStartsOn) != null ? c : (d = (l = m.locale) == null ? void 0 : l.options) == null ? void 0 : d.weekStartsOn) != null ? u : 0, b = Me(t, n == null ? void 0 : n.in), f = b.getDay(), k = (e % 7 + 7) % 7, h = 7 - v, p = e < 0 || e > 6 ? e - (f + h) % 7 : (k + h) % 7 - (f + h) % 7;
  return Gr(b, p, n);
}
class ka extends Y {
  constructor() {
    super(...arguments), A(this, "priority", 90), A(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(e, n, r) {
    switch (n) {
      case "E":
      case "EE":
      case "EEE":
        return r.day(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(e, { width: "short", context: "formatting" }) || r.day(e, { width: "narrow", context: "formatting" });
      case "EEEEE":
        return r.day(e, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return r.day(e, { width: "short", context: "formatting" }) || r.day(e, { width: "narrow", context: "formatting" });
      case "EEEE":
      default:
        return r.day(e, { width: "wide", context: "formatting" }) || r.day(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(e, { width: "short", context: "formatting" }) || r.day(e, { width: "narrow", context: "formatting" });
    }
  }
  validate(e, n) {
    return n >= 0 && n <= 6;
  }
  set(e, n, r, o) {
    return e = Zn(e, r, o), e.setHours(0, 0, 0, 0), e;
  }
}
class Ta extends Y {
  constructor() {
    super(...arguments), A(this, "priority", 90), A(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, n, r, o) {
    const a = (i) => {
      const l = Math.floor((i - 1) / 7) * 7;
      return (i + o.weekStartsOn + 6) % 7 + l;
    };
    switch (n) {
      case "e":
      case "ee":
        return ue(le(n.length, e), a);
      case "eo":
        return ue(
          r.ordinalNumber(e, {
            unit: "day"
          }),
          a
        );
      case "eee":
        return r.day(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(e, { width: "short", context: "formatting" }) || r.day(e, { width: "narrow", context: "formatting" });
      case "eeeee":
        return r.day(e, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return r.day(e, { width: "short", context: "formatting" }) || r.day(e, { width: "narrow", context: "formatting" });
      case "eeee":
      default:
        return r.day(e, { width: "wide", context: "formatting" }) || r.day(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(e, { width: "short", context: "formatting" }) || r.day(e, { width: "narrow", context: "formatting" });
    }
  }
  validate(e, n) {
    return n >= 0 && n <= 6;
  }
  set(e, n, r, o) {
    return e = Zn(e, r, o), e.setHours(0, 0, 0, 0), e;
  }
}
class wa extends Y {
  constructor() {
    super(...arguments), A(this, "priority", 90), A(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(e, n, r, o) {
    const a = (i) => {
      const l = Math.floor((i - 1) / 7) * 7;
      return (i + o.weekStartsOn + 6) % 7 + l;
    };
    switch (n) {
      case "c":
      case "cc":
        return ue(le(n.length, e), a);
      case "co":
        return ue(
          r.ordinalNumber(e, {
            unit: "day"
          }),
          a
        );
      case "ccc":
        return r.day(e, {
          width: "abbreviated",
          context: "standalone"
        }) || r.day(e, { width: "short", context: "standalone" }) || r.day(e, { width: "narrow", context: "standalone" });
      case "ccccc":
        return r.day(e, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return r.day(e, { width: "short", context: "standalone" }) || r.day(e, { width: "narrow", context: "standalone" });
      case "cccc":
      default:
        return r.day(e, { width: "wide", context: "standalone" }) || r.day(e, {
          width: "abbreviated",
          context: "standalone"
        }) || r.day(e, { width: "short", context: "standalone" }) || r.day(e, { width: "narrow", context: "standalone" });
    }
  }
  validate(e, n) {
    return n >= 0 && n <= 6;
  }
  set(e, n, r, o) {
    return e = Zn(e, r, o), e.setHours(0, 0, 0, 0), e;
  }
}
function Ia(t, e, n) {
  const r = Me(t, n == null ? void 0 : n.in), o = na(r, n), a = e - o;
  return Gr(r, a, n);
}
class Na extends Y {
  constructor() {
    super(...arguments), A(this, "priority", 90), A(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, n, r) {
    const o = (a) => a === 0 ? 7 : a;
    switch (n) {
      case "i":
      case "ii":
        return le(n.length, e);
      case "io":
        return r.ordinalNumber(e, { unit: "day" });
      case "iii":
        return ue(
          r.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || r.day(e, {
            width: "short",
            context: "formatting"
          }) || r.day(e, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
      case "iiiii":
        return ue(
          r.day(e, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
      case "iiiiii":
        return ue(
          r.day(e, {
            width: "short",
            context: "formatting"
          }) || r.day(e, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
      case "iiii":
      default:
        return ue(
          r.day(e, {
            width: "wide",
            context: "formatting"
          }) || r.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || r.day(e, {
            width: "short",
            context: "formatting"
          }) || r.day(e, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
    }
  }
  validate(e, n) {
    return n >= 1 && n <= 7;
  }
  set(e, n, r) {
    return e = Ia(e, r), e.setHours(0, 0, 0, 0), e;
  }
}
class Sa extends Y {
  constructor() {
    super(...arguments), A(this, "priority", 80), A(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(e, n, r) {
    switch (n) {
      case "a":
      case "aa":
      case "aaa":
        return r.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return r.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(e, {
          width: "wide",
          context: "formatting"
        }) || r.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(e, n, r) {
    return e.setHours(Yn(r), 0, 0, 0), e;
  }
}
class Oa extends Y {
  constructor() {
    super(...arguments), A(this, "priority", 80), A(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(e, n, r) {
    switch (n) {
      case "b":
      case "bb":
      case "bbb":
        return r.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return r.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(e, {
          width: "wide",
          context: "formatting"
        }) || r.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(e, n, r) {
    return e.setHours(Yn(r), 0, 0, 0), e;
  }
}
class Pa extends Y {
  constructor() {
    super(...arguments), A(this, "priority", 80), A(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(e, n, r) {
    switch (n) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(e, {
          width: "wide",
          context: "formatting"
        }) || r.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(e, n, r) {
    return e.setHours(Yn(r), 0, 0, 0), e;
  }
}
let Ma = class extends Y {
  constructor() {
    super(...arguments), A(this, "priority", 70), A(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(e, n, r) {
    switch (n) {
      case "h":
        return se(ce.hour12h, e);
      case "ho":
        return r.ordinalNumber(e, { unit: "hour" });
      default:
        return le(n.length, e);
    }
  }
  validate(e, n) {
    return n >= 1 && n <= 12;
  }
  set(e, n, r) {
    const o = e.getHours() >= 12;
    return o && r < 12 ? e.setHours(r + 12, 0, 0, 0) : !o && r === 12 ? e.setHours(0, 0, 0, 0) : e.setHours(r, 0, 0, 0), e;
  }
};
class Ca extends Y {
  constructor() {
    super(...arguments), A(this, "priority", 70), A(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(e, n, r) {
    switch (n) {
      case "H":
        return se(ce.hour23h, e);
      case "Ho":
        return r.ordinalNumber(e, { unit: "hour" });
      default:
        return le(n.length, e);
    }
  }
  validate(e, n) {
    return n >= 0 && n <= 23;
  }
  set(e, n, r) {
    return e.setHours(r, 0, 0, 0), e;
  }
}
class Ea extends Y {
  constructor() {
    super(...arguments), A(this, "priority", 70), A(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(e, n, r) {
    switch (n) {
      case "K":
        return se(ce.hour11h, e);
      case "Ko":
        return r.ordinalNumber(e, { unit: "hour" });
      default:
        return le(n.length, e);
    }
  }
  validate(e, n) {
    return n >= 0 && n <= 11;
  }
  set(e, n, r) {
    return e.getHours() >= 12 && r < 12 ? e.setHours(r + 12, 0, 0, 0) : e.setHours(r, 0, 0, 0), e;
  }
}
class _a extends Y {
  constructor() {
    super(...arguments), A(this, "priority", 70), A(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(e, n, r) {
    switch (n) {
      case "k":
        return se(ce.hour24h, e);
      case "ko":
        return r.ordinalNumber(e, { unit: "hour" });
      default:
        return le(n.length, e);
    }
  }
  validate(e, n) {
    return n >= 1 && n <= 24;
  }
  set(e, n, r) {
    const o = r <= 24 ? r % 24 : r;
    return e.setHours(o, 0, 0, 0), e;
  }
}
class Aa extends Y {
  constructor() {
    super(...arguments), A(this, "priority", 60), A(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(e, n, r) {
    switch (n) {
      case "m":
        return se(ce.minute, e);
      case "mo":
        return r.ordinalNumber(e, { unit: "minute" });
      default:
        return le(n.length, e);
    }
  }
  validate(e, n) {
    return n >= 0 && n <= 59;
  }
  set(e, n, r) {
    return e.setMinutes(r, 0, 0), e;
  }
}
class Ra extends Y {
  constructor() {
    super(...arguments), A(this, "priority", 50), A(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(e, n, r) {
    switch (n) {
      case "s":
        return se(ce.second, e);
      case "so":
        return r.ordinalNumber(e, { unit: "second" });
      default:
        return le(n.length, e);
    }
  }
  validate(e, n) {
    return n >= 0 && n <= 59;
  }
  set(e, n, r) {
    return e.setSeconds(r, 0), e;
  }
}
class Da extends Y {
  constructor() {
    super(...arguments), A(this, "priority", 30), A(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(e, n) {
    const r = (o) => Math.trunc(o * Math.pow(10, -n.length + 3));
    return ue(le(n.length, e), r);
  }
  set(e, n, r) {
    return e.setMilliseconds(r), e;
  }
}
class za extends Y {
  constructor() {
    super(...arguments), A(this, "priority", 10), A(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(e, n) {
    switch (n) {
      case "X":
        return Ue(
          He.basicOptionalMinutes,
          e
        );
      case "XX":
        return Ue(He.basic, e);
      case "XXXX":
        return Ue(
          He.basicOptionalSeconds,
          e
        );
      case "XXXXX":
        return Ue(
          He.extendedOptionalSeconds,
          e
        );
      case "XXX":
      default:
        return Ue(He.extended, e);
    }
  }
  set(e, n, r) {
    return n.timestampIsSet ? e : Pe(
      e,
      e.getTime() - Qr(e) - r
    );
  }
}
class La extends Y {
  constructor() {
    super(...arguments), A(this, "priority", 10), A(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(e, n) {
    switch (n) {
      case "x":
        return Ue(
          He.basicOptionalMinutes,
          e
        );
      case "xx":
        return Ue(He.basic, e);
      case "xxxx":
        return Ue(
          He.basicOptionalSeconds,
          e
        );
      case "xxxxx":
        return Ue(
          He.extendedOptionalSeconds,
          e
        );
      case "xxx":
      default:
        return Ue(He.extended, e);
    }
  }
  set(e, n, r) {
    return n.timestampIsSet ? e : Pe(
      e,
      e.getTime() - Qr(e) - r
    );
  }
}
class Fa extends Y {
  constructor() {
    super(...arguments), A(this, "priority", 40), A(this, "incompatibleTokens", "*");
  }
  parse(e) {
    return Yr(e);
  }
  set(e, n, r) {
    return [Pe(e, r * 1e3), { timestampIsSet: !0 }];
  }
}
class Ba extends Y {
  constructor() {
    super(...arguments), A(this, "priority", 20), A(this, "incompatibleTokens", "*");
  }
  parse(e) {
    return Yr(e);
  }
  set(e, n, r) {
    return [Pe(e, r), { timestampIsSet: !0 }];
  }
}
new oa(), new aa(), new ia(), new la(), new da(), new ca(), new ua(), new ma(), new pa(), new fa(), new va(), new ya(), new ja(), new ka(), new Ta(), new wa(), new Na(), new Sa(), new Oa(), new Pa(), new Ma(), new Ca(), new Ea(), new _a(), new Aa(), new Ra(), new Da(), new za(), new La(), new Fa(), new Ba();
function me(t) {
  return t % 1 !== 0 ? t.toFixed(2).replace(".", ",") : t.toString().replace(".", ",");
}
function Ha(t) {
  return t == null ? void 0 : t.toUpperCase().replace(/\s/g, "").replace(/(.{4})/g, "$1 ").trim();
}
const qr = (t, e) => {
  let n = !0;
  return t.length !== e.length ? n = !1 : t.forEach((r, o) => {
    const a = sn(r), i = sn(e[o]);
    a !== i ? n = !1 : a === "object" ? Qt(r, e[o]) || (n = !1) : a === "array" ? qr(r, e[o]) || (n = !1) : r !== e[o] && (n = !1);
  }), n;
}, Qt = (t, e) => {
  let n = !0;
  return Object.keys(t).length !== Object.keys(e).length ? n = !1 : Object.keys(t).forEach((r) => {
    const o = sn(t[r]), a = sn(e[r]);
    o !== a ? n = !1 : o === "object" ? Qt(t[r], e[r]) || (n = !1) : o === "array" ? qr(t[r], e[r]) || (n = !1) : e[r] !== t[r] && (n = !1);
  }), n;
}, sn = (t) => {
  const e = typeof t;
  if (e === "number")
    return isNaN(t) ? "NaN" : e;
  if (e === "object") {
    if (t instanceof Array)
      return "array";
    if (t instanceof Element)
      return "node";
    if (String(t == null ? void 0 : t.$$typeof) === "Symbol(react.element)")
      return "ReactNode";
    if (t === null)
      return "null";
  }
  return e;
};
var Ua = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
(function(t) {
  t();
})(function() {
  function t(p, x) {
    if (!(p instanceof x))
      throw new TypeError("Cannot call a class as a function");
  }
  function e(p, x) {
    for (var y = 0; y < x.length; y++) {
      var g = x[y];
      g.enumerable = g.enumerable || !1, g.configurable = !0, "value" in g && (g.writable = !0), Object.defineProperty(p, g.key, g);
    }
  }
  function n(p, x, y) {
    return x && e(p.prototype, x), y && e(p, y), Object.defineProperty(p, "prototype", {
      writable: !1
    }), p;
  }
  function r(p, x) {
    if (typeof x != "function" && x !== null)
      throw new TypeError("Super expression must either be null or a function");
    p.prototype = Object.create(x && x.prototype, {
      constructor: {
        value: p,
        writable: !0,
        configurable: !0
      }
    }), Object.defineProperty(p, "prototype", {
      writable: !1
    }), x && a(p, x);
  }
  function o(p) {
    return o = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(x) {
      return x.__proto__ || Object.getPrototypeOf(x);
    }, o(p);
  }
  function a(p, x) {
    return a = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(y, g) {
      return y.__proto__ = g, y;
    }, a(p, x);
  }
  function i() {
    if (typeof Reflect == "undefined" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch (p) {
      return !1;
    }
  }
  function l(p) {
    if (p === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return p;
  }
  function d(p, x) {
    if (x && (typeof x == "object" || typeof x == "function"))
      return x;
    if (x !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return l(p);
  }
  function c(p) {
    var x = i();
    return function() {
      var y = o(p), g;
      if (x) {
        var T = o(this).constructor;
        g = Reflect.construct(y, arguments, T);
      } else
        g = y.apply(this, arguments);
      return d(this, g);
    };
  }
  function u(p, x) {
    for (; !Object.prototype.hasOwnProperty.call(p, x) && (p = o(p), p !== null); )
      ;
    return p;
  }
  function m() {
    return typeof Reflect != "undefined" && Reflect.get ? m = Reflect.get.bind() : m = function(p, x, y) {
      var g = u(p, x);
      if (g) {
        var T = Object.getOwnPropertyDescriptor(g, x);
        return T.get ? T.get.call(arguments.length < 3 ? p : y) : T.value;
      }
    }, m.apply(this, arguments);
  }
  var v = /* @__PURE__ */ function() {
    function p() {
      t(this, p), Object.defineProperty(this, "listeners", {
        value: {},
        writable: !0,
        configurable: !0
      });
    }
    return n(p, [{
      key: "addEventListener",
      value: function(x, y, g) {
        x in this.listeners || (this.listeners[x] = []), this.listeners[x].push({
          callback: y,
          options: g
        });
      }
    }, {
      key: "removeEventListener",
      value: function(x, y) {
        if (x in this.listeners) {
          for (var g = this.listeners[x], T = 0, C = g.length; T < C; T++)
            if (g[T].callback === y) {
              g.splice(T, 1);
              return;
            }
        }
      }
    }, {
      key: "dispatchEvent",
      value: function(x) {
        if (x.type in this.listeners) {
          for (var y = this.listeners[x.type], g = y.slice(), T = 0, C = g.length; T < C; T++) {
            var _ = g[T];
            try {
              _.callback.call(this, x);
            } catch (z) {
              Promise.resolve().then(function() {
                throw z;
              });
            }
            _.options && _.options.once && this.removeEventListener(x.type, _.callback);
          }
          return !x.defaultPrevented;
        }
      }
    }]), p;
  }(), b = /* @__PURE__ */ function(p) {
    r(y, p);
    var x = c(y);
    function y() {
      var g;
      return t(this, y), g = x.call(this), g.listeners || v.call(l(g)), Object.defineProperty(l(g), "aborted", {
        value: !1,
        writable: !0,
        configurable: !0
      }), Object.defineProperty(l(g), "onabort", {
        value: null,
        writable: !0,
        configurable: !0
      }), Object.defineProperty(l(g), "reason", {
        value: void 0,
        writable: !0,
        configurable: !0
      }), g;
    }
    return n(y, [{
      key: "toString",
      value: function() {
        return "[object AbortSignal]";
      }
    }, {
      key: "dispatchEvent",
      value: function(g) {
        g.type === "abort" && (this.aborted = !0, typeof this.onabort == "function" && this.onabort.call(this, g)), m(o(y.prototype), "dispatchEvent", this).call(this, g);
      }
    }]), y;
  }(v), f = /* @__PURE__ */ function() {
    function p() {
      t(this, p), Object.defineProperty(this, "signal", {
        value: new b(),
        writable: !0,
        configurable: !0
      });
    }
    return n(p, [{
      key: "abort",
      value: function(x) {
        var y;
        try {
          y = new Event("abort");
        } catch (T) {
          typeof document != "undefined" ? document.createEvent ? (y = document.createEvent("Event"), y.initEvent("abort", !1, !1)) : (y = document.createEventObject(), y.type = "abort") : y = {
            type: "abort",
            bubbles: !1,
            cancelable: !1
          };
        }
        var g = x;
        if (g === void 0)
          if (typeof document == "undefined")
            g = new Error("This operation was aborted"), g.name = "AbortError";
          else
            try {
              g = new DOMException("signal is aborted without reason");
            } catch (T) {
              g = new Error("This operation was aborted"), g.name = "AbortError";
            }
        this.signal.reason = g, this.signal.dispatchEvent(y);
      }
    }, {
      key: "toString",
      value: function() {
        return "[object AbortController]";
      }
    }]), p;
  }();
  typeof Symbol != "undefined" && Symbol.toStringTag && (f.prototype[Symbol.toStringTag] = "AbortController", b.prototype[Symbol.toStringTag] = "AbortSignal");
  function k(p) {
    return p.__FORCE_INSTALL_ABORTCONTROLLER_POLYFILL ? (console.log("__FORCE_INSTALL_ABORTCONTROLLER_POLYFILL=true is set, will force install polyfill"), !0) : typeof p.Request == "function" && !p.Request.prototype.hasOwnProperty("signal") || !p.AbortController;
  }
  function h(p) {
    typeof p == "function" && (p = {
      fetch: p
    });
    var x = p, y = x.fetch, g = x.Request, T = g === void 0 ? y.Request : g, C = x.AbortController, _ = x.__FORCE_INSTALL_ABORTCONTROLLER_POLYFILL, z = _ === void 0 ? !1 : _;
    if (!k({
      fetch: y,
      Request: T,
      AbortController: C,
      __FORCE_INSTALL_ABORTCONTROLLER_POLYFILL: z
    }))
      return {
        fetch: y,
        Request: E
      };
    var E = T;
    (E && !E.prototype.hasOwnProperty("signal") || z) && (E = function(M, N) {
      var j;
      N && N.signal && (j = N.signal, delete N.signal);
      var U = new T(M, N);
      return j && Object.defineProperty(U, "signal", {
        writable: !1,
        enumerable: !1,
        configurable: !0,
        value: j
      }), U;
    }, E.prototype = T.prototype);
    var I = y, D = function(M, N) {
      var j = E && E.prototype.isPrototypeOf(M) ? M.signal : N ? N.signal : void 0;
      if (j) {
        var U;
        try {
          U = new DOMException("Aborted", "AbortError");
        } catch (Te) {
          U = new Error("Aborted"), U.name = "AbortError";
        }
        if (j.aborted)
          return Promise.reject(U);
        var xe = new Promise(function(Te, Ae) {
          j.addEventListener("abort", function() {
            return Ae(U);
          }, {
            once: !0
          });
        });
        return N && N.signal && delete N.signal, Promise.race([xe, I(M, N)]);
      }
      return I(M, N);
    };
    return {
      fetch: D,
      Request: E
    };
  }
  (function(p) {
    if (k(p)) {
      if (!p.fetch) {
        console.warn("fetch() is not available, cannot install abortcontroller-polyfill");
        return;
      }
      var x = h(p), y = x.fetch, g = x.Request;
      p.fetch = y, p.Request = g, Object.defineProperty(p, "AbortController", {
        writable: !0,
        enumerable: !1,
        configurable: !0,
        value: f
      }), Object.defineProperty(p, "AbortSignal", {
        writable: !0,
        enumerable: !1,
        configurable: !0,
        value: b
      });
    }
  })(typeof self != "undefined" ? self : Ua);
});
function $a(t, e) {
  let n = t;
  for (const r in e) {
    const o = r.replace(/^:|%3A/, ""), a = String(e[r]);
    n.includes(`%3A${o}`) ? n = n.replace(`%3A${o}`, encodeURIComponent(a)) : n = n.replace(`:${o}`, encodeURIComponent(a));
  }
  return n;
}
function Le(t) {
  for (var e = arguments.length, n = Array(e > 1 ? e - 1 : 0), r = 1; r < e; r++)
    n[r - 1] = arguments[r];
  throw Error("[Immer] minified error nr: " + t + (n.length ? " " + n.map(function(o) {
    return "'" + o + "'";
  }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function bt(t) {
  return !!t && !!t[re];
}
function yt(t) {
  var e;
  return !!t && (function(n) {
    if (!n || typeof n != "object")
      return !1;
    var r = Object.getPrototypeOf(n);
    if (r === null)
      return !0;
    var o = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
    return o === Object || typeof o == "function" && Function.toString.call(o) === qa;
  }(t) || Array.isArray(t) || !!t[kr] || !!(!((e = t.constructor) === null || e === void 0) && e[kr]) || Xn(t) || Kn(t));
}
function jt(t, e, n) {
  n === void 0 && (n = !1), zt(t) === 0 ? (n ? Object.keys : St)(t).forEach(function(r) {
    n && typeof r == "symbol" || e(r, t[r], t);
  }) : t.forEach(function(r, o) {
    return e(o, r, t);
  });
}
function zt(t) {
  var e = t[re];
  return e ? e.i > 3 ? e.i - 4 : e.i : Array.isArray(t) ? 1 : Xn(t) ? 2 : Kn(t) ? 3 : 0;
}
function Nt(t, e) {
  return zt(t) === 2 ? t.has(e) : Object.prototype.hasOwnProperty.call(t, e);
}
function Va(t, e) {
  return zt(t) === 2 ? t.get(e) : t[e];
}
function Jr(t, e, n) {
  var r = zt(t);
  r === 2 ? t.set(e, n) : r === 3 ? t.add(n) : t[e] = n;
}
function es(t, e) {
  return t === e ? t !== 0 || 1 / t == 1 / e : t != t && e != e;
}
function Xn(t) {
  return Xa && t instanceof Map;
}
function Kn(t) {
  return Ka && t instanceof Set;
}
function gt(t) {
  return t.o || t.t;
}
function qn(t) {
  if (Array.isArray(t))
    return Array.prototype.slice.call(t);
  var e = ns(t);
  delete e[re];
  for (var n = St(e), r = 0; r < n.length; r++) {
    var o = n[r], a = e[o];
    a.writable === !1 && (a.writable = !0, a.configurable = !0), (a.get || a.set) && (e[o] = { configurable: !0, writable: !0, enumerable: a.enumerable, value: t[o] });
  }
  return Object.create(Object.getPrototypeOf(t), e);
}
function Jn(t, e) {
  return e === void 0 && (e = !1), er(t) || bt(t) || !yt(t) || (zt(t) > 1 && (t.set = t.add = t.clear = t.delete = Ga), Object.freeze(t), e && jt(t, function(n, r) {
    return Jn(r, !0);
  }, !0)), t;
}
function Ga() {
  Le(2);
}
function er(t) {
  return t == null || typeof t != "object" || Object.isFrozen(t);
}
function We(t) {
  var e = Rn[t];
  return e || Le(18, t), e;
}
function Qa(t, e) {
  Rn[t] || (Rn[t] = e);
}
function En() {
  return Wt;
}
function yn(t, e) {
  e && (We("Patches"), t.u = [], t.s = [], t.v = e);
}
function on(t) {
  _n(t), t.p.forEach(Wa), t.p = null;
}
function _n(t) {
  t === Wt && (Wt = t.l);
}
function gr(t) {
  return Wt = { p: [], l: Wt, h: t, m: !0, _: 0 };
}
function Wa(t) {
  var e = t[re];
  e.i === 0 || e.i === 1 ? e.j() : e.g = !0;
}
function jn(t, e) {
  e._ = e.p.length;
  var n = e.p[0], r = t !== void 0 && t !== n;
  return e.h.O || We("ES5").S(e, t, r), r ? (n[re].P && (on(e), Le(4)), yt(t) && (t = an(e, t), e.l || ln(e, t)), e.u && We("Patches").M(n[re].t, t, e.u, e.s)) : t = an(e, n, []), on(e), e.u && e.v(e.u, e.s), t !== ts ? t : void 0;
}
function an(t, e, n) {
  if (er(e))
    return e;
  var r = e[re];
  if (!r)
    return jt(e, function(l, d) {
      return vr(t, r, e, l, d, n);
    }, !0), e;
  if (r.A !== t)
    return e;
  if (!r.P)
    return ln(t, r.t, !0), r.t;
  if (!r.I) {
    r.I = !0, r.A._--;
    var o = r.i === 4 || r.i === 5 ? r.o = qn(r.k) : r.o, a = o, i = !1;
    r.i === 3 && (a = new Set(o), o.clear(), i = !0), jt(a, function(l, d) {
      return vr(t, r, o, l, d, n, i);
    }), ln(t, o, !1), n && t.u && We("Patches").N(r, n, t.u, t.s);
  }
  return r.o;
}
function vr(t, e, n, r, o, a, i) {
  if (bt(o)) {
    var l = an(t, o, a && e && e.i !== 3 && !Nt(e.R, r) ? a.concat(r) : void 0);
    if (Jr(n, r, l), !bt(l))
      return;
    t.m = !1;
  } else
    i && n.add(o);
  if (yt(o) && !er(o)) {
    if (!t.h.D && t._ < 1)
      return;
    an(t, o), e && e.A.l || ln(t, o);
  }
}
function ln(t, e, n) {
  n === void 0 && (n = !1), !t.l && t.h.D && t.m && Jn(e, n);
}
function kn(t, e) {
  var n = t[re];
  return (n ? gt(n) : t)[e];
}
function xr(t, e) {
  if (e in t)
    for (var n = Object.getPrototypeOf(t); n; ) {
      var r = Object.getOwnPropertyDescriptor(n, e);
      if (r)
        return r;
      n = Object.getPrototypeOf(n);
    }
}
function it(t) {
  t.P || (t.P = !0, t.l && it(t.l));
}
function Tn(t) {
  t.o || (t.o = qn(t.t));
}
function An(t, e, n) {
  var r = Xn(e) ? We("MapSet").F(e, n) : Kn(e) ? We("MapSet").T(e, n) : t.O ? function(o, a) {
    var i = Array.isArray(o), l = { i: i ? 1 : 0, A: a ? a.A : En(), P: !1, I: !1, R: {}, l: a, t: o, k: null, o: null, j: null, C: !1 }, d = l, c = Yt;
    i && (d = [l], c = $t);
    var u = Proxy.revocable(d, c), m = u.revoke, v = u.proxy;
    return l.k = v, l.j = m, v;
  }(e, n) : We("ES5").J(e, n);
  return (n ? n.A : En()).p.push(r), r;
}
function Ya(t) {
  return bt(t) || Le(22, t), function e(n) {
    if (!yt(n))
      return n;
    var r, o = n[re], a = zt(n);
    if (o) {
      if (!o.P && (o.i < 4 || !We("ES5").K(o)))
        return o.t;
      o.I = !0, r = br(n, a), o.I = !1;
    } else
      r = br(n, a);
    return jt(r, function(i, l) {
      o && Va(o.t, i) === l || Jr(r, i, e(l));
    }), a === 3 ? new Set(r) : r;
  }(t);
}
function br(t, e) {
  switch (e) {
    case 2:
      return new Map(t);
    case 3:
      return Array.from(t);
  }
  return qn(t);
}
function Za() {
  function t(a, i) {
    var l = o[a];
    return l ? l.enumerable = i : o[a] = l = { configurable: !0, enumerable: i, get: function() {
      var d = this[re];
      return Yt.get(d, a);
    }, set: function(d) {
      var c = this[re];
      Yt.set(c, a, d);
    } }, l;
  }
  function e(a) {
    for (var i = a.length - 1; i >= 0; i--) {
      var l = a[i][re];
      if (!l.P)
        switch (l.i) {
          case 5:
            r(l) && it(l);
            break;
          case 4:
            n(l) && it(l);
        }
    }
  }
  function n(a) {
    for (var i = a.t, l = a.k, d = St(l), c = d.length - 1; c >= 0; c--) {
      var u = d[c];
      if (u !== re) {
        var m = i[u];
        if (m === void 0 && !Nt(i, u))
          return !0;
        var v = l[u], b = v && v[re];
        if (b ? b.t !== m : !es(v, m))
          return !0;
      }
    }
    var f = !!i[re];
    return d.length !== St(i).length + (f ? 0 : 1);
  }
  function r(a) {
    var i = a.k;
    if (i.length !== a.t.length)
      return !0;
    var l = Object.getOwnPropertyDescriptor(i, i.length - 1);
    if (l && !l.get)
      return !0;
    for (var d = 0; d < i.length; d++)
      if (!i.hasOwnProperty(d))
        return !0;
    return !1;
  }
  var o = {};
  Qa("ES5", { J: function(a, i) {
    var l = Array.isArray(a), d = function(u, m) {
      if (u) {
        for (var v = Array(m.length), b = 0; b < m.length; b++)
          Object.defineProperty(v, "" + b, t(b, !0));
        return v;
      }
      var f = ns(m);
      delete f[re];
      for (var k = St(f), h = 0; h < k.length; h++) {
        var p = k[h];
        f[p] = t(p, u || !!f[p].enumerable);
      }
      return Object.create(Object.getPrototypeOf(m), f);
    }(l, a), c = { i: l ? 5 : 4, A: i ? i.A : En(), P: !1, I: !1, R: {}, l: i, t: a, k: d, o: null, g: !1, C: !1 };
    return Object.defineProperty(d, re, { value: c, writable: !0 }), d;
  }, S: function(a, i, l) {
    l ? bt(i) && i[re].A === a && e(a.p) : (a.u && function d(c) {
      if (c && typeof c == "object") {
        var u = c[re];
        if (u) {
          var m = u.t, v = u.k, b = u.R, f = u.i;
          if (f === 4)
            jt(v, function(y) {
              y !== re && (m[y] !== void 0 || Nt(m, y) ? b[y] || d(v[y]) : (b[y] = !0, it(u)));
            }), jt(m, function(y) {
              v[y] !== void 0 || Nt(v, y) || (b[y] = !1, it(u));
            });
          else if (f === 5) {
            if (r(u) && (it(u), b.length = !0), v.length < m.length)
              for (var k = v.length; k < m.length; k++)
                b[k] = !1;
            else
              for (var h = m.length; h < v.length; h++)
                b[h] = !0;
            for (var p = Math.min(v.length, m.length), x = 0; x < p; x++)
              v.hasOwnProperty(x) || (b[x] = !0), b[x] === void 0 && d(v[x]);
          }
        }
      }
    }(a.p[0]), e(a.p));
  }, K: function(a) {
    return a.i === 4 ? n(a) : r(a);
  } });
}
var yr, Wt, tr = typeof Symbol != "undefined" && typeof Symbol("x") == "symbol", Xa = typeof Map != "undefined", Ka = typeof Set != "undefined", jr = typeof Proxy != "undefined" && Proxy.revocable !== void 0 && typeof Reflect != "undefined", ts = tr ? Symbol.for("immer-nothing") : ((yr = {})["immer-nothing"] = !0, yr), kr = tr ? Symbol.for("immer-draftable") : "__$immer_draftable", re = tr ? Symbol.for("immer-state") : "__$immer_state", qa = "" + Object.prototype.constructor, St = typeof Reflect != "undefined" && Reflect.ownKeys ? Reflect.ownKeys : Object.getOwnPropertySymbols !== void 0 ? function(t) {
  return Object.getOwnPropertyNames(t).concat(Object.getOwnPropertySymbols(t));
} : Object.getOwnPropertyNames, ns = Object.getOwnPropertyDescriptors || function(t) {
  var e = {};
  return St(t).forEach(function(n) {
    e[n] = Object.getOwnPropertyDescriptor(t, n);
  }), e;
}, Rn = {}, Yt = { get: function(t, e) {
  if (e === re)
    return t;
  var n = gt(t);
  if (!Nt(n, e))
    return function(o, a, i) {
      var l, d = xr(a, i);
      return d ? "value" in d ? d.value : (l = d.get) === null || l === void 0 ? void 0 : l.call(o.k) : void 0;
    }(t, n, e);
  var r = n[e];
  return t.I || !yt(r) ? r : r === kn(t.t, e) ? (Tn(t), t.o[e] = An(t.A.h, r, t)) : r;
}, has: function(t, e) {
  return e in gt(t);
}, ownKeys: function(t) {
  return Reflect.ownKeys(gt(t));
}, set: function(t, e, n) {
  var r = xr(gt(t), e);
  if (r != null && r.set)
    return r.set.call(t.k, n), !0;
  if (!t.P) {
    var o = kn(gt(t), e), a = o == null ? void 0 : o[re];
    if (a && a.t === n)
      return t.o[e] = n, t.R[e] = !1, !0;
    if (es(n, o) && (n !== void 0 || Nt(t.t, e)))
      return !0;
    Tn(t), it(t);
  }
  return t.o[e] === n && (n !== void 0 || e in t.o) || Number.isNaN(n) && Number.isNaN(t.o[e]) || (t.o[e] = n, t.R[e] = !0), !0;
}, deleteProperty: function(t, e) {
  return kn(t.t, e) !== void 0 || e in t.t ? (t.R[e] = !1, Tn(t), it(t)) : delete t.R[e], t.o && delete t.o[e], !0;
}, getOwnPropertyDescriptor: function(t, e) {
  var n = gt(t), r = Reflect.getOwnPropertyDescriptor(n, e);
  return r && { writable: !0, configurable: t.i !== 1 || e !== "length", enumerable: r.enumerable, value: n[e] };
}, defineProperty: function() {
  Le(11);
}, getPrototypeOf: function(t) {
  return Object.getPrototypeOf(t.t);
}, setPrototypeOf: function() {
  Le(12);
} }, $t = {};
jt(Yt, function(t, e) {
  $t[t] = function() {
    return arguments[0] = arguments[0][0], e.apply(this, arguments);
  };
}), $t.deleteProperty = function(t, e) {
  return $t.set.call(this, t, e, void 0);
}, $t.set = function(t, e, n) {
  return Yt.set.call(this, t[0], e, n, t[0]);
};
var Ja = function() {
  function t(n) {
    var r = this;
    this.O = jr, this.D = !0, this.produce = function(o, a, i) {
      if (typeof o == "function" && typeof a != "function") {
        var l = a;
        a = o;
        var d = r;
        return function(k) {
          var h = this;
          k === void 0 && (k = l);
          for (var p = arguments.length, x = Array(p > 1 ? p - 1 : 0), y = 1; y < p; y++)
            x[y - 1] = arguments[y];
          return d.produce(k, function(g) {
            var T;
            return (T = a).call.apply(T, [h, g].concat(x));
          });
        };
      }
      var c;
      if (typeof a != "function" && Le(6), i !== void 0 && typeof i != "function" && Le(7), yt(o)) {
        var u = gr(r), m = An(r, o, void 0), v = !0;
        try {
          c = a(m), v = !1;
        } finally {
          v ? on(u) : _n(u);
        }
        return typeof Promise != "undefined" && c instanceof Promise ? c.then(function(k) {
          return yn(u, i), jn(k, u);
        }, function(k) {
          throw on(u), k;
        }) : (yn(u, i), jn(c, u));
      }
      if (!o || typeof o != "object") {
        if ((c = a(o)) === void 0 && (c = o), c === ts && (c = void 0), r.D && Jn(c, !0), i) {
          var b = [], f = [];
          We("Patches").M(o, c, b, f), i(b, f);
        }
        return c;
      }
      Le(21, o);
    }, this.produceWithPatches = function(o, a) {
      if (typeof o == "function")
        return function(c) {
          for (var u = arguments.length, m = Array(u > 1 ? u - 1 : 0), v = 1; v < u; v++)
            m[v - 1] = arguments[v];
          return r.produceWithPatches(c, function(b) {
            return o.apply(void 0, [b].concat(m));
          });
        };
      var i, l, d = r.produce(o, a, function(c, u) {
        i = c, l = u;
      });
      return typeof Promise != "undefined" && d instanceof Promise ? d.then(function(c) {
        return [c, i, l];
      }) : [d, i, l];
    }, typeof (n == null ? void 0 : n.useProxies) == "boolean" && this.setUseProxies(n.useProxies), typeof (n == null ? void 0 : n.autoFreeze) == "boolean" && this.setAutoFreeze(n.autoFreeze);
  }
  var e = t.prototype;
  return e.createDraft = function(n) {
    yt(n) || Le(8), bt(n) && (n = Ya(n));
    var r = gr(this), o = An(this, n, void 0);
    return o[re].C = !0, _n(r), o;
  }, e.finishDraft = function(n, r) {
    var o = n && n[re], a = o.A;
    return yn(a, r), jn(void 0, a);
  }, e.setAutoFreeze = function(n) {
    this.D = n;
  }, e.setUseProxies = function(n) {
    n && !jr && Le(20), this.O = n;
  }, e.applyPatches = function(n, r) {
    var o;
    for (o = r.length - 1; o >= 0; o--) {
      var a = r[o];
      if (a.path.length === 0 && a.op === "replace") {
        n = a.value;
        break;
      }
    }
    o > -1 && (r = r.slice(o + 1));
    var i = We("Patches").$;
    return bt(n) ? i(n, r) : this.produce(n, function(l) {
      return i(l, r);
    });
  }, t;
}(), Ce = new Ja();
Ce.produce;
Ce.produceWithPatches.bind(Ce);
Ce.setAutoFreeze.bind(Ce);
Ce.setUseProxies.bind(Ce);
Ce.applyPatches.bind(Ce);
Ce.createDraft.bind(Ce);
Ce.finishDraft.bind(Ce);
var rs = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var a in o)
        Object.prototype.hasOwnProperty.call(o, a) && (r[a] = o[a]);
    }, t(e, n);
  };
  return function(e, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), ei = globalThis && globalThis.__generator || function(t, e) {
  var n = { label: 0, sent: function() {
    if (a[0] & 1)
      throw a[1];
    return a[1];
  }, trys: [], ops: [] }, r, o, a, i;
  return i = { next: l(0), throw: l(1), return: l(2) }, typeof Symbol == "function" && (i[Symbol.iterator] = function() {
    return this;
  }), i;
  function l(c) {
    return function(u) {
      return d([c, u]);
    };
  }
  function d(c) {
    if (r)
      throw new TypeError("Generator is already executing.");
    for (; n; )
      try {
        if (r = 1, o && (a = c[0] & 2 ? o.return : c[0] ? o.throw || ((a = o.return) && a.call(o), 0) : o.next) && !(a = a.call(o, c[1])).done)
          return a;
        switch (o = 0, a && (c = [c[0] & 2, a.value]), c[0]) {
          case 0:
          case 1:
            a = c;
            break;
          case 4:
            return n.label++, { value: c[1], done: !1 };
          case 5:
            n.label++, o = c[1], c = [0];
            continue;
          case 7:
            c = n.ops.pop(), n.trys.pop();
            continue;
          default:
            if (a = n.trys, !(a = a.length > 0 && a[a.length - 1]) && (c[0] === 6 || c[0] === 2)) {
              n = 0;
              continue;
            }
            if (c[0] === 3 && (!a || c[1] > a[0] && c[1] < a[3])) {
              n.label = c[1];
              break;
            }
            if (c[0] === 6 && n.label < a[1]) {
              n.label = a[1], a = c;
              break;
            }
            if (a && n.label < a[2]) {
              n.label = a[2], n.ops.push(c);
              break;
            }
            a[2] && n.ops.pop(), n.trys.pop();
            continue;
        }
        c = e.call(t, n);
      } catch (u) {
        c = [6, u], o = 0;
      } finally {
        r = a = 0;
      }
    if (c[0] & 5)
      throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
}, dn = globalThis && globalThis.__spreadArray || function(t, e) {
  for (var n = 0, r = e.length, o = t.length; n < r; n++, o++)
    t[o] = e[n];
  return t;
}, ti = Object.defineProperty, ni = Object.defineProperties, ri = Object.getOwnPropertyDescriptors, Tr = Object.getOwnPropertySymbols, si = Object.prototype.hasOwnProperty, oi = Object.prototype.propertyIsEnumerable, wr = function(t, e, n) {
  return e in t ? ti(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n;
}, Vt = function(t, e) {
  for (var n in e || (e = {}))
    si.call(e, n) && wr(t, n, e[n]);
  if (Tr)
    for (var r = 0, o = Tr(e); r < o.length; r++) {
      var n = o[r];
      oi.call(e, n) && wr(t, n, e[n]);
    }
  return t;
}, wn = function(t, e) {
  return ni(t, ri(e));
}, ai = function(t, e, n) {
  return new Promise(function(r, o) {
    var a = function(d) {
      try {
        l(n.next(d));
      } catch (c) {
        o(c);
      }
    }, i = function(d) {
      try {
        l(n.throw(d));
      } catch (c) {
        o(c);
      }
    }, l = function(d) {
      return d.done ? r(d.value) : Promise.resolve(d.value).then(a, i);
    };
    l((n = n.apply(t, e)).next());
  });
};
function Ot(t, e) {
  function n() {
    for (var r = [], o = 0; o < arguments.length; o++)
      r[o] = arguments[o];
    if (e) {
      var a = e.apply(void 0, r);
      if (!a)
        throw new Error("prepareAction did not return an object");
      return Vt(Vt({
        type: t,
        payload: a.payload
      }, "meta" in a && { meta: a.meta }), "error" in a && { error: a.error });
    }
    return { type: t, payload: r[0] };
  }
  return n.toString = function() {
    return "" + t;
  }, n.type = t, n.match = function(r) {
    return r.type === t;
  }, n;
}
(function(t) {
  rs(e, t);
  function e() {
    for (var n = [], r = 0; r < arguments.length; r++)
      n[r] = arguments[r];
    var o = t.apply(this, n) || this;
    return Object.setPrototypeOf(o, e.prototype), o;
  }
  return Object.defineProperty(e, Symbol.species, {
    get: function() {
      return e;
    },
    enumerable: !1,
    configurable: !0
  }), e.prototype.concat = function() {
    for (var n = [], r = 0; r < arguments.length; r++)
      n[r] = arguments[r];
    return t.prototype.concat.apply(this, n);
  }, e.prototype.prepend = function() {
    for (var n = [], r = 0; r < arguments.length; r++)
      n[r] = arguments[r];
    return n.length === 1 && Array.isArray(n[0]) ? new (e.bind.apply(e, dn([void 0], n[0].concat(this))))() : new (e.bind.apply(e, dn([void 0], n.concat(this))))();
  }, e;
})(Array);
(function(t) {
  rs(e, t);
  function e() {
    for (var n = [], r = 0; r < arguments.length; r++)
      n[r] = arguments[r];
    var o = t.apply(this, n) || this;
    return Object.setPrototypeOf(o, e.prototype), o;
  }
  return Object.defineProperty(e, Symbol.species, {
    get: function() {
      return e;
    },
    enumerable: !1,
    configurable: !0
  }), e.prototype.concat = function() {
    for (var n = [], r = 0; r < arguments.length; r++)
      n[r] = arguments[r];
    return t.prototype.concat.apply(this, n);
  }, e.prototype.prepend = function() {
    for (var n = [], r = 0; r < arguments.length; r++)
      n[r] = arguments[r];
    return n.length === 1 && Array.isArray(n[0]) ? new (e.bind.apply(e, dn([void 0], n[0].concat(this))))() : new (e.bind.apply(e, dn([void 0], n.concat(this))))();
  }, e;
})(Array);
var ii = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW", li = function(t) {
  t === void 0 && (t = 21);
  for (var e = "", n = t; n--; )
    e += ii[Math.random() * 64 | 0];
  return e;
}, di = [
  "name",
  "message",
  "stack",
  "code"
], In = (
  /** @class */
  function() {
    function t(e, n) {
      this.payload = e, this.meta = n;
    }
    return t;
  }()
), Ir = (
  /** @class */
  function() {
    function t(e, n) {
      this.payload = e, this.meta = n;
    }
    return t;
  }()
), ci = function(t) {
  if (typeof t == "object" && t !== null) {
    for (var e = {}, n = 0, r = di; n < r.length; n++) {
      var o = r[n];
      typeof t[o] == "string" && (e[o] = t[o]);
    }
    return e;
  }
  return { message: String(t) };
};
(function() {
  function t(e, n, r) {
    var o = Ot(e + "/fulfilled", function(c, u, m, v) {
      return {
        payload: c,
        meta: wn(Vt({}, v || {}), {
          arg: m,
          requestId: u,
          requestStatus: "fulfilled"
        })
      };
    }), a = Ot(e + "/pending", function(c, u, m) {
      return {
        payload: void 0,
        meta: wn(Vt({}, m || {}), {
          arg: u,
          requestId: c,
          requestStatus: "pending"
        })
      };
    }), i = Ot(e + "/rejected", function(c, u, m, v, b) {
      return {
        payload: v,
        error: (r && r.serializeError || ci)(c || "Rejected"),
        meta: wn(Vt({}, b || {}), {
          arg: m,
          requestId: u,
          rejectedWithValue: !!v,
          requestStatus: "rejected",
          aborted: (c == null ? void 0 : c.name) === "AbortError",
          condition: (c == null ? void 0 : c.name) === "ConditionError"
        })
      };
    }), l = typeof AbortController != "undefined" ? AbortController : (
      /** @class */
      function() {
        function c() {
          this.signal = {
            aborted: !1,
            addEventListener: function() {
            },
            dispatchEvent: function() {
              return !1;
            },
            onabort: function() {
            },
            removeEventListener: function() {
            },
            reason: void 0,
            throwIfAborted: function() {
            }
          };
        }
        return c.prototype.abort = function() {
        }, c;
      }()
    );
    function d(c) {
      return function(u, m, v) {
        var b = r != null && r.idGenerator ? r.idGenerator(c) : li(), f = new l(), k;
        function h(x) {
          k = x, f.abort();
        }
        var p = function() {
          return ai(this, null, function() {
            var x, y, g, T, C, _, z;
            return ei(this, function(E) {
              switch (E.label) {
                case 0:
                  return E.trys.push([0, 4, , 5]), T = (x = r == null ? void 0 : r.condition) == null ? void 0 : x.call(r, c, { getState: m, extra: v }), mi(T) ? [4, T] : [3, 2];
                case 1:
                  T = E.sent(), E.label = 2;
                case 2:
                  if (T === !1 || f.signal.aborted)
                    throw {
                      name: "ConditionError",
                      message: "Aborted due to condition callback returning false."
                    };
                  return C = new Promise(function(I, D) {
                    return f.signal.addEventListener("abort", function() {
                      return D({
                        name: "AbortError",
                        message: k || "Aborted"
                      });
                    });
                  }), u(a(b, c, (y = r == null ? void 0 : r.getPendingMeta) == null ? void 0 : y.call(r, { requestId: b, arg: c }, { getState: m, extra: v }))), [4, Promise.race([
                    C,
                    Promise.resolve(n(c, {
                      dispatch: u,
                      getState: m,
                      extra: v,
                      requestId: b,
                      signal: f.signal,
                      abort: h,
                      rejectWithValue: function(I, D) {
                        return new In(I, D);
                      },
                      fulfillWithValue: function(I, D) {
                        return new Ir(I, D);
                      }
                    })).then(function(I) {
                      if (I instanceof In)
                        throw I;
                      return I instanceof Ir ? o(I.payload, b, c, I.meta) : o(I, b, c);
                    })
                  ])];
                case 3:
                  return g = E.sent(), [3, 5];
                case 4:
                  return _ = E.sent(), g = _ instanceof In ? i(null, b, c, _.payload, _.meta) : i(_, b, c), [3, 5];
                case 5:
                  return z = r && !r.dispatchConditionRejection && i.match(g) && g.meta.condition, z || u(g), [2, g];
              }
            });
          });
        }();
        return Object.assign(p, {
          abort: h,
          requestId: b,
          arg: c,
          unwrap: function() {
            return p.then(ui);
          }
        });
      };
    }
    return Object.assign(d, {
      pending: a,
      rejected: i,
      fulfilled: o,
      typePrefix: e
    });
  }
  return t.withTypes = function() {
    return t;
  }, t;
})();
function ui(t) {
  if (t.meta && t.meta.rejectedWithValue)
    throw t.payload;
  if (t.error)
    throw t.error;
  return t.payload;
}
function mi(t) {
  return t !== null && typeof t == "object" && typeof t.then == "function";
}
var nr = "listenerMiddleware";
Ot(nr + "/add");
Ot(nr + "/removeAll");
Ot(nr + "/remove");
typeof queueMicrotask == "function" && queueMicrotask.bind(typeof window != "undefined" ? window : typeof global != "undefined" ? global : globalThis);
Za();
const pi = (t, e) => {
  const n = `${window.location.origin}${xo}`;
  return e ? `${n}${nn.O2TV}` : t ? `${n}${nn.DATAHOME}` : `${n}${nn.DEFAULT}`;
}, we = (t) => {
  var i, l, d;
  if (!((i = window == null ? void 0 : window.location) != null && i.href))
    return;
  function e() {
    return window.location.href.split(window.location.origin)[1];
  }
  function n() {
    return new URLSearchParams(window.location.search).get("utm_source") === "o2app" ? "app" : "web";
  }
  const r = e(), o = n();
  if (window.dataLayer = window.dataLayer || [], window.dataLayer.length && ((d = (l = window.dataLayer[window.dataLayer.length - 1]) == null ? void 0 : l.virtual_pageview_params) == null ? void 0 : d.path) === r)
    return;
  const a = H({
    event: "virtual_pageview",
    virtual_pageview_params: {
      path: r,
      affiliation: o
    }
  }, t && { ecommerce: t });
  window.dataLayer.push(a);
};
function Nn(t) {
  return t.replace(",", ".");
}
function wt({
  crossSellItem: t,
  index: e,
  userType: n,
  affiliation: r,
  isSetTopBox: o,
  parentAddonName: a
}) {
  function i(d, c) {
    return Object.prototype.hasOwnProperty.call(d, c);
  }
  let l = {};
  if (l = {
    item_name: t.name,
    item_id: t.skuId,
    item_sap: t.externalId,
    price: Nn(me(t.price)),
    item_down_payment: null,
    item_brand: t.ga_item_brand,
    item_category: t.ga_item_category,
    item_category2: t.ga_item_category2,
    quantity: "1",
    index: e.toString(),
    affiliation: r,
    item_user_type: n
  }, i(t, "oldPrice")) {
    const d = t.oldPrice || 0;
    d > t.price && (l = G(H({}, l), {
      discount: Nn(me(d - t.price))
    }));
  }
  return i(t, "chargePeriod") && t.chargePeriod === "MONTHLY" ? l = G(H({}, l), {
    item_monthly_payment: Nn(me(t.price))
  }) : l = G(H({}, l), {
    item_monthly_payment: null
  }), l = G(H({}, l), {
    item_list_id: o ? `cross_sell_${a == null ? void 0 : a.toLowerCase().replace(/\s/g, "")}` : "cross_sell"
  }), l = G(H({}, l), { item_list_name: o ? `Cross-sell (${a})` : "Cross-sell" }), l;
}
function hi(t, e) {
  return t ? `cross_sell_${e == null ? void 0 : e.toLowerCase().replace(/\s/g, "")}` : "cross_sell";
}
function fi(t, e) {
  return t ? `Cross-sell (${e})` : "Cross-sell";
}
function gi(t) {
  let e = 0;
  const { programs: n = [], devices: r = [], addons: o = [] } = t, a = n.map((c) => wt({
    crossSellItem: c,
    index: e++,
    userType: t.user_type,
    affiliation: t.affiliation,
    isSetTopBox: !1
  })), i = r.map((c) => wt({
    crossSellItem: c,
    index: e++,
    userType: t.user_type,
    affiliation: t.affiliation,
    isSetTopBox: !1
  })), l = [];
  o.forEach((c) => {
    var v;
    l.push(
      wt({
        crossSellItem: c,
        index: e++,
        userType: t.user_type,
        affiliation: t.affiliation,
        isSetTopBox: !1
      })
    );
    const u = c.checked, m = c.settopbox && c.settopbox.length;
    u && m && ((v = c.settopbox) == null || v.forEach((b) => {
      const f = wt({
        crossSellItem: b,
        index: e++,
        userType: t.user_type,
        affiliation: t.affiliation,
        isSetTopBox: !0,
        parentAddonName: c.name
      });
      l.push(f);
    }));
  });
  const d = [...a, ...i, ...l];
  return {
    item_list_id: "cross-sell",
    item_list_name: "Cross-sell",
    affiliation: t.affiliation,
    currency: "EUR",
    user_type: t.user_type,
    items: d
  };
}
function ss(t, e, n) {
  const r = !!n, o = wt({
    crossSellItem: t,
    index: 0,
    userType: e.user_type,
    affiliation: e.affiliation,
    isSetTopBox: r,
    parentAddonName: n
  });
  return {
    item_list_id: hi(r, n),
    item_list_name: fi(r, n),
    affiliation: e.affiliation,
    currency: "EUR",
    user_type: e.user_type,
    items: [o]
  };
}
function vi({
  settopboxes: t,
  parentAddonName: e,
  affiliation: n,
  userType: r
}) {
  return {
    item_list_id: `cross-sell-${e.toLowerCase().replace(/\s/g, "")}`,
    item_list_name: `Cross-sell (${e})`,
    affiliation: n,
    currency: "EUR",
    user_type: r,
    items: t.map((o) => wt({
      crossSellItem: o,
      index: 0,
      userType: r,
      affiliation: n,
      isSetTopBox: !0,
      parentAddonName: e
    }))
  };
}
function os({
  crossSell: t,
  addon: e
}) {
  var r;
  window.dataLayer = window.dataLayer || [];
  const n = {
    event: "view_item_list",
    ecommerce: (r = e == null ? void 0 : e.settopbox) != null && r.length ? vi({
      settopboxes: e.settopbox,
      parentAddonName: e.name,
      affiliation: t.affiliation,
      userType: t.user_type
    }) : gi(t)
  };
  window.dataLayer.push(n);
}
function Zt(t, e, n) {
  window.dataLayer = window.dataLayer || [];
  const r = {
    event: "add_to_cart",
    ecommerce: ss(t, e, n)
  };
  window.dataLayer.push(r);
}
function xi(t, e) {
  window.dataLayer = window.dataLayer || [];
  const n = {
    event: "remove_from_cart",
    ecommerce: ss(t, e)
  };
  window.dataLayer.push(n);
}
const gn = (t) => t ? t.includes("/") ? window.location.origin + t : `${window.location.origin}/delegate/web-content?sid=2355222&tag=${t}` : "";
function bi(t, e) {
  if (is(t) <= e)
    return JSON.parse(JSON.stringify(t));
  const n = [];
  let r = e;
  for (const o of t)
    if (r - o.amount > 0)
      r -= o.amount, n.push(JSON.parse(JSON.stringify(o)));
    else {
      const a = JSON.parse(JSON.stringify(o));
      a.amount = r, n.push(a), r = 0;
    }
  return n;
}
function as(t) {
  return t.reduce((e, n) => n.oneTimePriceOverride ? e + n.oneTimePriceOverride : e + n.oneTimePrice, 0);
}
function is(t) {
  return t.reduce((e, n) => e + n.amount, 0);
}
function yi(t, e, n) {
  const r = as(t.hwDevices) - is(t.availableBonuses) * t.installmentCount;
  if (r < t.minimalAdvancePayment)
    return n.hint1;
  if (t.minimalAdvancePayment < t.defaultAdvancePayment && t.defaultAdvancePayment < r) {
    if (e >= t.minimalAdvancePayment && e < t.defaultAdvancePayment)
      return n.hint2;
    if (t.defaultAdvancePayment === e)
      return n.hint3;
    if (t.defaultAdvancePayment < e && e < r)
      return n.hint4;
    if (r === e)
      return n.hint5;
    if (r < e && e <= t.maximalAdvancePayment)
      return n.hint6;
  } else if (t.minimalAdvancePayment <= t.defaultAdvancePayment && t.defaultAdvancePayment === r) {
    if (t.minimalAdvancePayment <= e && e < t.defaultAdvancePayment)
      return n.hint2;
    if (e === t.defaultAdvancePayment)
      return n.hint7;
    if (t.defaultAdvancePayment < e && e <= t.maximalAdvancePayment)
      return n.hint6;
  } else if (t.minimalAdvancePayment === t.defaultAdvancePayment && t.defaultAdvancePayment < r) {
    if (e === t.defaultAdvancePayment)
      return n.hint3;
    if (t.defaultAdvancePayment < e && e < r)
      return n.hint4;
    if (r === e)
      return n.hint5;
    if (r < e && e <= t.maximalAdvancePayment)
      return n.hint6;
  } else if (t.minimalAdvancePayment <= r && r < t.defaultAdvancePayment) {
    if (t.minimalAdvancePayment <= e && e < r)
      return n.hint2;
    if (e === r)
      return n.hint8;
    if (r < e && e < t.defaultAdvancePayment)
      return n.hint9;
    if (e === t.defaultAdvancePayment)
      return n.hint10;
    if (t.defaultAdvancePayment < e && e <= t.maximalAdvancePayment)
      return n.hint1;
  }
  return "";
}
function Dn(t, e) {
  var n;
  return ((n = t == null ? void 0 : t.wrongPortInValues) != null ? n : []).includes((e == null ? void 0 : e.donorCode) + "|" + (e == null ? void 0 : e.donorServiceId));
}
function Ie(t, e, n, r) {
  if (e)
    return e === q.LR_CART ? t(q.CART) : window.liferayRedirect(e);
  if (n)
    return Co.includes(n) ? t(q[n], r) : window.liferayRedirect(n);
}
function ji(t) {
  if (t.includes("location=")) {
    const e = t.split("location=")[1].split("&")[0], n = e.replaceAll("/", "%252F").replaceAll("+", "%252B").replaceAll("=", "%253D");
    return t.replace("location=" + e, "location=" + n);
  }
  return t;
}
const ki = (t) => {
  if (t === void 0)
    return;
  const e = t.indexOf("<section_");
  return e === -1 ? t : t.substring(0, e);
}, Ft = (t, e) => {
  if (!t)
    return;
  const n = "<" + e + ">[\\s\\S]*</" + e + ">", r = t.match(new RegExp(n));
  if (Array.isArray(r) && r.length > 0)
    return r[0].substring(e.length + 2, r[0].length - e.length - 3);
};
var at = /* @__PURE__ */ ((t) => (t.IGNORE = "IGNORE", t.REPLACE = "REPLACE", t.REPLACE_ALL_GROUPS = "REPLACE_ALL_GROUPS", t))(at || {}), Xe = /* @__PURE__ */ ((t) => (t.CASH = "CASH", t.O2_MOBIL = "O2_MOBIL", t))(Xe || {}), lt = /* @__PURE__ */ ((t) => (t.NEW_SIM = "NEW_SIM", t.EXISTING_SIM = "EXISTING_SIM", t))(lt || {}), X = /* @__PURE__ */ ((t) => (t.CHANGE = "CHANGE", t.EXISTING = "EXISTING", t.ACTIVATION = "ACTIVATION", t.PORTIN = "PORTIN", t))(X || {});
const ls = (t) => {
  var n, r, o;
  const e = {
    contextTariff: void 0,
    contextHw: void 0,
    installationType: void 0,
    portinMsisdn: void 0,
    paymentMethod: void 0,
    operation: void 0,
    transaction: void 0,
    promoCode: void 0,
    hwInsurances: void 0,
    portinBuyOut: void 0,
    takeoverPin: void 0,
    location: void 0,
    campaignId: void 0,
    skipTransaction: void 0,
    ftthPortation: void 0,
    utmSource: void 0,
    futureLocation: void 0
  };
  if (t.has("contextTariff") && (e.contextTariff = { seoId: t.get("contextTariff") }), t.has("contextHw") && (e.contextHw = { seoIds: t.getAll("contextHw") }), t.has("installationType") && (e.installationType = t.get("installationType")), t.has("location") && (e.location = t.get("location")), t.has("paymentMethod")) {
    const a = (n = t.get("paymentMethod")) == null ? void 0 : n.toUpperCase();
    a === "CASH" ? e.paymentMethod = Xe.CASH : (a === "O2MOBIL" || a === "O2_MOBIL") && (e.paymentMethod = Xe.O2_MOBIL);
  }
  if (t.has("promoCode") && (e.promoCode = t.get("promoCode")), t.has("hwInsurance") && (e.hwInsurances = t.getAll("hwInsurance")), t.has("portinBuyOut") && (e.portinBuyOut = t.get("portinBuyOut")), t.has("takeoverPin") && (e.takeoverPin = t.get("takeoverPin")), t.has("transaction") && (e.transaction = X[(r = t.get("transaction")) == null ? void 0 : r.toUpperCase()]), t.has("operation")) {
    const a = (o = t.get("operation")) == null ? void 0 : o.toUpperCase();
    a === "NEWSIM" || a === "NEW_SIM" ? e.operation = lt.NEW_SIM : (a === "EXISTINGSIM" || a === "EXISTING_SIM") && (e.operation = lt.EXISTING_SIM);
  }
  return t.has("portinBuyOut") && (e.portinBuyOut = t.get("portinBuyOut")), t.has("campaignId") && (e.campaignId = t.get("campaignId")), t.has("skipTransaction") && (t.get("skipTransaction") ? e.skipTransaction = t.get("skipTransaction") : e.skipTransaction = "true"), t.has("testSession") && (e.testSession = t.get("testSession") === "true"), t.has("testArea") && (e.testArea = t.get("testArea")), t.has("FTTH_PORTATION") && (e.ftthPortation = t.get("FTTH_PORTATION") === "true"), t.has("EIC_CODE") && (e.eicCode = t.get("EIC_CODE")), t.has("utm_source") && (e.utmSource = t.get("utm_source")), t.has("futureLocation") && t.get("futureLocation") === "true" && (e.futureLocation = !0), e;
}, Ti = (t, e) => G(H({}, t), {
  installationType: e
}), wi = (t, e) => G(H({}, t), {
  ownDeviceSerialNumber: e
}), Ii = (t, e, n) => {
  var i;
  const o = ((l) => {
    var c;
    const d = e == null ? void 0 : e.map(({ seoId: u }) => u);
    return ((c = l == null ? void 0 : l.seoIds) == null ? void 0 : c.filter((u) => !(d != null && d.includes(u)))) || [];
  })(t == null ? void 0 : t.contextHw);
  return G(H({}, t), {
    contextHw: {
      seoIds: [...o, n],
      quoteGroupId: (i = t == null ? void 0 : t.contextHw) == null ? void 0 : i.quoteGroupId
    }
  });
}, ds = (t, e, n) => {
  var i;
  const o = ((l) => {
    var c;
    const d = e == null ? void 0 : e.map(({ seoId: u }) => u);
    return ((c = l == null ? void 0 : l.seoIds) == null ? void 0 : c.filter((u) => !(d != null && d.includes(u)))) || [];
  })(t == null ? void 0 : t.contextHw);
  return G(H({}, t), {
    contextHw: {
      seoIds: [...o, ...n],
      quoteGroupId: (i = t == null ? void 0 : t.contextHw) == null ? void 0 : i.quoteGroupId
    }
  });
}, Nr = (t, e) => {
  if (t && t !== "DEFAULT") {
    const n = localStorage.getItem("stateQuotes"), r = n ? JSON.parse(n) : {};
    r[t] = e, localStorage.setItem("stateQuotes", JSON.stringify(r));
  }
}, Ni = (t) => {
  if (t && t !== "DEFAULT") {
    const e = localStorage.getItem("stateQuotes");
    return (e ? JSON.parse(e) : {})[t];
  } else
    return;
}, Sr = () => {
  localStorage.removeItem("stateQuotes");
}, cs = (t) => {
  const e = Object.entries(q).map(([r, o]) => [o, r]);
  return Object.fromEntries(e)[t];
}, Si = (t) => ({
  msisdn: t.msisdn,
  fee: t.isGold ? "O4:POP:OCC:GOLD_NUMBER" : "O4:POP:OCC:SEL_NUMBER",
  pattern: "",
  pun: "",
  type: t.isGold ? "GOLD" : "SILVER"
}), us = (t) => t && t.length === 10 ? `${t.slice(0, 4)} ${t.slice(4, 7)} ${t.slice(7, 10)}` : t != null ? t : "", cn = (t) => {
  var e;
  return (e = t == null ? void 0 : t.replaceAll(" ", "")) != null ? e : "";
}, ms = (t) => t ? t.includes(".") ? me(parseFloat(t)) : t.includes(",") ? me(parseFloat(t.replace(",", "."))) : t.match(/\d/g).join("") : "", Oi = (t) => {
  const e = t.hardwareType === "old" ? "OLD" : "MODERN";
  let n;
  return t.hardwareType === "old" && (n = t.tvBoxes.filter((r) => r.amount > 0).map((r) => ({
    seoId: r.seoId,
    amount: r.amount
  }))), {
    setTopBoxType: e,
    setTopBoxHardware: n
  };
}, Pi = () => {
  const t = je(), e = Hn(), [n, r] = w(), [o, a] = w(!1), i = $(() => e.pathname !== "/", [e.pathname]), [l] = mn(), d = J(() => {
    const b = localStorage.getItem("quote");
    r(b ? JSON.parse(b) : void 0);
  }, []), c = J(
    (b) => {
      const f = ["cartOnly", "errorModalText"], k = f.some((p) => b.has(p));
      let h = "";
      if (k) {
        const p = new URLSearchParams();
        f.forEach((x) => {
          b.has(x) && p.append(x, b.get(x));
        }), h = `${e.pathname}?${p.toString()}`;
      } else
        h = e.pathname;
      return h;
    },
    [e.pathname]
  ), u = J(() => {
    var f, k;
    const b = ls(l);
    r(b), localStorage.setItem("quote", JSON.stringify(b)), (f = b.contextTariff) != null && f.seoId && localStorage.setItem("selectedTariff", JSON.stringify({ seoId: (k = b.contextTariff) == null ? void 0 : k.seoId })), t(c(l), { replace: !0 });
  }, [c, t, l]), m = J(() => {
    localStorage.removeItem("quote"), Sr(), localStorage.removeItem("selectedTariff"), r(void 0);
  }, []), v = J((b, f) => {
    r((k) => {
      var p;
      const h = H(H({}, k), b);
      return localStorage.setItem("quote", JSON.stringify(h)), (p = h.contextTariff) != null && p.seoId && localStorage.setItem("selectedTariff", JSON.stringify({ seoId: h.contextTariff.seoId })), k && h && Qt(k, h) ? (f == null || f(k), k) : (f == null || f(h), h);
    });
  }, []);
  return S(() => {
    if (!o)
      Sr(), i ? d() : l.toString() ? u() : m(), a(!0);
    else {
      const b = Ni(cs(e.pathname));
      b && r((f) => f && Qt(b, f) ? f : b);
    }
  }, [m, o, d, u, l, i, e.pathname]), { quote: n, initialized: o, setQuote: v };
}, ke = () => {
  const { quote: t, setQuote: e } = P(ne), n = Hn(), [r] = mn(), [o, a] = w({
    groupId: void 0,
    quoteAction: void 0
  }), [i, l] = w(!1), {
    config: { nextStateUrl: d }
  } = P(K), [c, u] = w(null), m = (p) => {
    const x = Object.keys(p).reduce(function(y, g) {
      return p[g] !== void 0 ? G(H({}, y), { [g]: p[g] }) : y;
    }, {});
    return p.quoteAction || p.groupId || p.reasonCode || p.cartOnly || p.errorModalText ? "?" + new URLSearchParams(x).toString() : "";
  }, {
    data: v,
    loading: b,
    error: f,
    fetcher: k
  } = ve(d, {
    method: "POST",
    manual: !0
  });
  S(() => {
    u((p) => JSON.stringify(p) === JSON.stringify(f) ? p : f);
  }, [f]), S(() => {
    if (i) {
      const p = Object.entries(q).map(([g, T]) => [T, g]), y = {
        currentPage: Object.fromEntries(p)[n.pathname],
        referrer: document.referrer,
        nextPage: void 0,
        redirectUrl: void 0,
        contextQuote: t,
        checkSkuCanBeLost: !!o.checkSkuCanBeLost
      };
      Nr(cs(n.pathname), t), k(y, void 0, m(o)), l(!1);
    }
  }, [i, o, n.pathname, t, k]);
  const h = J(
    (p, x, y, g) => {
      const T = r.has("cartOnly") ? !!r.get("cartOnly") : void 0, C = r.has("errorModalText") ? r.get("errorModalText") : void 0;
      a({
        quoteAction: p,
        groupId: x,
        reasonCode: y,
        checkSkuCanBeLost: g,
        cartOnly: T,
        errorModalText: C
      }), l(!0);
    },
    [r]
  );
  return S(() => {
    v && (Nr(v.nextPage, v.contextQuote), e(v.contextQuote));
  }, [v, e]), {
    getNextState: h,
    loading: b,
    nextPage: v == null ? void 0 : v.nextPage,
    redirectUrl: v == null ? void 0 : v.redirectUrl,
    error: c,
    setError: u
  };
}, Mi = () => (S(() => {
  history.pushState(null, "", `${window.location.pathname}#${q.HW_SLIDER}`), window.location.href = `${window.location.origin}${q.LR_CART}`;
}, []), /* @__PURE__ */ s.jsx(s.Fragment, {})), Ci = ({ addon: t, eyeCatcher: e, eyeCatcherColor: n, withDivider: r }) => {
  const { unionText: o, withParams: a } = O(), { addonsMessages: i } = o;
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsxs("article", { className: "cross-sell__product", children: [
      /* @__PURE__ */ s.jsxs("div", { className: "d-flex gap-3 fw-bold", children: [
        /* @__PURE__ */ s.jsx("div", { className: "product__name", children: t.name }),
        t.monthlyPrice && /* @__PURE__ */ s.jsx("div", { className: "product__price", children: a(i.monthlyPrice, { price: me(t.monthlyPrice) }) })
      ] }),
      (e || !!t.oldPrice) && /* @__PURE__ */ s.jsxs("div", { className: "d-flex gap-3 fw-bold", children: [
        /* @__PURE__ */ s.jsx("div", { className: "product__name mt-1", children: e && /* @__PURE__ */ s.jsx(Lr, { color: n, children: e }) }),
        !!t.oldPrice && /* @__PURE__ */ s.jsx("span", { className: "product__old-price text-small mt-1", children: a(i.monthlyPrice, { price: me(t.oldPrice) }) })
      ] })
    ] }),
    r && /* @__PURE__ */ s.jsx("hr", { className: "my-2" })
  ] });
}, Ei = ({ onRef: t }) => {
  const { unionText: e } = O(), { buyOutMessages: n } = e;
  return /* @__PURE__ */ s.jsx(
    Ye,
    {
      id: "modal-choose-transaction-info",
      "data-testid": "modal-choose-transaction-info",
      size: "small",
      heading: n.detailsModal.title,
      onRef: t,
      children: /* @__PURE__ */ s.jsx("ol", { className: "ol", children: n.detailsModal.items.map((r, o) => /* @__PURE__ */ s.jsx("li", { className: "text-secondary", dangerouslySetInnerHTML: { __html: r } }, `detail-${o}`)) })
    }
  );
}, _i = ({ onRef: t, device: e }) => /* @__PURE__ */ s.jsxs(
  Ye,
  {
    id: `modal-${e.seoId}`,
    "data-testid": `modal-${e.seoId}`,
    size: "small",
    className: "fw-normal",
    heading: e.moreHeading || "",
    onRef: t,
    children: [
      e.moreBody && /* @__PURE__ */ s.jsx("p", { className: "text-secondary mb-4", children: e.moreBody }),
      e.moreHint && /* @__PURE__ */ s.jsx(
        xt,
        {
          background: "blue-light",
          className: "info-box",
          heading: "",
          "data-o2-id": "device-more-box-" + e.seoId,
          "data-testid": "device-more-box-" + e.seoId,
          children: /* @__PURE__ */ s.jsx("div", { dangerouslySetInnerHTML: { __html: e.moreHint } })
        }
      )
    ]
  }
), Or = 5, Pr = 30, Ai = () => {
  const { config: t } = P(K), { onManuallyAddedItem: e } = P(Dt), { unionText: n, withParams: r } = O(), o = be(null), {
    data: a,
    fetcher: i,
    error: l,
    loading: d
  } = ve(t.crossSellScanUrl, {
    manual: !0,
    method: "POST"
  }), c = (m) => {
    const v = m.trim();
    if (v.length < Or)
      return r(n.errorMessages.MIN_LENGTH, { length: Or.toString() });
    if (v.length > Pr)
      return r(n.errorMessages.MAX_LENGTH, { length: Pr.toString() });
    if (!/^[A-Za-z0-9/]+$/.test(v))
      return n.errorMessages.QUERY_INVALID;
  }, u = (m) => {
    i({ materialEanSn: m.materialEanSnInput });
  };
  return S(() => {
    var m;
    a && (e(a), (m = o.current) == null || m.resetForm());
  }, [a, e]), S(() => {
    var m, v;
    if ((m = l == null ? void 0 : l.validationResults) != null && m.length) {
      const b = l.validationResults[0].reasonCode, f = Mn[b];
      (v = o.current) == null || v.setFieldError("materialEanSnInput", f || Mn.DEFAULT_MESSAGE);
    }
  }, [l == null ? void 0 : l.validationResults]), S(() => {
  }, [l]), /* @__PURE__ */ s.jsx(te, { children: /* @__PURE__ */ s.jsx(W, { children: /* @__PURE__ */ s.jsx(F, { span: { base: 12, md: 8, lg: 6 }, offset: { base: 0, md: 2, lg: 3 }, children: /* @__PURE__ */ s.jsx(Tt, { innerRef: o, initialValues: { materialEanSnInput: "" }, onSubmit: u, children: ({ isValid: m }) => /* @__PURE__ */ s.jsx(
    Rr,
    {
      id: "cross-sell-add-material-form",
      name: "cross-sell-add-material-form",
      "data-testid": "cross-sell-add-material-form",
      children: /* @__PURE__ */ s.jsxs(B, { gap: 3, mt: 2, mb: 4, children: [
        /* @__PURE__ */ s.jsx(
          Pt,
          {
            as: vt,
            flexGrow: 1,
            fs: "body1",
            name: "materialEanSnInput",
            placeholder: n.crossSellMessages.searchPlaceholder,
            description: n.crossSellMessages.searchDescription,
            className: "cross-sell__add-material",
            "data-testid": "material-ean-sn-input",
            "aria-label": "material ean serial number input",
            leadingIcon: d ? "loading" : "search",
            validate: c
          }
        ),
        /* @__PURE__ */ s.jsx(
          ie,
          {
            "aria-label": n.crossSellMessages.searchAria,
            type: "submit",
            "data-testid": "add-material-button",
            disabled: d || !m,
            children: n.crossSellMessages.search
          }
        )
      ] })
    }
  ) }) }) }) });
}, Ri = ({ addon: t, onAddonAddedViaModal: e }) => {
  const n = et(), { unionText: r } = O(), [o, a] = w(), i = gn(t.tooltipArticle), l = () => {
    o == null || o.open();
  }, d = () => {
    // istanbul ignore else -- @preserve
    e && e(t), o == null || o.close();
  };
  return t.tooltipArticle ? /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsx(
      On,
      {
        "data-testid": "addon-tooltip-button",
        "aria-label": `${r.crossSellMessages.addonDetails} ${t.name}`,
        usage: "ghost",
        style: { height: 20, minHeight: 20 },
        variant: "primary",
        onPress: l,
        children: /* @__PURE__ */ s.jsx(pt, { color: "blue-brand" })
      }
    ),
    /* @__PURE__ */ s.jsxs(Je, { heading: t.name, size: "medium", "data-testid": "addon-detail", getController: a, children: [
      t.tooltipArticle && /* @__PURE__ */ s.jsx(kt, { url: i }),
      /* @__PURE__ */ s.jsx(
        ie,
        {
          slot: "primary",
          "data-testid": "addAddonToCartButton",
          "aria-label": r.crossSellMessages.addToCart,
          onPress: d,
          fullwidth: n,
          disabled: t.checked,
          children: r.crossSellMessages.addToCart
        }
      )
    ] })
  ] }) : null;
}, ps = ({ oldPrice: t, hasOffset: e }) => {
  const { withParams: n } = O();
  return t === void 0 ? null : /* @__PURE__ */ s.jsx(L, { as: "span", fs: "body1", c: "gray-medium", ms: e ? 2 : 0, style: { textDecoration: "line-through" }, children: n(Qe.oneTimePrice, { price: me(t) }) });
}, rr = ({ price: t, chargePeriod: e, biggerFont: n }) => {
  const { unionText: r, withParams: o } = O();
  return /* @__PURE__ */ s.jsxs(L, { as: "span", fs: "body1-strong", c: "blue-brand", style: n ? { fontSize: 24 } : void 0, children: [
    t !== void 0 && o(Qe.oneTimePrice, { price: me(t) }),
    e && r.chargePeriodMessages[e]
  ] });
}, Di = () => /* @__PURE__ */ s.jsx(B, { justify: "center", alignItems: "center", mb: 1, children: /* @__PURE__ */ s.jsx(L, { as: "span", fs: "notes-strong", c: "green", "data-testid": "items-added-text", children: " " }) }), vn = ({ itemsInCart: t }) => {
  const { unionText: e } = O();
  return t > 0 ? /* @__PURE__ */ s.jsxs(B, { justify: "center", alignItems: "center", mb: 1, children: [
    /* @__PURE__ */ s.jsx(zs, { me: 2, size: 16, c: "green" }),
    /* @__PURE__ */ s.jsxs(L, { as: "span", fs: "notes-strong", c: "green", "data-testid": "items-added-text", children: [
      e.crossSellMessages.added,
      ": ",
      t
    ] })
  ] }) : /* @__PURE__ */ s.jsx(Di, {});
}, zi = ({
  setTopBox: t,
  handleAddToCart: e,
  modalControls: n,
  setModalController: r
}) => {
  const { unionText: o } = O(), a = gn(t.tooltipArticle), i = () => {
    e(), n == null || n.close();
  };
  return /* @__PURE__ */ s.jsxs(Je, { "data-testid": "set-top-box-tooltip-modal", getController: r, size: "large", children: [
    t.tooltipArticle && /* @__PURE__ */ s.jsx(kt, { mt: { base: 0, sm: 5 }, url: a }),
    /* @__PURE__ */ s.jsx(
      ie,
      {
        role: "button",
        "aria-label": o.crossSellMessages.addToCart,
        "data-testid": "add-set-top-box-to-cart-button",
        slot: "primary",
        onPress: i,
        children: o.crossSellMessages.addToCart
      }
    )
  ] });
}, Mr = ({ setTopBox: t, addonName: e, changeAddonLoading: n, onSetTopBoxAdd: r }) => {
  const [o, a] = w(), { unionText: i, withParams: l } = O(), d = et(), c = 24, u = () => {
    o == null || o.open();
  }, m = () => {
    r == null || r(t, e);
  };
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsxs(
      B,
      {
        "data-testid": `cross-sell-settopbox__${t.seoId}`,
        "data-o2-id": `cross-sell-settopbox__${t.seoId}`,
        mt: 3,
        direction: d ? "column" : "row",
        style: { width: d ? 300 : "auto", border: "1px solid #CBD5E1", borderRadius: 5 },
        children: [
          /* @__PURE__ */ s.jsxs(
            L,
            G(H({
              w: d ? "auto" : 50,
              style: { position: "relative", overflow: "hidden", height: 172 },
              "data-testid": "open-settopbox-detail-top-button",
              "aria-label": i.crossSellMessages.openSetTopBoxDetail,
              tabIndex: 0
            }, t.stbArticle && { onClick: u, role: "button" }), {
              children: [
                t.image && /* @__PURE__ */ s.jsx(B, { justify: "center", p: 3, pt: 4, h: 100, children: /* @__PURE__ */ s.jsx(Et, { style: { objectFit: "contain" }, src: t.image.url, alt: t.name, skipWebp: !0 }) }),
                t.stbArticle && /* @__PURE__ */ s.jsx(
                  un,
                  {
                    "aria-label": "tooltip",
                    "data-testid": "tooltip-button",
                    color: "gray-light",
                    size: c,
                    style: {
                      position: "absolute",
                      top: 0,
                      right: 0,
                      width: c,
                      minWidth: c,
                      height: c,
                      minHeight: c
                    },
                    m: 3
                  }
                )
              ]
            })
          ),
          /* @__PURE__ */ s.jsxs(L, { p: 3, w: d ? "auto" : 50, children: [
            /* @__PURE__ */ s.jsx(L, { pb: 2, style: { borderBottom: "1px solid #CBD5E1" }, children: t.name }),
            t.price !== void 0 && /* @__PURE__ */ s.jsx(L, { fs: "body1-strong", c: "blue-brand", py: 2, children: l(Qe.oneTimePrice, { price: me(t.price) }) }),
            /* @__PURE__ */ s.jsx(vn, { itemsInCart: t.itemsInBasket }),
            /* @__PURE__ */ s.jsx(
              ie,
              {
                "aria-label": t.itemsInBasket ? i.crossSellMessages.addOneMoreAria : l(Qe.addToAria, { productName: e }),
                "data-testid": `cross-sell-settopbox__add-to-cart__${t.seoId}`,
                "data-o2-id": `cross-sell-settopbox__add-to-cart__${t.seoId}`,
                variant: "primary",
                usage: "outlined",
                fullwidth: !0,
                onPress: m,
                disabled: n,
                children: t.itemsInBasket ? i.crossSellMessages.addOneMore : l(Qe.addTo, { productName: e })
              }
            )
          ] })
        ]
      }
    ),
    /* @__PURE__ */ s.jsx(
      zi,
      {
        setTopBox: t,
        handleAddToCart: m,
        modalControls: o,
        setModalController: a
      }
    )
  ] });
}, Li = ({ stbArticle: t }) => {
  const { unionText: e } = O(), [n, r] = w(), o = gn(t);
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsxs(Dr, { background: "blue-light", mt: 3, mb: 1, children: [
      /* @__PURE__ */ s.jsx("div", { children: e.crossSellMessages.whySetTopBox }),
      /* @__PURE__ */ s.jsxs(
        ie,
        {
          "data-testid": "learn-more-button",
          "aria-label": e.crossSellMessages.learnMore,
          fs: "body1-strong",
          c: "blue-action",
          variant: "primary",
          usage: "text",
          mt: 1,
          onPress: () => {
            n == null || n.open();
          },
          children: [
            /* @__PURE__ */ s.jsx("span", { children: e.crossSellMessages.learnMore }),
            /* @__PURE__ */ s.jsx(pt, { ps: 1 })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ s.jsxs(
      Je,
      {
        size: "small",
        "data-testid": "learn-more-modal",
        getController: r,
        title: e.crossSellMessages.whySetTopBox,
        children: [
          t && /* @__PURE__ */ s.jsx(kt, { url: o }),
          /* @__PURE__ */ s.jsx(
            ie,
            {
              "data-testid": "close-learn-more-modal",
              "aria-label": e.crossSellMessages.close,
              variant: "primary",
              usage: "outlined",
              slot: "primary",
              onPress: () => n == null ? void 0 : n.close(),
              children: e.crossSellMessages.close
            }
          )
        ]
      }
    )
  ] });
}, Fi = ({
  sectionDescription: t,
  setTopBoxes: e,
  addonName: n,
  changeAddonLoading: r,
  onSetTopBoxAdd: o
}) => {
  const a = et(), i = (d) => {
    d.preventDefault(), d.stopPropagation();
  }, l = e && e.length > 1;
  return /* @__PURE__ */ s.jsx(L, { "data-testid": `${n}-settopbox-section`, pb: 3, style: { borderBottom: "1px solid #cbd5e1" }, children: /* @__PURE__ */ s.jsxs(B, { direction: "column", onClick: i, children: [
    t && /* @__PURE__ */ s.jsx(L, { as: "p", fs: "body1", c: "gray-medium", children: t }),
    a && l ? /* @__PURE__ */ s.jsx(Un, { style: { marginLeft: -18, marginRight: -18 }, children: e.map((d) => /* @__PURE__ */ s.jsx($n, { children: /* @__PURE__ */ s.jsx(
      Mr,
      {
        setTopBox: d,
        addonName: n,
        changeAddonLoading: r,
        onSetTopBoxAdd: o
      }
    ) }, d.seoId)) }) : e.map((d) => /* @__PURE__ */ s.jsx(
      Mr,
      {
        setTopBox: d,
        changeAddonLoading: r,
        addonName: n,
        onSetTopBoxAdd: o
      },
      d.seoId
    )),
    e[0].stbArticle && /* @__PURE__ */ s.jsx(Li, { stbArticle: e[0].stbArticle })
  ] }) });
}, Bi = ({
  addon: t,
  checkboxGroupName: e,
  onSetTopBoxAdd: n,
  changeAddonLoading: r,
  onAddonAddViaModal: o
}) => {
  var i, l, d;
  const a = t.checked && ((i = t.settopbox) == null ? void 0 : i.length);
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsx(
      B,
      {
        as: zr,
        w: 100,
        alignItems: "center",
        name: `${e}.${t.seoId}`,
        "aria-label": t.name,
        "data-testid": `cross-sell-addon__${t.seoId}`,
        "data-o2-id": `cross-sell-addon__${t.seoId}`,
        value: t.seoId,
        py: 3,
        bc: "gray-light",
        bb: !a,
        children: /* @__PURE__ */ s.jsx(B, { direction: "column", children: /* @__PURE__ */ s.jsxs(B, { justify: "between", ps: 2, alignItems: "center", children: [
          /* @__PURE__ */ s.jsxs(B, { direction: "column", alignItems: "start", children: [
            /* @__PURE__ */ s.jsxs(B, { direction: "row", alignItems: "center", children: [
              t.image && /* @__PURE__ */ s.jsx(
                Et,
                {
                  alignSelf: "center",
                  me: 2,
                  src: (l = t.image) == null ? void 0 : l.url,
                  "aria-label": (d = t.image) == null ? void 0 : d.title,
                  skipWebp: !0,
                  height: pr,
                  width: pr
                }
              ),
              /* @__PURE__ */ s.jsx("div", { children: t.name }),
              /* @__PURE__ */ s.jsx(Ri, { addon: t, onAddonAddedViaModal: o })
            ] }),
            t.eyeCatcher && /* @__PURE__ */ s.jsx(_t, { mt: 1, color: t.eyeCatcher.color, children: t.eyeCatcher.label })
          ] }),
          /* @__PURE__ */ s.jsx(B, { direction: "row", justify: "between", children: /* @__PURE__ */ s.jsxs(L, { mb: 2, children: [
            t.price !== void 0 && /* @__PURE__ */ s.jsx(rr, { price: t.price, chargePeriod: t.chargePeriod }),
            t.oldPrice !== void 0 && /* @__PURE__ */ s.jsx(ps, { oldPrice: t.oldPrice, hasOffset: !0 })
          ] }) })
        ] }) })
      }
    ),
    a && /* @__PURE__ */ s.jsx(
      Fi,
      {
        sectionDescription: t.settopboxDescription,
        setTopBoxes: t.settopbox,
        addonName: t.name,
        changeAddonLoading: r,
        onSetTopBoxAdd: n
      }
    )
  ] });
}, Hi = ({ categoryId: t }) => {
  const [e, n] = w(!0), r = `${yo}${t}`, o = `${window.location.origin}${bo}${r}`, a = J(() => {
    n(!1);
  }, []);
  return e ? /* @__PURE__ */ s.jsx(L, { mt: 2, fs: "body1", "data-testid": `crossSellAddonCategoryDescription.${t}`, children: /* @__PURE__ */ s.jsx(kt, { url: o, onError: a }) }) : null;
}, sr = ({ message: t, duration: e = 5e3 }) => {
  const n = be(), o = et() ? { position: "fixed", top: "0" } : { position: "fixed", top: "0", right: "0", bottom: "auto", left: "auto", transform: "translate(0, 0)" };
  return S(() => {
    var a;
    (a = n.current) == null || a.show();
  }, [n]), /* @__PURE__ */ s.jsx(Ys, { style: o, children: /* @__PURE__ */ s.jsxs(Zs, { o2Ref: n, "data-testid": "cross-sell-toast", color: "blue-light", closable: !1, duration: e, children: [
    /* @__PURE__ */ s.jsx(Ls, { slot: "icon" }),
    /* @__PURE__ */ s.jsx(L, { as: "span", dangerouslySetInnerHTML: { __html: t } })
  ] }) });
}, Ui = ({ category: t }) => {
  const { unionText: e } = O(), { quote: n } = P(ne), { config: r } = P(K), { addons: o, crossSell: a, refreshCrossSell: i, crossSellLoading: l } = P(Gn), [d, c] = w(!1), [u, m] = w(!1), [v, b] = w(!1), f = be(a);
  f.current = a;
  const k = (I, D) => I.filter((M) => M.category.businessId === D.businessId), h = t.businessId, p = k(o, t), x = $(
    () => p.filter((I) => I.checked).map((I) => I.seoId),
    [p]
  );
  function y(I, D, M) {
    return ot(this, null, function* () {
      var j, U;
      c(!0), b(!1);
      const N = r.dataHomeAddonChangeUrl;
      try {
        const xe = {
          seoId: I.seoId,
          operation: "ACTIVATE",
          groupId: D.contextTariff.quoteGroupId
        }, Te = yield fetch(N, {
          method: "POST",
          body: JSON.stringify(xe),
          headers: {
            "Content-Type": "application/json"
          }
        });
        if (Te.status !== 200)
          throw new Error(`Response status: ${Te.status}`);
        Zt(I, f.current, M), (j = I.settopbox) != null && j.length && os({ crossSell: f.current, addon: I });
      } catch (xe) {
        b(!0);
      } finally {
        c(!1), (U = window.updateMiniCartItemCount) == null || U.call(window), i(D);
      }
    });
  }
  function g(I) {
    return ot(this, null, function* () {
      var M;
      m(!0);
      const D = r.dataHomeAddonChangeUrl;
      try {
        const N = {
          seoId: I.seoId,
          operation: "REVERT",
          groupId: I.quoteItemGroupId,
          itemId: I.quoteItemId
        }, j = yield fetch(D, {
          method: "POST",
          body: JSON.stringify(N),
          headers: {
            "Content-Type": "application/json"
          }
        });
        if (j.status !== 200)
          throw new Error(`Response status: ${j.status}`);
        xi(I, f.current);
      } catch (N) {
        console.error("Error:", N);
      } finally {
        m(!1), (M = window.updateMiniCartItemCount) == null || M.call(window), n && i(n);
      }
    });
  }
  const T = (I, D) => {
    var M;
    (M = n == null ? void 0 : n.contextTariff) != null && M.quoteGroupId ? y(I, n, D) : console.error("quote or quoteItemGroupId is missing, addon to be activated: ", I.seoId);
  }, C = (I) => {
    I != null && I.quoteItemGroupId && (I != null && I.quoteItemId) ? g(I) : console.error("quoteItemGroupId or quoteItemId is missing, addon to be reverted: ", I.seoId);
  }, _ = (I) => {
    if (I.length > x.length) {
      const D = I.find((M) => !x.includes(M));
      if (D) {
        const M = o.find((N) => N.seoId === D);
        M && T(M);
      }
    }
    if (I.length < x.length) {
      const D = x.find((M) => !I.includes(M));
      if (D) {
        const M = p.find((N) => N.seoId === D);
        M && C(M);
      }
    }
  }, z = (I) => {
    T(I);
  }, E = (I, D) => {
    T(I, D);
  };
  return /* @__PURE__ */ s.jsxs(L, { mt: 3, children: [
    /* @__PURE__ */ s.jsx(L, { fs: "h4", mt: 4, children: t.name }),
    /* @__PURE__ */ s.jsx(Hi, { categoryId: t.businessId }),
    /* @__PURE__ */ s.jsx(
      Fs,
      {
        "data-testid": "categoryAddons",
        "aria-labelledby": e.crossSellMessages.addons,
        name: t.businessId,
        direction: "column",
        value: x,
        onChange: _,
        disabled: d || u || l,
        children: p.map((I) => /* @__PURE__ */ s.jsx(
          Bi,
          {
            addon: I,
            checkboxGroupName: h,
            onSetTopBoxAdd: E,
            changeAddonLoading: d || u,
            onAddonAddViaModal: z
          },
          I.seoId
        ))
      }
    ),
    v && /* @__PURE__ */ s.jsx(sr, { message: e.crossSellMessages.addProductFailed })
  ] });
}, $i = ({ addons: t }) => {
  const e = (l) => l.map((d) => d.category).flat(), n = (l) => [...new Set(l.map((d) => d.businessId))], r = (l, d) => l.map((c) => d.find((u) => u.businessId === c)), o = e(t), a = n(o), i = r(a, o);
  return /* @__PURE__ */ s.jsx(W, { mb: 3, children: /* @__PURE__ */ s.jsx(F, { span: { base: 12, xl: 6 }, offset: { xl: 3 }, children: i.map(
    (l) => l && /* @__PURE__ */ s.jsx(Ui, { category: l }, l.businessId)
  ) }) });
}, Vi = () => {
  const t = et(), { addons: e } = P(Gn);
  return e.length === 0 ? null : /* @__PURE__ */ s.jsx(L, { as: "section", className: "bg-white", py: 3, children: /* @__PURE__ */ s.jsx(te, { "data-testid": "cross-sell-addons-section-container", size: t ? "fluid" : void 0, children: /* @__PURE__ */ s.jsx(W, { children: /* @__PURE__ */ s.jsx(F, { span: 12, children: /* @__PURE__ */ s.jsx($i, { addons: e }) }) }) }) });
}, Gi = ({
  seoId: t,
  hirePurchaseEnabled: e,
  cardinalityLimitReached: n,
  handleAddToCartInstallments: r,
  handleAddToCartFullPrice: o,
  handleAddToCart: a
}) => {
  const { unionText: i } = O();
  return e ? /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsx(
      ie,
      {
        "data-testid": `cross-sell-device-detail__installments-add-to-cart-button__${t}`,
        "data-o2-id": `cross-sell-device-detail__installments-add-to-cart-button__${t}`,
        "aria-label": i.crossSellMessages.addToCartInstallments,
        variant: "primary",
        slot: "primary",
        mt: 2,
        onPress: r,
        fullwidth: !0,
        disabled: n,
        children: i.crossSellMessages.addToCartInstallments
      }
    ),
    /* @__PURE__ */ s.jsx(
      ie,
      {
        "data-testid": `cross-sell-device-detail__fullprice-add-to-cart-button__${t}`,
        "data-o2-id": `cross-sell-device-detail__fullprice-add-to-cart-button__${t}`,
        "aria-label": i.crossSellMessages.addToCartFullPrice,
        usage: "outlined",
        variant: "primary",
        slot: "secondary",
        mt: 2,
        fullwidth: !0,
        onPress: o,
        children: i.crossSellMessages.addToCartFullPrice
      }
    )
  ] }) : /* @__PURE__ */ s.jsx(
    ie,
    {
      "data-testid": `cross-sell-device-detail__general-add-to-cart-button__${t}`,
      "data-o2-id": `cross-sell-device-detail__general-add-to-cart-button__${t}`,
      "aria-label": i.crossSellMessages.addToCart,
      variant: "primary",
      slot: "primary",
      mt: 2,
      fullwidth: !0,
      onPress: a,
      children: i.crossSellMessages.addToCart
    }
  );
}, Qi = ({ longDescription: t }) => t ? /* @__PURE__ */ s.jsx(W, { mt: 5, children: /* @__PURE__ */ s.jsx(F, { span: { base: 12, md: 6 }, offset: { md: 3 }, children: /* @__PURE__ */ s.jsx("p", { dangerouslySetInnerHTML: { __html: t } }) }) }) : null, Wi = ({ title: t, isMobile: e }) => /* @__PURE__ */ s.jsx(L, { as: "h2", style: { fontWeight: 600 }, mt: e ? 0 : 4, mb: 2, children: t });
const Yi = ({
  parentModalSize: t,
  device: e,
  hirePurchaseEnabled: n,
  cardinalityLimitReached: r,
  handleAddToCartInstallments: o,
  handleAddToCartFullPrice: a,
  handleAddToCart: i
}) => {
  const l = t === "small", d = $(() => {
    var c;
    return ((c = e.media) == null ? void 0 : c.map((u) => ({
      key: u.key,
      detail: u.fullImage,
      thumbnail: u.thumbnailImage,
      alternateText: `image_${u.key}`
    }))) || [];
  }, [e.media]);
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsxs(W, { mt: { base: 0, sm: 5 }, children: [
      /* @__PURE__ */ s.jsx(F, { span: { base: 12, md: 7 }, children: /* @__PURE__ */ s.jsx(Xs, { "data-testid": "cross-sell-carousel", thumbSlidesPerView: 6, images: d }) }),
      /* @__PURE__ */ s.jsx(F, { span: { base: 12, md: 5 }, children: /* @__PURE__ */ s.jsxs(B, { direction: "column", justify: "center", h: 100, children: [
        /* @__PURE__ */ s.jsx(Wi, { title: e.name, isMobile: l }),
        /* @__PURE__ */ s.jsxs(Dr, { background: "blue-light", p: 3, children: [
          /* @__PURE__ */ s.jsx(rr, { price: e.price, biggerFont: !0 }),
          /* @__PURE__ */ s.jsx(ps, { oldPrice: e.oldPrice, hasOffset: !0 }),
          /* @__PURE__ */ s.jsx(L, { as: "hr", mt: 2, mb: 3 }),
          /* @__PURE__ */ s.jsx(
            Gi,
            {
              seoId: e.seoId,
              hirePurchaseEnabled: n,
              cardinalityLimitReached: r,
              handleAddToCartInstallments: o,
              handleAddToCartFullPrice: a,
              handleAddToCart: i
            }
          )
        ] })
      ] }) })
    ] }),
    /* @__PURE__ */ s.jsx(Qi, { longDescription: e.longDescription })
  ] });
}, Zi = ({ image: t }) => t != null && t.url ? /* @__PURE__ */ s.jsx(
  Et,
  {
    p: 3,
    style: { objectFit: "contain", objectPosition: "50% 50%", width: "100%" },
    src: t.url,
    skipWebp: !0,
    alt: t.title
  }
) : null, Xi = () => /* @__PURE__ */ s.jsx("div", { style: { position: "absolute", top: 0, right: 0, width: 24, height: 24 }, children: /* @__PURE__ */ s.jsx(un, { color: "gray-light", role: "tooltip" }) }), Ki = ({ eyeCatcher: t }) => t ? /* @__PURE__ */ s.jsx(L, { style: { position: "absolute", top: 0, left: 0 }, children: /* @__PURE__ */ s.jsx(_t, { color: t.color, children: t.label }) }) : null, qi = "PT_POSTPAID_PROGRAM", Ji = ({ device: t, crossSellAction: e, crossSellActionLoading: n }) => {
  var p, x;
  const { unionText: r } = O(), { crossSell: o, crossSellLoading: a } = P(Wn), { quote: i } = P(ne), { namespace: l } = P(K), [d, c] = w(), m = et() ? "small" : "large", v = !t.disabledHp, b = () => {
    d == null || d.open();
  }, f = () => {
    var g, T;
    const y = {
      seoId: t.seoId,
      paymentMethod: "O2_MOBIL",
      groupId: (g = i == null ? void 0 : i.contextHw) != null && g.quoteGroupId ? i.contextHw.quoteGroupId : (T = i == null ? void 0 : i.contextTariff) == null ? void 0 : T.quoteGroupId
    };
    e(y, t, !!t.addedViaEanCode), d == null || d.close();
  }, k = () => {
    const y = {
      seoId: t.seoId,
      paymentMethod: "CASH"
      /* CASH */
    };
    e(y, t, !!t.addedViaEanCode), d == null || d.close();
  }, h = () => {
    const y = {
      seoId: t.seoId,
      paymentMethod: t.categories.find((g) => g.businessId === qi) ? "O2_MOBIL" : "CASH"
      /* CASH */
    };
    e(y, t, !0), d == null || d.close();
  };
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsxs(
      B,
      {
        direction: "column",
        justify: (p = t.image) != null && p.url ? "between" : "end",
        style: { minHeight: 350 },
        bg: "white",
        p: 3,
        mb: 3,
        "data-testid": `cross-sell-device__${t.seoId}`,
        "data-o2-id": `cross-sell-device__${t.seoId}`,
        children: [
          /* @__PURE__ */ s.jsxs(B, { direction: "column", children: [
            ((x = t.image) == null ? void 0 : x.url) && /* @__PURE__ */ s.jsxs(
              L,
              {
                w: 100,
                style: { position: "relative", height: 156 },
                role: "button",
                onClick: b,
                "data-testid": `cross-sell-device__open-detail-image-button__${t.seoId}`,
                "data-o2-id": `cross-sell-device__open-detail-image-button__${t.seoId}`,
                children: [
                  /* @__PURE__ */ s.jsx(Zi, { image: t.image }),
                  /* @__PURE__ */ s.jsx(Ki, { eyeCatcher: t.eyeCatcher }),
                  /* @__PURE__ */ s.jsx(Xi, {})
                ]
              }
            ),
            /* @__PURE__ */ s.jsxs(
              B,
              {
                flexFill: !0,
                direction: "column",
                onClick: b,
                role: "button",
                "data-testid": `cross-sell-device__open-detail-description-button__${t.seoId}`,
                "data-o2-id": `cross-sell-device__open-detail-description-button__${t.seoId}`,
                children: [
                  /* @__PURE__ */ s.jsx(L, { pb: 2, mb: 2, bb: !0, bc: "gray-light", children: /* @__PURE__ */ s.jsx(Bs, { lineClamp: 2, children: t.name }) }),
                  /* @__PURE__ */ s.jsx(rr, { price: t.price })
                ]
              }
            )
          ] }),
          /* @__PURE__ */ s.jsxs(B, { direction: "column", children: [
            /* @__PURE__ */ s.jsx(W, { mt: 2, children: /* @__PURE__ */ s.jsx(F, { span: 12, children: /* @__PURE__ */ s.jsx(vn, { itemsInCart: t.itemsInBasket }) }) }),
            v ? /* @__PURE__ */ s.jsxs(W, { children: [
              /* @__PURE__ */ s.jsx(F, { span: { base: 12, md: 6 }, flexOrder: { base: 1, md: 2 }, alignSelf: "center", children: /* @__PURE__ */ s.jsx(
                ie,
                {
                  "data-testid": `cross-sell-device__installments-add-to-cart-button__${t.seoId}`,
                  "data-o2-id": `cross-sell-device__installments-add-to-cart-button__${t.seoId}`,
                  "aria-label": r.crossSellMessages.buyHwInstallments,
                  usage: "outlined",
                  variant: "primary",
                  fullwidth: !0,
                  mt: 2,
                  onPress: f,
                  disabled: !!o.cardinalityLimitReached || a || n,
                  children: r.crossSellMessages.buyHwInstallments
                }
              ) }),
              /* @__PURE__ */ s.jsx(F, { span: { base: 12, md: 6 }, flexOrder: { base: 2, md: 1 }, children: /* @__PURE__ */ s.jsx(
                ie,
                {
                  "data-testid": `cross-sell-device__fullprice-add-to-cart-button__${t.seoId}`,
                  "data-o2-id": `cross-sell-device__fullprice-add-to-cart-button__${t.seoId}`,
                  "aria-label": r.crossSellMessages.buyHwFullPrice,
                  usage: "ghost",
                  variant: "primary",
                  fullwidth: !0,
                  mt: 2,
                  onPress: k,
                  disabled: a,
                  children: r.crossSellMessages.buyHwFullPrice
                }
              ) })
            ] }) : /* @__PURE__ */ s.jsx(W, { children: /* @__PURE__ */ s.jsx(F, { span: 12, children: /* @__PURE__ */ s.jsx(
              ie,
              {
                "data-testid": `cross-sell-device__general-add-to-cart-button__${t.seoId}`,
                "data-o2-id": `cross-sell-device__general-add-to-cart-button__${t.seoId}`,
                "aria-label": r.crossSellMessages.addToCart,
                usage: "outlined",
                variant: "primary",
                fullwidth: !0,
                mt: 2,
                onPress: h,
                disabled: a || n,
                children: r.crossSellMessages.addToCart
              }
            ) }) })
          ] })
        ]
      }
    ),
    /* @__PURE__ */ s.jsx(
      Je,
      {
        getController: c,
        "data-testid": `cross-sell-device-detail-modal_${t.seoId}`,
        size: m,
        children: /* @__PURE__ */ s.jsx(Gt, { portlet: l, children: /* @__PURE__ */ s.jsx(
          Yi,
          {
            device: t,
            parentModalSize: m,
            hirePurchaseEnabled: v,
            cardinalityLimitReached: !!o.cardinalityLimitReached,
            handleAddToCartInstallments: f,
            handleAddToCartFullPrice: k,
            handleAddToCart: h
          }
        ) })
      }
    )
  ] });
}, el = ({ devices: t, crossSell: e, refreshCrossSell: n }) => {
  const { unionText: r } = O(), { config: o } = P(K), { quote: a } = P(ne), { incrementDeviceItemsInBasket: i } = P(Dt), [l, d] = w(!1), [c, u] = w(!1), m = be(e);
  m.current = e;
  function v(f, k) {
    return ot(this, null, function* () {
      d(!1), u(!0);
      const h = o.crossSellActionUrl;
      try {
        const p = yield fetch(h, {
          method: "POST",
          body: JSON.stringify(f),
          headers: {
            "Content-Type": "application/json"
          }
        });
        if (p.status !== 200)
          throw new Error(`CrossSell action response status: ${p.status}`);
        k();
      } catch (p) {
        d(!0);
      } finally {
        u(!1);
      }
    });
  }
  function b(f, k, h) {
    return ot(this, null, function* () {
      v(f, h ? () => {
        Zt(k, m.current), i(k.seoId);
      } : () => {
        var y;
        (y = window.updateMiniCartItemCount) == null || y.call(window), Zt(k, m.current), a && n(a);
      });
    });
  }
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsx(W, { children: /* @__PURE__ */ s.jsxs(F, { span: 12, py: 3, children: [
      l && /* @__PURE__ */ s.jsx(sr, { message: r.crossSellMessages.addProductFailed }),
      /* @__PURE__ */ s.jsx(L, { as: "h3", className: "h4", children: r.crossSellMessages.devicesTitle })
    ] }) }),
    /* @__PURE__ */ s.jsx(W, { children: t.map((f) => /* @__PURE__ */ s.jsx(F, { span: { base: 6, lg: 4 }, h: "auto", children: /* @__PURE__ */ s.jsx(
      Ji,
      {
        device: f,
        crossSellActionLoading: c,
        crossSellAction: b
      }
    ) }, f.seoId)) })
  ] });
}, tl = () => {
  const t = et(), { crossSell: e, refreshCrossSell: n } = P(Wn), { manuallyAddedDevices: r } = P(Dt), a = [...r.filter(
    (i) => {
      var l;
      return !((l = e.devices) != null && l.map((d) => d.seoId).includes(i.seoId));
    }
  ), ...e.devices || []];
  return a.length === 0 ? null : /* @__PURE__ */ s.jsx(L, { as: "section", bg: "gray-ultra-light", children: /* @__PURE__ */ s.jsx(te, { size: t ? "fluid" : void 0, children: /* @__PURE__ */ s.jsx(el, { devices: a, crossSell: e, refreshCrossSell: n }) }) });
}, nl = ({ error: t }) => {
  const { namespace: e } = P(K), { unionText: n } = O();
  return t ? /* @__PURE__ */ s.jsx(te, { children: /* @__PURE__ */ s.jsx(W, { children: /* @__PURE__ */ s.jsx(F, { span: 12, my: 3, children: /* @__PURE__ */ s.jsx(Ge, { color: "danger", "data-o2-portlet": e, "data-o2-role": "alert-system", children: n.commonMessages.error }) }) }) }) : null;
}, rl = ({
  program: t,
  modalControlls: e,
  setModalController: n,
  onAddToCart: r,
  crossSellLoading: o,
  crossSellCashActionLoading: a
}) => {
  const { unionText: i } = O(), l = $(() => gn(t.tooltipArticle), [t.tooltipArticle]), d = () => {
    r(t), e == null || e.close();
  };
  return t.tooltipArticle ? /* @__PURE__ */ s.jsxs(
    Je,
    {
      p: 2,
      heading: t.name,
      getController: n,
      "data-testid": `cross-sell-tooltip-article-modal__${t.seoId}`,
      "data-o2-id": `cross-sell-tooltip-article-modal__${t.seoId}`,
      children: [
        /* @__PURE__ */ s.jsx(kt, { mt: 3, url: l }),
        /* @__PURE__ */ s.jsx(
          ie,
          {
            slot: "primary",
            "aria-label": i.crossSellMessages.addToCartAria,
            "data-testid": "addProgramToCartButton",
            onPress: d,
            disabled: o || a,
            children: i.crossSellMessages.addToCart
          }
        )
      ]
    }
  ) : null;
}, sl = ({ containsDatahome: t, containsTv: e }) => {
  const [n, r] = w(!0), o = pi(t, e), a = J(() => {
    r(!1);
  }, []);
  return n ? /* @__PURE__ */ s.jsx(te, { children: /* @__PURE__ */ s.jsx(W, { children: /* @__PURE__ */ s.jsx(F, { span: 12, children: /* @__PURE__ */ s.jsx(B, { justify: "center", mt: 5, mb: 4, children: /* @__PURE__ */ s.jsx(kt, { url: o, onError: a }) }) }) }) }) : null;
}, Bt = 24, ol = ({
  program: t,
  modalController: e,
  onAddToCart: n,
  crossSellLoading: r,
  crossSellCashActionLoading: o,
  elementDataTestId: a,
  addToCartDataTestId: i
}) => {
  var p, x, y;
  const { withParams: l, unionText: d } = O(), c = t.image !== void 0, u = t.tooltipArticle, m = t.eyeCatcher !== void 0, h = (e == null ? void 0 : e.triggerProps) || {}, { onPress: v } = h, b = en(h, ["onPress"]), f = () => {
    e == null || e.toggle();
  }, k = () => {
    n(t);
  };
  return /* @__PURE__ */ s.jsxs(B, { direction: "column", h: 100, "data-testid": a, "data-o2-id": a, children: [
    /* @__PURE__ */ s.jsxs(
      "div",
      G(H(H({
        style: { position: "relative", overflow: "hidden", height: 160 },
        "data-testid": `cross-sell-program__open-detail-top-button__${t.seoId}`,
        "data-o2-id": `cross-sell-program__open-detail-top-button__${t.seoId}`,
        "aria-label": "open detail",
        tabIndex: 0
      }, u && { onClick: f, role: "button" }), b), {
        children: [
          c && /* @__PURE__ */ s.jsx(
            "div",
            {
              className: "image",
              style: {
                height: "100%",
                backgroundImage: `url(${(p = t.image) == null ? void 0 : p.url})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat"
              }
            }
          ),
          u && /* @__PURE__ */ s.jsx(
            un,
            {
              "aria-label": "tooltip",
              size: Bt,
              color: "gray-light",
              style: {
                position: "absolute",
                top: 0,
                right: 0,
                width: Bt,
                minWidth: Bt,
                height: Bt,
                minHeight: Bt
              },
              m: 3
            }
          ),
          m && /* @__PURE__ */ s.jsx(_t, { style: { position: "absolute", top: 0, left: 0 }, m: 3, color: (x = t.eyeCatcher) == null ? void 0 : x.color, children: (y = t.eyeCatcher) == null ? void 0 : y.label })
        ]
      })
    ),
    /* @__PURE__ */ s.jsx(L, { flexGrow: 1, p: 3, mb: 3, style: { backgroundColor: "white" }, children: /* @__PURE__ */ s.jsx(W, { style: { height: "100%", minHeight: 155 }, children: /* @__PURE__ */ s.jsxs(B, { direction: "column", children: [
      /* @__PURE__ */ s.jsxs(
        B,
        G(H({
          flexGrow: 1,
          direction: "column",
          justify: "between",
          "data-testid": "openDetailBottomButton",
          "aria-label": "open detail",
          tabIndex: 0
        }, u && { onClick: f, role: "button" }), {
          children: [
            /* @__PURE__ */ s.jsxs(F, { span: 12, children: [
              /* @__PURE__ */ s.jsx(L, { as: "h4", fs: "body1-strong", c: "blue-brand", children: t.name }),
              t.description && /* @__PURE__ */ s.jsx("p", { children: t.description })
            ] }),
            /* @__PURE__ */ s.jsxs(F, { span: 12, children: [
              /* @__PURE__ */ s.jsx(L, { as: "hr", my: 2 }),
              /* @__PURE__ */ s.jsxs(B, { direction: "row", justify: "between", alignItems: "center", children: [
                /* @__PURE__ */ s.jsxs(L, { mb: 2, children: [
                  t.price !== void 0 && /* @__PURE__ */ s.jsx(s.Fragment, { children: /* @__PURE__ */ s.jsxs(L, { as: "span", fs: "body1-strong", c: "blue-brand", children: [
                    l(Qe.oneTimePrice, { price: me(t.price) }),
                    t.chargePeriod && d.chargePeriodMessages[t.chargePeriod]
                  ] }) }),
                  t.oldPrice !== void 0 && /* @__PURE__ */ s.jsxs(L, { as: "span", fs: "body1", c: "gray-medium", children: [
                    " ",
                    /* @__PURE__ */ s.jsx("span", { style: { textDecoration: "line-through" }, children: l(Qe.oneTimePrice, { price: me(t.oldPrice) }) })
                  ] })
                ] }),
                /* @__PURE__ */ s.jsx(L, { children: /* @__PURE__ */ s.jsx(vn, { itemsInCart: t.itemsInBasket }) })
              ] })
            ] })
          ]
        })
      ),
      /* @__PURE__ */ s.jsx(F, { span: 12, children: /* @__PURE__ */ s.jsx(
        ie,
        {
          "data-testid": i,
          "data-o2-id": i,
          "aria-label": d.crossSellMessages.addToCart,
          variant: "primary",
          usage: "outlined",
          fullwidth: !0,
          onPress: k,
          disabled: r || o,
          children: d.crossSellMessages.addToCart
        }
      ) })
    ] }) }) })
  ] });
}, Ht = 24, al = ({
  program: t,
  modalController: e,
  onAddToCart: n,
  crossSellLoading: r,
  crossSellCashActionLoading: o,
  elementDataTestId: a,
  addToCartDataTestId: i
}) => {
  var p, x, y;
  const { withParams: l, unionText: d } = O(), c = t.image !== void 0, u = t.tooltipArticle, m = t.eyeCatcher !== void 0, h = (e == null ? void 0 : e.triggerProps) || {}, { onPress: v } = h, b = en(h, ["onPress"]), f = () => {
    e == null || e.toggle();
  }, k = () => {
    n(t);
  };
  return /* @__PURE__ */ s.jsxs(
    B,
    {
      direction: "column",
      flexGrow: 1,
      h: 100,
      style: { width: 300 },
      "data-testid": a,
      "data-o2-id": a,
      children: [
        /* @__PURE__ */ s.jsxs(
          "div",
          G(H(H({
            style: { position: "relative", overflow: "hidden", height: 160 },
            "data-testid": `cross-sell-program__open-detail-top-button__${t.seoId}`,
            "data-o2-id": `cross-sell-program__open-detail-top-button__${t.seoId}`,
            "aria-label": "open detail",
            tabIndex: 0
          }, u && { onClick: f, role: "button" }), b), {
            children: [
              c && /* @__PURE__ */ s.jsx(
                "div",
                {
                  className: "image",
                  style: {
                    height: "100%",
                    backgroundImage: `url(${(p = t.image) == null ? void 0 : p.url})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat"
                  }
                }
              ),
              u && /* @__PURE__ */ s.jsx(
                un,
                {
                  "aria-label": "tooltip",
                  "data-testid": "tooltip-button",
                  size: Ht,
                  color: "gray-light",
                  style: {
                    position: "absolute",
                    top: 0,
                    right: 0,
                    width: Ht,
                    minWidth: Ht,
                    height: Ht,
                    minHeight: Ht
                  },
                  m: 3
                }
              ),
              m && /* @__PURE__ */ s.jsx(_t, { style: { position: "absolute", top: 0, left: 0 }, m: 3, color: (x = t.eyeCatcher) == null ? void 0 : x.color, children: (y = t.eyeCatcher) == null ? void 0 : y.label })
            ]
          })
        ),
        /* @__PURE__ */ s.jsxs(B, { p: 3, mb: 3, flexFill: !0, h: "auto", direction: "column", justify: "between", style: { backgroundColor: "white" }, children: [
          /* @__PURE__ */ s.jsxs(B, { direction: "column", justify: "between", children: [
            /* @__PURE__ */ s.jsxs(
              W,
              G(H({
                mb: 2,
                "data-testid": "open-detail-bottom-button",
                "aria-label": "open detail",
                tabIndex: 0
              }, u && { onClick: f, role: "button" }), {
                children: [
                  /* @__PURE__ */ s.jsx(F, { pe: 0, span: 7, children: /* @__PURE__ */ s.jsx(L, { as: "h4", fs: "body1-strong", c: "blue-brand", children: t.name }) }),
                  /* @__PURE__ */ s.jsxs(F, { ps: 0, span: 5, style: { textAlign: "right" }, children: [
                    t.price !== void 0 && /* @__PURE__ */ s.jsx(L, { fs: "body1-strong", c: "blue-brand", children: /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
                      l(Qe.oneTimePrice, { price: me(t.price) }),
                      t.chargePeriod && d.chargePeriodMessages[t.chargePeriod]
                    ] }) }),
                    t.oldPrice !== void 0 && /* @__PURE__ */ s.jsx(L, { fs: "body1", c: "gray-medium", style: { textDecoration: "line-through" }, children: l(Qe.oneTimePrice, { price: me(t.oldPrice) }) })
                  ] })
                ]
              })
            ),
            /* @__PURE__ */ s.jsx(W, { style: { flex: 1 }, children: /* @__PURE__ */ s.jsx(F, { span: 12, children: t.description && /* @__PURE__ */ s.jsx("p", { style: { height: "100%" }, children: t.description }) }) })
          ] }),
          /* @__PURE__ */ s.jsx(W, { children: /* @__PURE__ */ s.jsxs(F, { span: 12, children: [
            /* @__PURE__ */ s.jsx(vn, { itemsInCart: t.itemsInBasket }),
            /* @__PURE__ */ s.jsx(
              ie,
              {
                "data-testid": i,
                "data-o2-id": i,
                "aria-label": d.crossSellMessages.addToCart,
                variant: "primary",
                usage: "outlined",
                fullwidth: !0,
                onPress: k,
                disabled: r || o,
                children: d.crossSellMessages.addToCart
              }
            )
          ] }) })
        ] })
      ]
    }
  );
}, Sn = ({ program: t, onAddToCart: e, crossSellLoading: n, crossSellCashActionLoading: r }) => {
  const o = et(), [a, i] = w(), l = `cross-sell-program__${t.seoId}`, d = `cross-sell-program__add-to-cart-button__${t.seoId}`;
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    o ? /* @__PURE__ */ s.jsx(
      al,
      {
        program: t,
        modalController: a,
        onAddToCart: e,
        crossSellLoading: n,
        crossSellCashActionLoading: r,
        elementDataTestId: l,
        addToCartDataTestId: d
      }
    ) : /* @__PURE__ */ s.jsx(
      ol,
      {
        program: t,
        modalController: a,
        onAddToCart: e,
        crossSellLoading: n,
        crossSellCashActionLoading: r,
        elementDataTestId: l,
        addToCartDataTestId: d
      }
    ),
    /* @__PURE__ */ s.jsx(
      rl,
      {
        program: t,
        modalControlls: a,
        setModalController: i,
        onAddToCart: e,
        crossSellLoading: n,
        crossSellCashActionLoading: r
      }
    )
  ] });
}, il = ({
  programs: t,
  crossSell: e,
  refreshCrossSell: n,
  crossSellLoading: r,
  hasOnlyPrograms: o
}) => {
  const { config: a } = P(K), { quote: i } = P(ne), { incrementProgramItemsInBasket: l } = P(Dt), { unionText: d } = O(), c = et(), [u, m] = w(!1), [v, b] = w(!1), f = be(e);
  f.current = e;
  function k(p, x) {
    return ot(this, null, function* () {
      b(!0), m(!1);
      const y = a.crossSellActionUrl;
      try {
        const g = yield fetch(y, {
          method: "POST",
          body: JSON.stringify(p),
          headers: {
            "Content-Type": "application/json"
          }
        });
        if (g.status !== 200)
          throw new Error(`Response status: ${g.status}`);
        x();
      } catch (g) {
        m(!0);
      } finally {
        b(!1);
      }
    });
  }
  const h = (p) => {
    const x = {
      paymentMethod: p.categories.find((T) => T.businessId === Ur) ? Xe.O2_MOBIL : Xe.CASH,
      seoId: p.seoId
    }, y = () => {
      var T;
      Zt(p, f.current), (T = window.updateMiniCartItemCount) == null || T.call(window), i && n(i);
    }, g = () => {
      Zt(p, f.current), l(p.seoId);
    };
    k(x, p.addedViaEanCode ? g : y);
  };
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    u && /* @__PURE__ */ s.jsx(sr, { message: d.crossSellMessages.addProductFailed }),
    c && o && /* @__PURE__ */ s.jsxs(te, { children: [
      /* @__PURE__ */ s.jsx(L, { as: "h3", className: "h4", py: 3, children: d.crossSellMessages.programsTitle }),
      t.map((p, x) => /* @__PURE__ */ s.jsx(B, { children: /* @__PURE__ */ s.jsx(
        Sn,
        {
          program: p,
          onAddToCart: h,
          crossSellLoading: r,
          crossSellCashActionLoading: v
        }
      ) }, x))
    ] }),
    c && !o && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      /* @__PURE__ */ s.jsx(F, { span: 12, children: /* @__PURE__ */ s.jsx(L, { as: "h3", className: "h4", px: 3, py: 3, children: d.crossSellMessages.programsTitle }) }),
      /* @__PURE__ */ s.jsx(Un, { children: t.map((p, x) => /* @__PURE__ */ s.jsx($n, { h: "auto", children: /* @__PURE__ */ s.jsx(
        Sn,
        {
          program: p,
          onAddToCart: h,
          crossSellLoading: r,
          crossSellCashActionLoading: v
        }
      ) }, x)) })
    ] }),
    !c && /* @__PURE__ */ s.jsx(te, { children: /* @__PURE__ */ s.jsxs(W, { children: [
      /* @__PURE__ */ s.jsx(F, { span: 12, children: /* @__PURE__ */ s.jsx(L, { as: "h3", className: "h4", py: 3, children: d.crossSellMessages.programsTitle }) }),
      /* @__PURE__ */ s.jsx(F, { span: 12, children: /* @__PURE__ */ s.jsx(W, { children: t.map((p, x) => /* @__PURE__ */ s.jsx(F, { span: 4, children: /* @__PURE__ */ s.jsx(
        Sn,
        {
          program: p,
          onAddToCart: h,
          crossSellLoading: r,
          crossSellCashActionLoading: v
        }
      ) }, x)) }) })
    ] }) })
  ] });
}, ll = ({ containsDatahome: t, observedRef: e, targetRef: n, getNextState: r }) => {
  const { unionText: o } = O(), [a, i] = w(!1);
  return S(() => {
    const l = new IntersectionObserver(
      ([c]) => {
        c.isIntersecting ? i(!1) : i(!0);
      },
      {
        threshold: 0.1
      }
    ), d = e.current;
    return d && l.observe(d), () => {
      d && l.unobserve(d);
    };
  }, [e]), /* @__PURE__ */ s.jsx(s.Fragment, { children: /* @__PURE__ */ s.jsx("div", { className: "cross-sell__cta-wrapper", ref: n, children: /* @__PURE__ */ s.jsx("div", { className: `cross-sell__cta ${a && "cta--sticky"}`, children: /* @__PURE__ */ s.jsx(te, { size: "fluid", children: /* @__PURE__ */ s.jsx(W, { justify: "center", children: /* @__PURE__ */ s.jsx(F, { span: { md: 8, lg: 6, xl: 4 }, children: /* @__PURE__ */ s.jsx(
    ie,
    {
      "aria-label": t ? o.crossSellMessages.goToCartAria : o.crossSellMessages.continueAria,
      id: "cross-sell-submit-button",
      my: 5,
      fullwidth: !0,
      "data-o2-id": "crossSell.submit",
      "data-testid": "crossSell.submit",
      name: "crossSell.submit",
      onPress: () => r(),
      children: t ? o.crossSellMessages.goToCart : o.crossSellMessages.continue
    }
  ) }) }) }) }) }) });
}, Ut = ({
  title: t,
  description: e,
  subtitle: n,
  id: r,
  cancel: o,
  items: a,
  changedAddons: i,
  changedAddonsTitle: l,
  submitMethod: d,
  cancelMethod: c,
  o2Ref: u,
  confirmText: m,
  hideMethod: v,
  message: b
}) => {
  const { unionText: f } = O(), { commonMessages: k } = f, h = be(), { namespace: p } = P(K);
  return Rs(
    u,
    () => h.current ? h.current : void 0,
    []
  ), /* @__PURE__ */ s.jsxs(Ye, { size: "small", heading: "", o2Ref: h, onHide: v, "data-testid": r + "-modal", children: [
    /* @__PURE__ */ s.jsx("div", { className: "text-center text-md-start", slot: "heading", children: t }),
    /* @__PURE__ */ s.jsx("p", { className: "text-center text-secondary text-md-start", dangerouslySetInnerHTML: { __html: e } }),
    l && i && i.length && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      /* @__PURE__ */ s.jsx("hr", {}),
      /* @__PURE__ */ s.jsx("p", { className: "fw-bold text-center text-md-start", children: l }),
      /* @__PURE__ */ s.jsx(
        xt,
        {
          background: "blue-light",
          className: "info-box mt-3",
          heading: "",
          "data-o2-id": "change-addons-box",
          "data-testid": "change-addons-box",
          children: i == null ? void 0 : i.map((x, y) => /* @__PURE__ */ s.jsx(
            Ci,
            {
              withDivider: y !== i.length - 1,
              addon: x,
              eyeCatcher: (x == null ? void 0 : x.priceLevel) === "Discounted" ? k.discountedAddonEyeCatcher : void 0,
              eyeCatcherColor: "frog"
            },
            `addon-${y}`
          ))
        }
      )
    ] }),
    n && a && a.length > 0 && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      /* @__PURE__ */ s.jsx("hr", {}),
      /* @__PURE__ */ s.jsx("p", { className: "fw-bold text-center text-md-start", children: n }),
      a == null ? void 0 : a.map((x, y) => /* @__PURE__ */ s.jsx("p", { className: "text-center mb-1 text-md-start", children: x }, y))
    ] }),
    b === "PRICE_LEVEL_DECOMMISSIONED" && /* @__PURE__ */ s.jsx("div", { className: "mt-3", children: /* @__PURE__ */ s.jsx(
      ye,
      {
        color: "warning",
        "data-o2-portlet": p,
        "data-o2-role": "alert-user",
        heading: k.PRICE_LEVEL_DECOMMISSIONED.heading,
        children: /* @__PURE__ */ s.jsx("p", { dangerouslySetInnerHTML: { __html: k.PRICE_LEVEL_DECOMMISSIONED.text } })
      }
    ) }),
    d && /* @__PURE__ */ s.jsx(
      ge,
      {
        "data-o2-id": r + "-confirm",
        "data-testid": r + "-confirm",
        name: (r + "-confirm").replace(/-([a-z])/g, function(x) {
          return x[1].toUpperCase();
        }),
        fullwidth: !0,
        slot: "primary",
        onClick: () => {
          var x;
          (x = h == null ? void 0 : h.current) == null || x.hide(), d && d();
        },
        children: m || k.errorConfirm
      }
    ),
    /* @__PURE__ */ s.jsx(
      ge,
      {
        "data-o2-id": r + "-cancel",
        "data-testid": r + "-cancel",
        name: (r + "-cancel").replace(/-([a-z])/g, function(x) {
          return x[1].toUpperCase();
        }),
        fullwidth: !0,
        usage: "outlined",
        slot: "secondary",
        onClick: () => {
          var x;
          (x = h == null ? void 0 : h.current) == null || x.hide(), c && c();
        },
        children: o
      }
    )
  ] });
}, or = ({ getNextState: t, error: e, setError: n, tariffName: r, onError: o }) => {
  const a = be(), i = be(), l = be(), d = be(), c = be(), [u, m] = w(), [v, b] = w(), [f, k] = w(), [h, p] = w(), { quote: x, setQuote: y } = P(ne), { unionText: g, withParams: T } = O(), { commonMessages: C } = g;
  S(() => {
    var D, M;
    if (!e || !e.validationResults && !e.skuCanBeLost && !e.changedAddons)
      return;
    const I = [
      "O2_CUSTOMER",
      "VIRTUAL_PORTIN_NOT_ALLOWED",
      "O2BS_CUSTOMER",
      "MULTIPLE_OPERATORS",
      "PORTIN_ALREADY_REQUESTED",
      "OPERATOR_NOT_FOUND"
    ];
    (D = e.validationResults) == null || D.forEach((N) => {
      var Te, Ae, Re, ht, ft, tt, nt, rt;
      const j = (Te = N.validationParams) == null ? void 0 : Te.find((Ze) => Ze.key === "TARIFF"), U = (Ae = N.validationParams) == null ? void 0 : Ae.find((Ze) => Ze.key === "MSISDN");
      let xe = {
        tariff: (Re = j == null ? void 0 : j.value) != null ? Re : "",
        msisdn: (ht = U == null ? void 0 : U.value) != null ? ht : "",
        reasonCode: N.reasonCode,
        groupId: N.groupId,
        portinMsisdn: x == null ? void 0 : x.portinMsisdn,
        portinError: !1
      };
      N.reasonCode === "FIX_PROGRAM_NOT_COMPATIBLE_WITH_QUOTE" ? (ft = c == null ? void 0 : c.current) == null || ft.show() : N.reasonCode === "SUBSCRIBER_ALREADY_IN_ORDER" || N.reasonCode === "CONFLICTING_GROUP_IN_QUOTE" ? (tt = a == null ? void 0 : a.current) == null || tt.show() : N.reasonCode === "NOT_ELIGIBLE_WITH_FIX_PROGRAM" ? (nt = l == null ? void 0 : l.current) == null || nt.show() : N.reasonCode === "DUPLICATED_PORTIN_MSISDN" ? (rt = d == null ? void 0 : d.current) == null || rt.show() : I.includes(N.reasonCode) && (xe = G(H({}, xe), {
        reasonCode: N.reasonCode,
        groupId: N.groupId,
        portinError: !0
      })), p(xe), o && o(xe);
    }), (e.skuCanBeLost || e.changedAddons) && (m(e.skuCanBeLost), b(e.changedAddons), k(e.message), (M = i == null ? void 0 : i.current) == null || M.show());
  }, [
    a,
    d,
    e,
    c,
    l,
    o,
    x == null ? void 0 : x.portinMsisdn,
    i
  ]);
  const _ = (I) => {
    x && (y(x, () => t(I, h == null ? void 0 : h.groupId, h == null ? void 0 : h.reasonCode, !1)), E("DUPLICATED_PORTIN_MSISDN"));
  }, z = () => {
    x && y(x, () => t());
  }, E = (I) => {
    var D;
    if (e) {
      const M = (D = e == null ? void 0 : e.validationResults) == null ? void 0 : D.filter(
        (N) => N.reasonCode !== I
      );
      n((N) => JSON.stringify(N == null ? void 0 : N.validationResults) === JSON.stringify(M) ? N : G(H({}, e), { validationResults: M }));
    }
  };
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsx(
      Ut,
      {
        title: C.alreadyInOrderTitle,
        description: T(C.alreadyInOrderDesc, {
          msisdn: (h == null ? void 0 : h.msisdn) || "",
          tariff: (h == null ? void 0 : h.tariff) || ""
        }),
        subtitle: C.alreadyInOrderSubTitle,
        id: "already-in-order",
        cancel: C.errorCancelProgram,
        items: r ? [r] : [],
        o2Ref: a,
        submitMethod: () => _(at.REPLACE),
        cancelMethod: () => {
          _(at.IGNORE);
        }
      }
    ),
    /* @__PURE__ */ s.jsx(
      Ut,
      {
        title: C.skuCanBeLostTitle,
        description: e != null && e.changeTariffDate ? T(C.skuCanBeLostDescWithDate, { date: e.changeTariffDate }) : C.skuCanBeLostDesc,
        subtitle: C.skuCanBeLostSubTitle,
        id: "skus-can-be-lost",
        cancel: C.cancel,
        confirmText: C.confirm,
        changedAddons: v,
        changedAddonsTitle: C.changedAddonsTitle,
        items: u,
        message: f,
        o2Ref: i,
        submitMethod: z
      }
    ),
    /* @__PURE__ */ s.jsx(
      Ut,
      {
        title: C.notEligibleWithProgramTitle,
        description: T(C.notEligibleWithProgramDesc, { tariff: (h == null ? void 0 : h.tariff) || "" }),
        id: "not-eligible-with-program",
        cancel: C.errorCancel,
        o2Ref: l,
        submitMethod: () => _(at.REPLACE),
        cancelMethod: () => {
          _(at.IGNORE);
        }
      }
    ),
    /* @__PURE__ */ s.jsx(
      Ut,
      {
        title: C.duplicatedPortinTitle,
        description: T(C.duplicatedPortinDesc, {
          msisdn: (h == null ? void 0 : h.msisdn) || "",
          tariff: (h == null ? void 0 : h.tariff) || ""
        }),
        subtitle: C.duplicatedPortinSubTitle,
        id: "duplicated-portin-msisdn",
        cancel: C.errorCancelProgram,
        items: r ? [r] : [],
        o2Ref: d,
        submitMethod: () => _(at.REPLACE),
        cancelMethod: () => {
          _(at.IGNORE);
        },
        hideMethod: () => {
          E("DUPLICATED_PORTIN_MSISDN");
        }
      }
    ),
    /* @__PURE__ */ s.jsx(
      Ut,
      {
        title: C.notCompatibleTitle,
        description: T(C.notCompatibleDesc, { tariff: (h == null ? void 0 : h.tariff) || "" }),
        id: "not-compatible-with-quote",
        submitMethod: () => {
          _(at.REPLACE_ALL_GROUPS);
        },
        cancel: C.errorCancel,
        o2Ref: c
      }
    )
  ] });
}, hs = ({ device: t, hidePrice: e }) => {
  const { namespace: n } = P(K), { unionText: r } = O(), { hwDevicesMessages: o } = r, a = (i) => {
    if (i)
      switch (i) {
        case "O2_EXTRA":
          return o.devicePrice_O2_EXTRA;
        case "SMARTWATCH":
          return o.devicePrice_SMARTWATCH;
        case "TABLETS":
          return o.devicePrice_TABLETS;
        case "MOBILE_PHONES":
          return o.devicePrice_MOBILE_PHONES;
        case "ACCESSORIES":
          return o.devicePrice_ACCESSORIES;
        default:
          return o.devicePrice_O2_EXTRA;
      }
    return o.devicePrice_O2_EXTRA;
  };
  return /* @__PURE__ */ s.jsxs("div", { className: "hw-product", children: [
    /* @__PURE__ */ s.jsx("div", { className: "hw-product__image-wrapper", children: /* @__PURE__ */ s.jsx(Vn, { src: t.primaryImage }) }),
    /* @__PURE__ */ s.jsxs("div", { className: "hw-product__info", children: [
      /* @__PURE__ */ s.jsx("div", { className: "hw-product__title", children: t.displayName }),
      !e && /* @__PURE__ */ s.jsxs("div", { className: "hw-product__lead", children: [
        a(t.category),
        " ",
        /* @__PURE__ */ s.jsx(Gt, { portlet: n, children: /* @__PURE__ */ s.jsx(Ne, { price: t.oneTimePrice, priceOverrideAmount: t.oneTimePriceOverride }) })
      ] })
    ] })
  ] });
};
const dl = ({ onRef: t, programType: e, selectedInstallationType: n }) => {
  const { unionText: r } = O(), { installationMethodMessages: o } = r, a = $(() => {
    if (e === "DATAHOME")
      return o.installMethodModal.steps.DATAHOME;
    switch (n) {
      case "SELF_SERVICE":
        return o.installMethodModal.steps.SELF_SERVICE;
      case "TECHNICIAN":
        return o.installMethodModal.steps.TECHNICIAN;
    }
  }, [
    o.installMethodModal.steps.SELF_SERVICE,
    o.installMethodModal.steps.TECHNICIAN,
    o.installMethodModal.steps.DATAHOME,
    e,
    n
  ]), i = $(() => Object.values(a != null ? a : []).map((d) => /* @__PURE__ */ s.jsxs("div", { children: [
    /* @__PURE__ */ s.jsx("h6", { className: "mb-1", children: d.title }),
    /* @__PURE__ */ s.jsx("p", { className: "text-secondary", children: d.content })
  ] }, `step-${d.title}`)), [a]);
  return /* @__PURE__ */ s.jsx(
    Ye,
    {
      id: "modal-install-method",
      "data-testid": "modal-install-method",
      size: "small",
      heading: o.installMethodModal.title,
      onRef: t,
      children: i
    }
  );
}, cl = ({
  occs: t,
  programType: e,
  selectedInstallationType: n,
  setSelectedInstallationType: r,
  loading: o
}) => {
  const { namespace: a } = P(K), { unionText: i } = O(), { installationMethodMessages: l } = i, [d, c] = w(), u = $(() => (t == null ? void 0 : t.length) && t.length > 0, [t]);
  return S(() => {
    var m;
    !n && (t != null && t.length) && t.length === 1 && r((m = t[0]) == null ? void 0 : m.type);
  }, [t, n, r]), /* @__PURE__ */ s.jsx(s.Fragment, { children: u && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsx(
      dl,
      {
        onRef: c,
        selectedInstallationType: n,
        programType: e
      }
    ),
    /* @__PURE__ */ s.jsx("hr", { className: "divider divider-gray my-3" }),
    /* @__PURE__ */ s.jsx(
      Fn,
      {
        "aria-label": "rg_label",
        name: "installationType",
        value: n != null ? n : "",
        direction: "column",
        w: 100,
        onChange: (m) => r(m),
        className: "w-100",
        "data-o2-id": "select-installationType-radio-group",
        "data-testid": "select-installationType-radio-group",
        disabled: o,
        children: t == null ? void 0 : t.map((m, v) => {
          var b;
          return /* @__PURE__ */ s.jsxs("div", { children: [
            /* @__PURE__ */ s.jsx(Gt, { portlet: a, children: /* @__PURE__ */ s.jsx(
              Bn,
              {
                value: m.type,
                className: "w100radio",
                w: 100,
                "data-o2-id": `radio-item-${m.type}`,
                "data-testid": `radio-item-${m.type}`,
                name: "installationType",
                children: /* @__PURE__ */ s.jsxs(B, { justify: "between", children: [
                  /* @__PURE__ */ s.jsxs("div", { children: [
                    n && m.type === n ? /* @__PURE__ */ s.jsx("b", { children: `${l.installation.label[m.type]} ` }) : l.installation.label[m.type] + " ",
                    m.type === "SELF_SERVICE" && /* @__PURE__ */ s.jsx(_t, { ms: 2, children: l.installation.recomended })
                  ] }),
                  /* @__PURE__ */ s.jsx("div", { className: "fw-bold", children: `${m.price}` })
                ] })
              },
              m.type
            ) }),
            !!n && m.type === n && /* @__PURE__ */ s.jsxs(Ge, { color: "primary", className: "pt-2 mt-3", children: [
              /* @__PURE__ */ s.jsx(
                "div",
                {
                  className: "mt-2 mb-3",
                  dangerouslySetInnerHTML: { __html: l.installation.hint[m.type] }
                }
              ),
              /* @__PURE__ */ s.jsxs(
                "a",
                {
                  id: "open-install-method",
                  "data-testid": "open-install-method",
                  className: "text-small d-flex align-items-center gap-1",
                  onClick: () => d == null ? void 0 : d.current.show(),
                  children: [
                    l.installation.learnMore,
                    " ",
                    /* @__PURE__ */ s.jsx(Q, { name: "info-circle", size: 18 })
                  ]
                }
              )
            ] }),
            /* @__PURE__ */ s.jsx("hr", { className: "divider divider-gray my-3" })
          ] }, (b = m.type) != null ? b : v);
        })
      }
    )
  ] }) });
}, xn = ({ quote: t }) => {
  const { unionText: e } = O(), { internetMoreInfoMessages: n } = e;
  function r(o) {
    return decodeURIComponent(escape(atob(o.substring(1)))).split("#")[2];
  }
  return /* @__PURE__ */ s.jsx(s.Fragment, { children: (t == null ? void 0 : t.location) && /* @__PURE__ */ s.jsx("div", { className: "text-center mb-5", children: /* @__PURE__ */ s.jsx(_t, { color: "blue", children: n.yourAddress + r(t.location) }) }) });
};
var ul = Object.defineProperty, ml = Object.defineProperties, pl = Object.getOwnPropertyDescriptors, Cr = Object.getOwnPropertySymbols, hl = Object.prototype.hasOwnProperty, fl = Object.prototype.propertyIsEnumerable, zn = (t, e, n) => e in t ? ul(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, gl = (t, e) => {
  for (var n in e || (e = {}))
    hl.call(e, n) && zn(t, n, e[n]);
  if (Cr)
    for (var n of Cr(e))
      fl.call(e, n) && zn(t, n, e[n]);
  return t;
}, vl = (t, e) => ml(t, pl(e)), R = (t, e, n) => (zn(t, typeof e != "symbol" ? e + "" : e, n), n);
const Ke = {
  required: "Toto pole je vyžadované.",
  birthNumber: "Nesprávny formát rodného čísla.",
  birthNumberLastDigits: "Nesprávny formát posledných 4 číslic z rodného čísla.",
  identificationNumber: "Nesprávny formát identifikačného čísla.",
  birthDate: "Zadajte menší dátum ako je dnešný dátum",
  dateFormat: (...t) => `Nesprávny formát dátumu. Zadajte dátum v tvare ${t[0]}.`,
  idCardNumber: "Nesprávny formát čísla dokladu.",
  idCardLastDigits: "Nesprávny formát posledných 4 číslic z občianského preukazu.",
  idCardValidity: "Zadajte dátum v budúcnosti",
  companyName: "Nesprávny formát názvu spoločnosti.",
  businessId: "Nesprávny formát IČO.",
  taxId: "Nesprávny formát DIČ.",
  vatId: "Nesprávny formát IČ DPH.",
  msisdnSk: "Zadaná hodnota musí byť slovenské telefónne číslo.",
  phoneNumber: "Nesprávny formát telefónneho čísla.",
  email: "Nesprávny formát emailu",
  simIcc: "Nesprávny formát posledného štvorčíslie novej SIM karty.",
  simCardNumber: "Nesprávny formát čísla SIM karty.",
  smartId: "Nesprávny formát bezpečnostného kódu.",
  smartIdRetype: "Bezpečnostné kódy sa nezhodujú",
  firstName: "Nesprávny formát mena.",
  lastName: "Nesprávny formát priezviska.",
  street: "Ulica môže obsahovať len písmená a/alebo číslice, prípadne bodku alebo čiarku. Maximálny počet znakov je 55.",
  streetInternational: "Ulica môže obsahovať len písmená a/alebo číslice, prípadne bodku alebo čiarku. Maximálny počet znakov je 55.",
  homeNumber: "Popisné číslo môže obsahovať len číslice a/alebo písmená, prípadne lomítko. Maximálny počet znakov je 20.",
  homeNumberInternational: "Popisné číslo môže obsahovať len číslice a/alebo písmená, prípadne lomítko. Maximálny počet znakov je 20.",
  city: "Nesprávny formát názvu mesta. Maximálny počet znakov je 40.",
  cityInternational: "Nesprávny formát názvu mesta. Maximálny počet znakov je 40.",
  zipCode: "Pole PSČ môže obsahovať len číslice. Maximálny počet znakov je 5.",
  zipCodeInternational: "Pole PSČ môže obsahovať písmena a číslice. Maximálny počet znakov je 11.",
  zipCodeForVerification: "Nesprávny formát PSČ. Zadajte ho v tvare 12345.",
  dateFrom: '"Dátum od" nemôže byť väčší ako "Dátum do".',
  dateTo: '"Dátum do" nemôže byť menší ako "Dátum od".',
  productNumber: "Nesprávny formát názvu produktu",
  decimal: "Nesprávny formát nezáporného desatinného čísla",
  promoExternalId: "Nesprávny formát Id ponuky",
  maxLength: (t) => `Maximálny počet znakov je ${t}.`,
  minLength: (t) => `Minimálny počet znakov je ${t}.`,
  promoUniversalCode: "Nesprávny formát univerzálneho kódu",
  numeric: "Nesprávny formát celého čísla",
  positiveNumeric: "Nesprávny formát celého nezáporného čísla",
  price: "Nesprávny formát ceny",
  positivePrice: "Nesprávny formát nezápornej ceny",
  residencePermit: "Nesprávny formát čísla povolenia na pobyt. Príklad: AB1234567",
  iccid: "Nesprávny formát ICCID",
  customerReferenceNumber: "Nesprávne číslo zákazníka.",
  requestOrderNumber: "Nesprávne číslo objednávky.",
  selectedCustomer: "Zákazník nebol vybratý.",
  selectedMsisdn: "Číslo nebolo vybraté.",
  idCardCheckbox: "Overenie identifikátorov musí byť zaškrtnuté.",
  alternative: {
    businessId: "Nesprávny formát IČO. Príklad: 35848863",
    idCardNumber: "Vyplňte číslo občianskeho preukazu. Príklad: SA123456",
    idCardLastDigits: "Vyplňte posledné 4 číslice z občianskeho preukazu. Príklad: 3456",
    phoneNumber: "Nesprávny formát telefónneho čísla. Príklad: 0949123456",
    birthNumber: "Nesprávny formát rodného čísla. Príklad: 999999/9999",
    birthNumberLastDigits: "Vyplňte posledné 4 číslice z rodného čísla. Príklad: 9999",
    required: "Povinný údaj."
  },
  passwordFormat: "Heslo nespĺňa podmienky",
  passwordRetype: "Zadané heslá sa nezhodujú",
  bscsCodeShort: "Nesprávny formát skráteného čísla predajne",
  bscsCode: "Nesprávny formát čísla predajne",
  sapCode: "Nesprávny formát SAP kódu",
  taxReceiptFolder: "Nesprávny formát zložky daňového dokladu",
  stockNumber: "Nesprávny formát čísla skladových zásob",
  adLogin: "Nesprávny formát prihlasovacieho mena",
  imei: "Nesprávny formát IMEI",
  contractNumber: "Nesprávny formát čísla kontraktu",
  hwContractNumber: "Nesprávny formát čísla fakturačného profilu",
  baInvoiceNumber: "Nesprávny formát čísla zmluvy na HW",
  existingSubcategory: "Podkategória sa už nachádza v zozname.",
  simSerial: "Nesprávny formát sériového čísla SIM karty",
  simPuk: "Nesprávny formát PUK kódu",
  latitude: "Nesprávny formát zemepisnej šírky",
  longitude: "Nesprávny formát zemepisnej dĺžky",
  minAge: (t) => `Osoba musí byť staršia než ${t} rokov`,
  iban: "Nesprávny formát IBAN.",
  tescoClubcard: "Zadaný formát čísla nie je správny. Prosím, uveďte platné číslo Clubcard.",
  url: "Zadaný formát URL adresy nie je správny. Prosím, zadajte platnú adresu (URL).",
  fsisdn: "Nesprávny formát. Zadajte telefónne číslo (príklad: 0949123456) alebo číslo služby (príklad: 11123456)."
}, fs = 6048e5, xl = 6e4, bl = 36e5, yl = 1e3, Er = Symbol.for("constructDateFrom");
function Ee(t, e) {
  return typeof t == "function" ? t(e) : t && typeof t == "object" && Er in t ? t[Er](e) : t instanceof Date ? new t.constructor(e) : new Date(e);
}
function _e(t, e) {
  return Ee(e || t, t);
}
function gs(t, e, n) {
  const r = _e(t, n == null ? void 0 : n.in);
  return isNaN(e) ? Ee((n == null ? void 0 : n.in) || t, NaN) : (e && r.setDate(r.getDate() + e), r);
}
let jl = {};
function bn() {
  return jl;
}
function ct(t, e) {
  var n, r, o, a, i, l, d, c;
  const u = bn(), m = (c = (d = (a = (o = e == null ? void 0 : e.weekStartsOn) != null ? o : (r = (n = e == null ? void 0 : e.locale) == null ? void 0 : n.options) == null ? void 0 : r.weekStartsOn) != null ? a : u.weekStartsOn) != null ? d : (l = (i = u.locale) == null ? void 0 : i.options) == null ? void 0 : l.weekStartsOn) != null ? c : 0, v = _e(t, e == null ? void 0 : e.in), b = v.getDay(), f = (b < m ? 7 : 0) + b - m;
  return v.setDate(v.getDate() - f), v.setHours(0, 0, 0, 0), v;
}
function Ct(t, e) {
  return ct(t, vl(gl({}, e), { weekStartsOn: 1 }));
}
function kl(t, e) {
  const n = _e(t, e == null ? void 0 : e.in), r = n.getFullYear(), o = Ee(n, 0);
  o.setFullYear(r + 1, 0, 4), o.setHours(0, 0, 0, 0);
  const a = Ct(o), i = Ee(n, 0);
  i.setFullYear(r, 0, 4), i.setHours(0, 0, 0, 0);
  const l = Ct(i);
  return n.getTime() >= a.getTime() ? r + 1 : n.getTime() >= l.getTime() ? r : r - 1;
}
function vs(t) {
  const e = _e(t), n = new Date(
    Date.UTC(
      e.getFullYear(),
      e.getMonth(),
      e.getDate(),
      e.getHours(),
      e.getMinutes(),
      e.getSeconds(),
      e.getMilliseconds()
    )
  );
  return n.setUTCFullYear(e.getFullYear()), +t - +n;
}
function Tl(t, e) {
  const n = kl(t, e), r = Ee((e == null ? void 0 : e.in) || t, 0);
  return r.setFullYear(n, 0, 4), r.setHours(0, 0, 0, 0), Ct(r);
}
function wl(t, e) {
  const n = _e(t, e == null ? void 0 : e.in), r = +Ct(n) - +Tl(n);
  return Math.round(r / fs) + 1;
}
function xs(t, e) {
  var n, r, o, a, i, l, d, c;
  const u = _e(t, e == null ? void 0 : e.in), m = u.getFullYear(), v = bn(), b = (c = (d = (a = (o = e == null ? void 0 : e.firstWeekContainsDate) != null ? o : (r = (n = e == null ? void 0 : e.locale) == null ? void 0 : n.options) == null ? void 0 : r.firstWeekContainsDate) != null ? a : v.firstWeekContainsDate) != null ? d : (l = (i = v.locale) == null ? void 0 : i.options) == null ? void 0 : l.firstWeekContainsDate) != null ? c : 1, f = Ee((e == null ? void 0 : e.in) || t, 0);
  f.setFullYear(m + 1, 0, b), f.setHours(0, 0, 0, 0);
  const k = ct(f, e), h = Ee((e == null ? void 0 : e.in) || t, 0);
  h.setFullYear(m, 0, b), h.setHours(0, 0, 0, 0);
  const p = ct(h, e);
  return +u >= +k ? m + 1 : +u >= +p ? m : m - 1;
}
function Il(t, e) {
  var n, r, o, a, i, l, d, c;
  const u = bn(), m = (c = (d = (a = (o = e == null ? void 0 : e.firstWeekContainsDate) != null ? o : (r = (n = e == null ? void 0 : e.locale) == null ? void 0 : n.options) == null ? void 0 : r.firstWeekContainsDate) != null ? a : u.firstWeekContainsDate) != null ? d : (l = (i = u.locale) == null ? void 0 : i.options) == null ? void 0 : l.firstWeekContainsDate) != null ? c : 1, v = xs(t, e), b = Ee((e == null ? void 0 : e.in) || t, 0);
  return b.setFullYear(v, 0, m), b.setHours(0, 0, 0, 0), ct(b, e);
}
function Nl(t, e) {
  const n = _e(t, e == null ? void 0 : e.in), r = +ct(n, e) - +Il(n, e);
  return Math.round(r / fs) + 1;
}
function Sl(t, e) {
  const n = _e(t, e == null ? void 0 : e.in).getDay();
  return n === 0 ? 7 : n;
}
class Ol {
  constructor() {
    R(this, "subPriority", 0);
  }
  validate(e, n) {
    return !0;
  }
}
class Pl extends Ol {
  constructor(e, n, r, o, a) {
    super(), this.value = e, this.validateValue = n, this.setValue = r, this.priority = o, a && (this.subPriority = a);
  }
  validate(e, n) {
    return this.validateValue(e, this.value, n);
  }
  set(e, n, r) {
    return this.setValue(e, n, this.value, r);
  }
}
class Z {
  run(e, n, r, o) {
    const a = this.parse(e, n, r, o);
    return a ? {
      setter: new Pl(
        a.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: a.rest
    } : null;
  }
  validate(e, n, r) {
    return !0;
  }
}
class Ml extends Z {
  constructor() {
    super(...arguments), R(this, "priority", 140), R(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(e, n, r) {
    switch (n) {
      case "G":
      case "GG":
      case "GGG":
        return r.era(e, { width: "abbreviated" }) || r.era(e, { width: "narrow" });
      case "GGGGG":
        return r.era(e, { width: "narrow" });
      case "GGGG":
      default:
        return r.era(e, { width: "wide" }) || r.era(e, { width: "abbreviated" }) || r.era(e, { width: "narrow" });
    }
  }
  set(e, n, r) {
    return n.era = r, e.setFullYear(r, 0, 1), e.setHours(0, 0, 0, 0), e;
  }
}
const pe = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, $e = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function he(t, e) {
  return t && {
    value: e(t.value),
    rest: t.rest
  };
}
function oe(t, e) {
  const n = e.match(t);
  return n ? {
    value: parseInt(n[0], 10),
    rest: e.slice(n[0].length)
  } : null;
}
function Ve(t, e) {
  const n = e.match(t);
  if (!n)
    return null;
  if (n[0] === "Z")
    return {
      value: 0,
      rest: e.slice(1)
    };
  const r = n[1] === "+" ? 1 : -1, o = n[2] ? parseInt(n[2], 10) : 0, a = n[3] ? parseInt(n[3], 10) : 0, i = n[5] ? parseInt(n[5], 10) : 0;
  return {
    value: r * (o * bl + a * xl + i * yl),
    rest: e.slice(n[0].length)
  };
}
function bs(t) {
  return oe(pe.anyDigitsSigned, t);
}
function de(t, e) {
  switch (t) {
    case 1:
      return oe(pe.singleDigit, e);
    case 2:
      return oe(pe.twoDigits, e);
    case 3:
      return oe(pe.threeDigits, e);
    case 4:
      return oe(pe.fourDigits, e);
    default:
      return oe(new RegExp("^\\d{1," + t + "}"), e);
  }
}
function ys(t, e) {
  switch (t) {
    case 1:
      return oe(pe.singleDigitSigned, e);
    case 2:
      return oe(pe.twoDigitsSigned, e);
    case 3:
      return oe(pe.threeDigitsSigned, e);
    case 4:
      return oe(pe.fourDigitsSigned, e);
    default:
      return oe(new RegExp("^-?\\d{1," + t + "}"), e);
  }
}
function ar(t) {
  switch (t) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function js(t, e) {
  const n = e > 0, r = n ? e : 1 - e;
  let o;
  if (r <= 50)
    o = t || 100;
  else {
    const a = r + 50, i = Math.trunc(a / 100) * 100, l = t >= a % 100;
    o = t + i - (l ? 100 : 0);
  }
  return n ? o : 1 - o;
}
function ks(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
class Cl extends Z {
  constructor() {
    super(...arguments), R(this, "priority", 130), R(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(e, n, r) {
    const o = (a) => ({
      year: a,
      isTwoDigitYear: n === "yy"
    });
    switch (n) {
      case "y":
        return he(de(4, e), o);
      case "yo":
        return he(
          r.ordinalNumber(e, {
            unit: "year"
          }),
          o
        );
      default:
        return he(de(n.length, e), o);
    }
  }
  validate(e, n) {
    return n.isTwoDigitYear || n.year > 0;
  }
  set(e, n, r) {
    const o = e.getFullYear();
    if (r.isTwoDigitYear) {
      const i = js(
        r.year,
        o
      );
      return e.setFullYear(i, 0, 1), e.setHours(0, 0, 0, 0), e;
    }
    const a = !("era" in n) || n.era === 1 ? r.year : 1 - r.year;
    return e.setFullYear(a, 0, 1), e.setHours(0, 0, 0, 0), e;
  }
}
class El extends Z {
  constructor() {
    super(...arguments), R(this, "priority", 130), R(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(e, n, r) {
    const o = (a) => ({
      year: a,
      isTwoDigitYear: n === "YY"
    });
    switch (n) {
      case "Y":
        return he(de(4, e), o);
      case "Yo":
        return he(
          r.ordinalNumber(e, {
            unit: "year"
          }),
          o
        );
      default:
        return he(de(n.length, e), o);
    }
  }
  validate(e, n) {
    return n.isTwoDigitYear || n.year > 0;
  }
  set(e, n, r, o) {
    const a = xs(e, o);
    if (r.isTwoDigitYear) {
      const l = js(
        r.year,
        a
      );
      return e.setFullYear(
        l,
        0,
        o.firstWeekContainsDate
      ), e.setHours(0, 0, 0, 0), ct(e, o);
    }
    const i = !("era" in n) || n.era === 1 ? r.year : 1 - r.year;
    return e.setFullYear(i, 0, o.firstWeekContainsDate), e.setHours(0, 0, 0, 0), ct(e, o);
  }
}
class _l extends Z {
  constructor() {
    super(...arguments), R(this, "priority", 130), R(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, n) {
    return ys(n === "R" ? 4 : n.length, e);
  }
  set(e, n, r) {
    const o = Ee(e, 0);
    return o.setFullYear(r, 0, 4), o.setHours(0, 0, 0, 0), Ct(o);
  }
}
class Al extends Z {
  constructor() {
    super(...arguments), R(this, "priority", 130), R(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(e, n) {
    return ys(n === "u" ? 4 : n.length, e);
  }
  set(e, n, r) {
    return e.setFullYear(r, 0, 1), e.setHours(0, 0, 0, 0), e;
  }
}
class Rl extends Z {
  constructor() {
    super(...arguments), R(this, "priority", 120), R(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, n, r) {
    switch (n) {
      case "Q":
      case "QQ":
        return de(n.length, e);
      case "Qo":
        return r.ordinalNumber(e, { unit: "quarter" });
      case "QQQ":
        return r.quarter(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.quarter(e, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQQ":
        return r.quarter(e, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return r.quarter(e, {
          width: "wide",
          context: "formatting"
        }) || r.quarter(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.quarter(e, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(e, n) {
    return n >= 1 && n <= 4;
  }
  set(e, n, r) {
    return e.setMonth((r - 1) * 3, 1), e.setHours(0, 0, 0, 0), e;
  }
}
class Dl extends Z {
  constructor() {
    super(...arguments), R(this, "priority", 120), R(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, n, r) {
    switch (n) {
      case "q":
      case "qq":
        return de(n.length, e);
      case "qo":
        return r.ordinalNumber(e, { unit: "quarter" });
      case "qqq":
        return r.quarter(e, {
          width: "abbreviated",
          context: "standalone"
        }) || r.quarter(e, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqqq":
        return r.quarter(e, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return r.quarter(e, {
          width: "wide",
          context: "standalone"
        }) || r.quarter(e, {
          width: "abbreviated",
          context: "standalone"
        }) || r.quarter(e, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(e, n) {
    return n >= 1 && n <= 4;
  }
  set(e, n, r) {
    return e.setMonth((r - 1) * 3, 1), e.setHours(0, 0, 0, 0), e;
  }
}
class zl extends Z {
  constructor() {
    super(...arguments), R(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]), R(this, "priority", 110);
  }
  parse(e, n, r) {
    const o = (a) => a - 1;
    switch (n) {
      case "M":
        return he(
          oe(pe.month, e),
          o
        );
      case "MM":
        return he(de(2, e), o);
      case "Mo":
        return he(
          r.ordinalNumber(e, {
            unit: "month"
          }),
          o
        );
      case "MMM":
        return r.month(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.month(e, { width: "narrow", context: "formatting" });
      case "MMMMM":
        return r.month(e, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return r.month(e, { width: "wide", context: "formatting" }) || r.month(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.month(e, { width: "narrow", context: "formatting" });
    }
  }
  validate(e, n) {
    return n >= 0 && n <= 11;
  }
  set(e, n, r) {
    return e.setMonth(r, 1), e.setHours(0, 0, 0, 0), e;
  }
}
class Ll extends Z {
  constructor() {
    super(...arguments), R(this, "priority", 110), R(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, n, r) {
    const o = (a) => a - 1;
    switch (n) {
      case "L":
        return he(
          oe(pe.month, e),
          o
        );
      case "LL":
        return he(de(2, e), o);
      case "Lo":
        return he(
          r.ordinalNumber(e, {
            unit: "month"
          }),
          o
        );
      case "LLL":
        return r.month(e, {
          width: "abbreviated",
          context: "standalone"
        }) || r.month(e, { width: "narrow", context: "standalone" });
      case "LLLLL":
        return r.month(e, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return r.month(e, { width: "wide", context: "standalone" }) || r.month(e, {
          width: "abbreviated",
          context: "standalone"
        }) || r.month(e, { width: "narrow", context: "standalone" });
    }
  }
  validate(e, n) {
    return n >= 0 && n <= 11;
  }
  set(e, n, r) {
    return e.setMonth(r, 1), e.setHours(0, 0, 0, 0), e;
  }
}
function Fl(t, e, n) {
  const r = _e(t, n == null ? void 0 : n.in), o = Nl(r, n) - e;
  return r.setDate(r.getDate() - o * 7), _e(r, n == null ? void 0 : n.in);
}
class Bl extends Z {
  constructor() {
    super(...arguments), R(this, "priority", 100), R(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(e, n, r) {
    switch (n) {
      case "w":
        return oe(pe.week, e);
      case "wo":
        return r.ordinalNumber(e, { unit: "week" });
      default:
        return de(n.length, e);
    }
  }
  validate(e, n) {
    return n >= 1 && n <= 53;
  }
  set(e, n, r, o) {
    return ct(Fl(e, r, o), o);
  }
}
function Hl(t, e, n) {
  const r = _e(t, n == null ? void 0 : n.in), o = wl(r, n) - e;
  return r.setDate(r.getDate() - o * 7), r;
}
class Ul extends Z {
  constructor() {
    super(...arguments), R(this, "priority", 100), R(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, n, r) {
    switch (n) {
      case "I":
        return oe(pe.week, e);
      case "Io":
        return r.ordinalNumber(e, { unit: "week" });
      default:
        return de(n.length, e);
    }
  }
  validate(e, n) {
    return n >= 1 && n <= 53;
  }
  set(e, n, r) {
    return Ct(Hl(e, r));
  }
}
const $l = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Vl = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class Gl extends Z {
  constructor() {
    super(...arguments), R(this, "priority", 90), R(this, "subPriority", 1), R(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, n, r) {
    switch (n) {
      case "d":
        return oe(pe.date, e);
      case "do":
        return r.ordinalNumber(e, { unit: "date" });
      default:
        return de(n.length, e);
    }
  }
  validate(e, n) {
    const r = e.getFullYear(), o = ks(r), a = e.getMonth();
    return o ? n >= 1 && n <= Vl[a] : n >= 1 && n <= $l[a];
  }
  set(e, n, r) {
    return e.setDate(r), e.setHours(0, 0, 0, 0), e;
  }
}
class Ql extends Z {
  constructor() {
    super(...arguments), R(this, "priority", 90), R(this, "subpriority", 1), R(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, n, r) {
    switch (n) {
      case "D":
      case "DD":
        return oe(pe.dayOfYear, e);
      case "Do":
        return r.ordinalNumber(e, { unit: "date" });
      default:
        return de(n.length, e);
    }
  }
  validate(e, n) {
    const r = e.getFullYear();
    return ks(r) ? n >= 1 && n <= 366 : n >= 1 && n <= 365;
  }
  set(e, n, r) {
    return e.setMonth(0, r), e.setHours(0, 0, 0, 0), e;
  }
}
function ir(t, e, n) {
  var r, o, a, i, l, d, c, u;
  const m = bn(), v = (u = (c = (i = (a = n == null ? void 0 : n.weekStartsOn) != null ? a : (o = (r = n == null ? void 0 : n.locale) == null ? void 0 : r.options) == null ? void 0 : o.weekStartsOn) != null ? i : m.weekStartsOn) != null ? c : (d = (l = m.locale) == null ? void 0 : l.options) == null ? void 0 : d.weekStartsOn) != null ? u : 0, b = _e(t, n == null ? void 0 : n.in), f = b.getDay(), k = (e % 7 + 7) % 7, h = 7 - v, p = e < 0 || e > 6 ? e - (f + h) % 7 : (k + h) % 7 - (f + h) % 7;
  return gs(b, p, n);
}
class Wl extends Z {
  constructor() {
    super(...arguments), R(this, "priority", 90), R(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(e, n, r) {
    switch (n) {
      case "E":
      case "EE":
      case "EEE":
        return r.day(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(e, { width: "short", context: "formatting" }) || r.day(e, { width: "narrow", context: "formatting" });
      case "EEEEE":
        return r.day(e, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return r.day(e, { width: "short", context: "formatting" }) || r.day(e, { width: "narrow", context: "formatting" });
      case "EEEE":
      default:
        return r.day(e, { width: "wide", context: "formatting" }) || r.day(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(e, { width: "short", context: "formatting" }) || r.day(e, { width: "narrow", context: "formatting" });
    }
  }
  validate(e, n) {
    return n >= 0 && n <= 6;
  }
  set(e, n, r, o) {
    return e = ir(e, r, o), e.setHours(0, 0, 0, 0), e;
  }
}
class Yl extends Z {
  constructor() {
    super(...arguments), R(this, "priority", 90), R(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, n, r, o) {
    const a = (i) => {
      const l = Math.floor((i - 1) / 7) * 7;
      return (i + o.weekStartsOn + 6) % 7 + l;
    };
    switch (n) {
      case "e":
      case "ee":
        return he(de(n.length, e), a);
      case "eo":
        return he(
          r.ordinalNumber(e, {
            unit: "day"
          }),
          a
        );
      case "eee":
        return r.day(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(e, { width: "short", context: "formatting" }) || r.day(e, { width: "narrow", context: "formatting" });
      case "eeeee":
        return r.day(e, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return r.day(e, { width: "short", context: "formatting" }) || r.day(e, { width: "narrow", context: "formatting" });
      case "eeee":
      default:
        return r.day(e, { width: "wide", context: "formatting" }) || r.day(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(e, { width: "short", context: "formatting" }) || r.day(e, { width: "narrow", context: "formatting" });
    }
  }
  validate(e, n) {
    return n >= 0 && n <= 6;
  }
  set(e, n, r, o) {
    return e = ir(e, r, o), e.setHours(0, 0, 0, 0), e;
  }
}
class Zl extends Z {
  constructor() {
    super(...arguments), R(this, "priority", 90), R(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(e, n, r, o) {
    const a = (i) => {
      const l = Math.floor((i - 1) / 7) * 7;
      return (i + o.weekStartsOn + 6) % 7 + l;
    };
    switch (n) {
      case "c":
      case "cc":
        return he(de(n.length, e), a);
      case "co":
        return he(
          r.ordinalNumber(e, {
            unit: "day"
          }),
          a
        );
      case "ccc":
        return r.day(e, {
          width: "abbreviated",
          context: "standalone"
        }) || r.day(e, { width: "short", context: "standalone" }) || r.day(e, { width: "narrow", context: "standalone" });
      case "ccccc":
        return r.day(e, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return r.day(e, { width: "short", context: "standalone" }) || r.day(e, { width: "narrow", context: "standalone" });
      case "cccc":
      default:
        return r.day(e, { width: "wide", context: "standalone" }) || r.day(e, {
          width: "abbreviated",
          context: "standalone"
        }) || r.day(e, { width: "short", context: "standalone" }) || r.day(e, { width: "narrow", context: "standalone" });
    }
  }
  validate(e, n) {
    return n >= 0 && n <= 6;
  }
  set(e, n, r, o) {
    return e = ir(e, r, o), e.setHours(0, 0, 0, 0), e;
  }
}
function Xl(t, e, n) {
  const r = _e(t, n == null ? void 0 : n.in), o = Sl(r, n), a = e - o;
  return gs(r, a, n);
}
class Kl extends Z {
  constructor() {
    super(...arguments), R(this, "priority", 90), R(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, n, r) {
    const o = (a) => a === 0 ? 7 : a;
    switch (n) {
      case "i":
      case "ii":
        return de(n.length, e);
      case "io":
        return r.ordinalNumber(e, { unit: "day" });
      case "iii":
        return he(
          r.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || r.day(e, {
            width: "short",
            context: "formatting"
          }) || r.day(e, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
      case "iiiii":
        return he(
          r.day(e, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
      case "iiiiii":
        return he(
          r.day(e, {
            width: "short",
            context: "formatting"
          }) || r.day(e, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
      case "iiii":
      default:
        return he(
          r.day(e, {
            width: "wide",
            context: "formatting"
          }) || r.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || r.day(e, {
            width: "short",
            context: "formatting"
          }) || r.day(e, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
    }
  }
  validate(e, n) {
    return n >= 1 && n <= 7;
  }
  set(e, n, r) {
    return e = Xl(e, r), e.setHours(0, 0, 0, 0), e;
  }
}
class ql extends Z {
  constructor() {
    super(...arguments), R(this, "priority", 80), R(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(e, n, r) {
    switch (n) {
      case "a":
      case "aa":
      case "aaa":
        return r.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return r.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(e, {
          width: "wide",
          context: "formatting"
        }) || r.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(e, n, r) {
    return e.setHours(ar(r), 0, 0, 0), e;
  }
}
class Jl extends Z {
  constructor() {
    super(...arguments), R(this, "priority", 80), R(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(e, n, r) {
    switch (n) {
      case "b":
      case "bb":
      case "bbb":
        return r.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return r.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(e, {
          width: "wide",
          context: "formatting"
        }) || r.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(e, n, r) {
    return e.setHours(ar(r), 0, 0, 0), e;
  }
}
class ed extends Z {
  constructor() {
    super(...arguments), R(this, "priority", 80), R(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(e, n, r) {
    switch (n) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(e, {
          width: "wide",
          context: "formatting"
        }) || r.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(e, n, r) {
    return e.setHours(ar(r), 0, 0, 0), e;
  }
}
class td extends Z {
  constructor() {
    super(...arguments), R(this, "priority", 70), R(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(e, n, r) {
    switch (n) {
      case "h":
        return oe(pe.hour12h, e);
      case "ho":
        return r.ordinalNumber(e, { unit: "hour" });
      default:
        return de(n.length, e);
    }
  }
  validate(e, n) {
    return n >= 1 && n <= 12;
  }
  set(e, n, r) {
    const o = e.getHours() >= 12;
    return o && r < 12 ? e.setHours(r + 12, 0, 0, 0) : !o && r === 12 ? e.setHours(0, 0, 0, 0) : e.setHours(r, 0, 0, 0), e;
  }
}
class nd extends Z {
  constructor() {
    super(...arguments), R(this, "priority", 70), R(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(e, n, r) {
    switch (n) {
      case "H":
        return oe(pe.hour23h, e);
      case "Ho":
        return r.ordinalNumber(e, { unit: "hour" });
      default:
        return de(n.length, e);
    }
  }
  validate(e, n) {
    return n >= 0 && n <= 23;
  }
  set(e, n, r) {
    return e.setHours(r, 0, 0, 0), e;
  }
}
class rd extends Z {
  constructor() {
    super(...arguments), R(this, "priority", 70), R(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(e, n, r) {
    switch (n) {
      case "K":
        return oe(pe.hour11h, e);
      case "Ko":
        return r.ordinalNumber(e, { unit: "hour" });
      default:
        return de(n.length, e);
    }
  }
  validate(e, n) {
    return n >= 0 && n <= 11;
  }
  set(e, n, r) {
    return e.getHours() >= 12 && r < 12 ? e.setHours(r + 12, 0, 0, 0) : e.setHours(r, 0, 0, 0), e;
  }
}
class sd extends Z {
  constructor() {
    super(...arguments), R(this, "priority", 70), R(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(e, n, r) {
    switch (n) {
      case "k":
        return oe(pe.hour24h, e);
      case "ko":
        return r.ordinalNumber(e, { unit: "hour" });
      default:
        return de(n.length, e);
    }
  }
  validate(e, n) {
    return n >= 1 && n <= 24;
  }
  set(e, n, r) {
    const o = r <= 24 ? r % 24 : r;
    return e.setHours(o, 0, 0, 0), e;
  }
}
class od extends Z {
  constructor() {
    super(...arguments), R(this, "priority", 60), R(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(e, n, r) {
    switch (n) {
      case "m":
        return oe(pe.minute, e);
      case "mo":
        return r.ordinalNumber(e, { unit: "minute" });
      default:
        return de(n.length, e);
    }
  }
  validate(e, n) {
    return n >= 0 && n <= 59;
  }
  set(e, n, r) {
    return e.setMinutes(r, 0, 0), e;
  }
}
class ad extends Z {
  constructor() {
    super(...arguments), R(this, "priority", 50), R(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(e, n, r) {
    switch (n) {
      case "s":
        return oe(pe.second, e);
      case "so":
        return r.ordinalNumber(e, { unit: "second" });
      default:
        return de(n.length, e);
    }
  }
  validate(e, n) {
    return n >= 0 && n <= 59;
  }
  set(e, n, r) {
    return e.setSeconds(r, 0), e;
  }
}
class id extends Z {
  constructor() {
    super(...arguments), R(this, "priority", 30), R(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(e, n) {
    const r = (o) => Math.trunc(o * Math.pow(10, -n.length + 3));
    return he(de(n.length, e), r);
  }
  set(e, n, r) {
    return e.setMilliseconds(r), e;
  }
}
class ld extends Z {
  constructor() {
    super(...arguments), R(this, "priority", 10), R(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(e, n) {
    switch (n) {
      case "X":
        return Ve(
          $e.basicOptionalMinutes,
          e
        );
      case "XX":
        return Ve($e.basic, e);
      case "XXXX":
        return Ve(
          $e.basicOptionalSeconds,
          e
        );
      case "XXXXX":
        return Ve(
          $e.extendedOptionalSeconds,
          e
        );
      case "XXX":
      default:
        return Ve($e.extended, e);
    }
  }
  set(e, n, r) {
    return n.timestampIsSet ? e : Ee(
      e,
      e.getTime() - vs(e) - r
    );
  }
}
class dd extends Z {
  constructor() {
    super(...arguments), R(this, "priority", 10), R(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(e, n) {
    switch (n) {
      case "x":
        return Ve(
          $e.basicOptionalMinutes,
          e
        );
      case "xx":
        return Ve($e.basic, e);
      case "xxxx":
        return Ve(
          $e.basicOptionalSeconds,
          e
        );
      case "xxxxx":
        return Ve(
          $e.extendedOptionalSeconds,
          e
        );
      case "xxx":
      default:
        return Ve($e.extended, e);
    }
  }
  set(e, n, r) {
    return n.timestampIsSet ? e : Ee(
      e,
      e.getTime() - vs(e) - r
    );
  }
}
class cd extends Z {
  constructor() {
    super(...arguments), R(this, "priority", 40), R(this, "incompatibleTokens", "*");
  }
  parse(e) {
    return bs(e);
  }
  set(e, n, r) {
    return [Ee(e, r * 1e3), { timestampIsSet: !0 }];
  }
}
class ud extends Z {
  constructor() {
    super(...arguments), R(this, "priority", 20), R(this, "incompatibleTokens", "*");
  }
  parse(e) {
    return bs(e);
  }
  set(e, n, r) {
    return [Ee(e, r), { timestampIsSet: !0 }];
  }
}
new Ml(), new Cl(), new El(), new _l(), new Al(), new Rl(), new Dl(), new zl(), new Ll(), new Bl(), new Ul(), new Gl(), new Ql(), new Wl(), new Yl(), new Zl(), new Kl(), new ql(), new Jl(), new ed(), new td(), new nd(), new rd(), new sd(), new od(), new ad(), new id(), new ld(), new dd(), new cd(), new ud();
function ut(t) {
  return t ? void 0 : Ke.required;
}
function Ts(t, e) {
  if (!t)
    return e ? void 0 : Ke.required;
  if (!t.match(/^((\+|00)?421\s?|0?)9\d{2}\s?(\d{3}\s?\d{3}|\d{2}\s?\d{2}\s?\d{2})$/g))
    return Ke.msisdnSk;
}
function md(t, e, n) {
  if (!t)
    return n ? void 0 : Ke.required;
  if (e) {
    if (!t.match(/^[0-9]+$/g))
      return Ke.positiveNumeric;
  } else if (!t.match(/^-?[0-9]+$/g))
    return Ke.numeric;
}
function ws(t, e) {
  if (!t)
    return e ? void 0 : Ke.required;
  const n = 15, r = 34, o = BigInt("97"), a = t.trim().toUpperCase().replaceAll(/([A-Z0-9]{3}) /gu, "$1");
  if (!a.match(/^[A-Z0-9]+$/gu) || a.length < n || a.length > r)
    return Ke.iban;
  const i = [...a.substring(4) + a.substring(0, 4)].map((l) => l >= "0" && l <= "9" ? l : l.charCodeAt(0) - "A".charCodeAt(0) + 10).join("");
  if (BigInt(i) % o !== BigInt("1"))
    return Ke.iban;
}
const pd = ({ showModal: t }) => {
  const { setFieldValue: e } = ee(), { unionText: n } = O(), { internetMoreInfoMessages: r } = n;
  return /* @__PURE__ */ s.jsxs("div", { className: "mt-2", children: [
    /* @__PURE__ */ s.jsx("h3", { id: "h1_label", className: "text-center mt-5 mb-3", children: r.eic.title }),
    /* @__PURE__ */ s.jsx(
      Oe,
      {
        as: vt,
        label: r.eic.eicLabel,
        placeholder: r.eic.placeholder,
        "data-testid": "material-ean-sn-input",
        name: "eic",
        validate: ut,
        required: !0,
        onChange: (o) => {
          e("eic", o != null ? o : "");
        }
      }
    ),
    /* @__PURE__ */ s.jsxs(
      "a",
      {
        id: "open-more-info-eic",
        "data-testid": "open-more-info-eic",
        className: "text-small d-flex align-items-center gap-1 mt-3",
        onClick: () => {
          t(
            r.eic.modal.heading,
            /* @__PURE__ */ s.jsx("span", { dangerouslySetInnerHTML: { __html: r.eic.modal.text } })
          );
        },
        children: [
          r.eic.moreInfo,
          " ",
          /* @__PURE__ */ s.jsx(pt, { size: 18 })
        ]
      }
    )
  ] });
}, hd = ({ floors: t }) => {
  const { setFieldValue: e } = ee(), { unionText: n } = O(), { internetMoreInfoMessages: r } = n;
  return /* @__PURE__ */ s.jsxs("div", { className: "mt-2", children: [
    /* @__PURE__ */ s.jsx("h3", { id: "h1_label", className: "text-center mt-5 mb-3", children: r.floor.title }),
    /* @__PURE__ */ s.jsx(
      Oe,
      {
        as: rn,
        className: "mt-2 mb-2",
        "data-testid": "donor-code-select",
        name: "floor",
        placeholder: r.floor.placeholder,
        label: r.floor.floorLabel,
        onChange: (o) => {
          e("floor", o != null ? o : "");
        },
        errorMessage: r.required,
        validate: ut,
        required: !0,
        children: t == null ? void 0 : t.map((o, a) => {
          var i;
          return (
            // index as a key is ok, the list does not change
            /* @__PURE__ */ s.jsx(
              rn.Item,
              {
                value: o.value,
                text: (i = o.text) != null ? i : o.value
              },
              a
            )
          );
        })
      }
    )
  ] });
}, fd = () => {
  const { setFieldValue: t } = ee(), { unionText: e } = O(), { internetMoreInfoMessages: n } = e;
  return /* @__PURE__ */ s.jsxs("div", { className: "mt-2", children: [
    /* @__PURE__ */ s.jsx("h3", { id: "h1_label", className: "text-center mt-5 mb-3", children: n.floor.title }),
    /* @__PURE__ */ s.jsx(
      Oe,
      {
        as: vt,
        className: "mt-2 mb-2",
        "data-testid": "donor-code-select",
        name: "floor",
        label: n.floor.floorLabel,
        placeholder: n.floor.inputPlaceholder,
        onChange: (r) => {
          t("floor", r != null ? r : "");
        },
        validate: ut,
        required: !0
      }
    ),
    /* @__PURE__ */ s.jsx(
      Oe,
      {
        as: vt,
        className: "mt-2 mb-2",
        "data-testid": "donor-code-select",
        name: "apartment",
        label: n.floor.apartmentLabel,
        placeholder: n.floor.inputPlaceholder,
        onChange: (r) => {
          t("apartment", r != null ? r : "");
        },
        validate: ut,
        required: !0
      }
    )
  ] });
}, _r = ({ optionPortInType: t, programType: e, showModal: n }) => {
  const { values: r } = ee(), { unionText: o } = O(), { internetPortInMessages: a } = o;
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsxs(
      Bn,
      {
        value: t,
        "data-o2-id": "radio-item-" + t,
        "data-testid": "radio-item-" + t,
        name: "portInType",
        className: "pt-3 pb-3",
        children: [
          a[t].label,
          /* @__PURE__ */ s.jsx("div", { className: "text-secondary text-small", children: a[t].labelSecondary })
        ]
      },
      "portin-false"
    ),
    r.portInType === t && /* @__PURE__ */ s.jsxs(Ge, { className: "mb-3", children: [
      /* @__PURE__ */ s.jsx("span", { dangerouslySetInnerHTML: { __html: a[t].alert } }),
      e && /* @__PURE__ */ s.jsxs(
        "a",
        {
          id: "open-more-info-" + t + "-" + e,
          "data-testid": "open-more-info-" + t + "-" + e,
          className: "text-small d-flex align-items-center gap-1 mt-3",
          onClick: () => {
            n(
              a.moreInfo,
              /* @__PURE__ */ s.jsx("div", { children: Object.values(a[t].moreInfoModal[e]).map(
                (i, l) => /* @__PURE__ */ s.jsxs("div", { className: "mt-3", children: [
                  /* @__PURE__ */ s.jsx("h6", { children: i.title }),
                  /* @__PURE__ */ s.jsx("span", { className: "text-secondary", children: i.content })
                ] }, l)
              ) })
            );
          },
          children: [
            a.moreInfo,
            " ",
            /* @__PURE__ */ s.jsx(pt, { size: 18 })
          ]
        }
      )
    ] })
  ] });
}, gd = ({ portInData: t, loading: e, showModal: n }) => {
  const { setFieldValue: r } = ee();
  return /* @__PURE__ */ s.jsx(s.Fragment, { children: /* @__PURE__ */ s.jsxs(
    Oe,
    {
      as: Fn,
      "aria-label": "h1_label",
      name: "portInType",
      direction: "column",
      w: 100,
      className: "w-100",
      "data-o2-id": "select-installationType-radio-group",
      "data-testid": "select-installationType-radio-group",
      onChange: (o) => {
        r("portInType", o != null ? o : "");
      },
      disabled: e,
      children: [
        /* @__PURE__ */ s.jsx("hr", { className: "mt-1 mb-1" }),
        /* @__PURE__ */ s.jsx(_r, { optionPortInType: "PORT_IN", programType: t == null ? void 0 : t.programType, showModal: n }),
        /* @__PURE__ */ s.jsx("hr", { className: "mt-1 mb-1" }),
        /* @__PURE__ */ s.jsx(_r, { optionPortInType: "NO_PORT_IN", programType: t == null ? void 0 : t.programType, showModal: n }),
        /* @__PURE__ */ s.jsx("hr", { className: "mt-1 mb-1" })
      ]
    }
  ) });
}, vd = ({ htmlDescription: t }) => {
  const { setFieldValue: e, values: n } = ee(), r = $(() => Ft(t, "section_donor_billing_profile_id"), [t]), o = $(() => Ft(r, "label"), [r]), a = $(() => Ft(r, "hint"), [r]), i = $(() => Ft(r, "heading"), [r]), l = $(() => Ft(r, "description"), [r]);
  return S(() => {
    e("donorBillingProfileIdValid", !r || n.donorBillingProfileId);
  }, [e, r, n.donorBillingProfileId]), /* @__PURE__ */ s.jsx(s.Fragment, { children: r && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsx(
      Pt,
      {
        as: vt,
        label: o,
        placeholder: a,
        "data-testid": "donor_billing_profile_id",
        name: "donorBillingProfileId",
        required: !0,
        validate: ut
      }
    ),
    l && /* @__PURE__ */ s.jsx(Ge, { mt: 3, mb: 3, heading: i, children: /* @__PURE__ */ s.jsx("span", { dangerouslySetInnerHTML: { __html: l } }) })
  ] }) });
}, xd = ({ operators: t, portInOperatorData: e }) => {
  const { setFieldValue: n, values: r, touched: o, setTouched: a } = ee(), { config: i } = P(K), [l, d] = w("aaa"), { unionText: c } = O(), { internetPortInOperatorMessages: u } = c;
  S(() => {
    d(() => {
      const f = ut(r.donorServiceId);
      if (f && o.donorServiceId)
        return f;
      if (Dn(e, r))
        return u.donorServiceIdUnrecognized;
    });
  }, [u, e, r, o]);
  const m = $(() => {
    if (t === void 0)
      return null;
    const f = t == null ? void 0 : t.filter((k) => k.code === r.donorCode);
    return f.length === 0 ? null : f[0];
  }, [t, r.donorCode]), v = $(() => ki(m == null ? void 0 : m.htmlDescription), [m]), b = $(() => {
    var f;
    return m != null && m.htmlDescription ? (f = m == null ? void 0 : m.serviceIdHint) != null ? f : "" : m != null && m.serviceIdHint ? m == null ? void 0 : m.serviceIdHint : u.otherOperator.donorServiceIdPlaceholder;
  }, [m, u.otherOperator.donorServiceIdPlaceholder]);
  return /* @__PURE__ */ s.jsxs("div", { className: "mt-2", children: [
    /* @__PURE__ */ s.jsx(
      Pt,
      {
        as: rn,
        className: "mt-2 mb-2",
        "data-testid": "donor-code-select",
        name: "donorCode",
        label: u.otherOperator.donorCode,
        placeholder: u.otherOperator.donorCodePlaceholder,
        onChange: (f) => {
          n("donorCode", f != null ? f : "");
        },
        validate: ut,
        required: !0,
        children: t == null ? void 0 : t.map((f, k) => {
          var h;
          return (
            // index as a key is ok, the list does not change
            /* @__PURE__ */ s.jsx(
              rn.Item,
              {
                value: f.code,
                text: (h = f.description) != null ? h : ""
              },
              k
            )
          );
        })
      }
    ),
    /* @__PURE__ */ s.jsx(vd, { htmlDescription: m == null ? void 0 : m.htmlDescription }),
    /* @__PURE__ */ s.jsx(
      Pt,
      {
        as: vt,
        label: u.otherOperator.donorServiceId,
        placeholder: b,
        "data-testid": "donor-service-id",
        name: "donorServiceId",
        required: !0,
        error: !!l,
        errorMessage: l,
        onChange: (f) => {
          n("donorServiceId", f != null ? f : "");
        }
      }
    ),
    Dn(e, r) && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      i.assistantSignedIn && /* @__PURE__ */ s.jsx(Ge, { mt: 3, mb: 3, color: "warning", heading: u.otherOperator.alert.heading, children: /* @__PURE__ */ s.jsx(
        "span",
        {
          dangerouslySetInnerHTML: { __html: u.otherOperator.alert.textAssistant }
        }
      ) }),
      !i.assistantSignedIn && /* @__PURE__ */ s.jsx(Ge, { mt: 3, mb: 3, color: "warning", heading: u.otherOperator.alert.heading, children: /* @__PURE__ */ s.jsx("span", { dangerouslySetInnerHTML: { __html: u.otherOperator.alert.text } }) })
    ] }),
    r.donorCode && /* @__PURE__ */ s.jsxs(Ge, { mt: 3, mb: 3, heading: u.otherOperator.serviceIdDescription.heading, children: [
      v && /* @__PURE__ */ s.jsx("span", { dangerouslySetInnerHTML: { __html: v } }),
      !v && /* @__PURE__ */ s.jsx(
        "span",
        {
          dangerouslySetInnerHTML: {
            __html: u.otherOperator.serviceIdDescription.defaultHtmlDescription
          }
        }
      )
    ] }),
    !1
  ] });
}, lr = ({ children: t, howItWorks: e, anchorId: n, description: r, hint: o }) => {
  const [a, i] = w(), { unionText: l } = O(), { chooseTransactionMessages: d } = l;
  return /* @__PURE__ */ s.jsx(s.Fragment, { children: /* @__PURE__ */ s.jsxs(
    xt,
    {
      background: "blue-light",
      heading: "",
      className: "mb-4",
      "data-o2-id": "radio-content-box-" + n,
      "data-testid": "radio-content-box-" + n,
      children: [
        t,
        /* @__PURE__ */ s.jsx("div", { className: "mb-1", children: e }),
        /* @__PURE__ */ s.jsxs(
          "a",
          {
            className: "no-href text-small",
            id: n,
            "data-o2-id": n,
            "data-testid": n,
            onClick: (c) => {
              var u;
              c == null || c.preventDefault(), (u = a == null ? void 0 : a.current) == null || u.show();
            },
            children: [
              n === "portin-modal" ? d.learnMore : d.readMore,
              " ",
              /* @__PURE__ */ s.jsx(Q, { name: "info-circle" })
            ]
          }
        ),
        /* @__PURE__ */ s.jsxs(Ye, { size: "small", "data-testid": "o2-modal", heading: e, onRef: (c) => i(c), children: [
          /* @__PURE__ */ s.jsx(
            "p",
            {
              dangerouslySetInnerHTML: {
                __html: r
              }
            }
          ),
          o && /* @__PURE__ */ s.jsxs(ye, { color: "purple", heading: d.goodToKnow, children: [
            /* @__PURE__ */ s.jsx(Q, { name: "question-circle", solid: !0, slot: "icon" }),
            /* @__PURE__ */ s.jsx("p", { dangerouslySetInnerHTML: { __html: o } })
          ] })
        ] })
      ]
    }
  ) });
}, qt = ({ requiredQuote: t, requiredData: e, requiredParams: n, alertMessage: r, children: o }) => {
  const { namespace: a } = P(K), { quote: i } = P(ne), [l] = mn(), d = $(() => e != null && e.length ? i ? !e.find((m) => !i[m]) : !1 : !0, [i, e]), c = $(() => n != null && n.length ? !n.find((m) => !l.get(m)) : !0, [n, l]), u = $(() => t ? !!i : !0, [i, t]);
  return !d || !c || !u ? /* @__PURE__ */ s.jsx(ye, { color: "danger", "data-o2-portlet": a, "data-o2-role": "alert-user", children: r }) : o;
}, bd = ({ hwSliderModel: t, advancePayment: e, color: n, onUpdate: r }) => /* @__PURE__ */ s.jsx(
  Ks,
  {
    id: "hw-slider",
    "data-o2-id": "hwSlider",
    "data-testid": "hwSlider",
    name: "hwSlider",
    min: t.minimalAdvancePayment.toString(),
    max: t.maximalAdvancePayment.toString(),
    from: e.toString(),
    step: t.stepAmount,
    decimals: 2,
    color: n,
    simple: !0,
    onUpdate: (o) => r(
      Number(o.target.value[0].replace(" ", "").replace(",", "."))
    )
  }
), yd = ({ setFetchNewModel: t }) => {
  const {
    config: { tariffDetailUrl: e }
  } = P(K), [n, r] = w(!1), [o, a] = w(), [i, l] = w(), [d, c] = w(), [u, m] = w(), { setQuote: v } = P(ne), { unionText: b } = O(), { chooseTariffMessages: f } = b;
  S(() => {
    u != null && u.current && u.current.querySelectorAll("[data-tariff-name]").forEach(
      (x) => x.addEventListener("tariff-selected", (y) => {
        var g;
        v({
          contextTariff: { seoId: y.target.getAttribute("data-tariff-name") }
        }), t(!0), (g = o == null ? void 0 : o.current) == null || g.hide();
      })
    );
  }, [u, o, t, v]);
  const k = J(
    (p) => {
      var x;
      p.preventDefault(), (x = o == null ? void 0 : o.current) == null || x.show();
    },
    [o]
  ), h = $(() => ({ headers: { "Accept-Language": "sk-SK;q=0.9" } }), []);
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsx("a", { className: "no-href", onClick: k, children: f.tariffDetail }),
    /* @__PURE__ */ s.jsxs(
      Ye,
      {
        size: "large",
        "data-testid": "o2-modal",
        heading: f.tariffDetail,
        onRef: a,
        onHide: () => r(!1),
        onShow: () => r(!0),
        children: [
          d && /* @__PURE__ */ s.jsx(ye, { color: "danger", "data-o2-portlet": "storybook", "data-o2-role": "alert-system", heading: d.message }),
          i && /* @__PURE__ */ s.jsx(Q, { "data-testid": "loader", name: "loading", color: "blue-brand", size: 45 }),
          n && /* @__PURE__ */ s.jsx(
            kt,
            {
              url: e,
              options: h,
              onLoading: l,
              onError: c,
              onFetched: m
            }
          )
        ]
      }
    )
  ] });
}, Is = () => {
  const [t, e] = w(), { unionText: n } = O(), { chooseTransactionMessages: r } = n;
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsx("div", { className: "fw-bold mb-1", children: r.deposit.heading }),
    /* @__PURE__ */ s.jsxs(
      "a",
      {
        className: "no-href text-small",
        id: "deposit-modal",
        "data-o2-id": "deposit-modal",
        "data-testid": "deposit-modal",
        onClick: (o) => {
          var a;
          o == null || o.preventDefault(), (a = t == null ? void 0 : t.current) == null || a.show();
        },
        children: [
          r.deposit.more,
          " ",
          /* @__PURE__ */ s.jsx(Q, { name: "info-circle" })
        ]
      }
    ),
    /* @__PURE__ */ s.jsx("hr", { className: "my-3" }),
    /* @__PURE__ */ s.jsx(
      Ye,
      {
        size: "small",
        "data-testid": "o2-modal",
        heading: r.deposit.heading,
        onRef: e,
        children: /* @__PURE__ */ s.jsx(
          "p",
          {
            dangerouslySetInnerHTML: {
              __html: r.deposit.description
            }
          }
        )
      }
    )
  ] });
}, jd = ({ customNumbers: t }) => {
  const { values: e } = ee(), { unionText: n, withParams: r } = O(), { chooseTransactionMessages: o } = n, a = $(
    () => t.find(
      (i) => cn(i.msisdn) === cn(e.pickedMsisdn.msisdn)
    ),
    [t, e.pickedMsisdn]
  );
  return /* @__PURE__ */ s.jsxs("div", { className: "inline-input", children: [
    /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx("strong", { children: a.isGold ? o.desiredMsisdnFee.product.isGold : o.desiredMsisdnFee.product.default }) }),
    /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx("strong", { children: r(o.desiredMsisdnFee.total, {
      fee: ms(a.status)
    }) }) })
  ] });
}, kd = ({ status: t, checkedMsisdn: e, msisdn: n, isGold: r }) => {
  const { unionText: o, withParams: a } = O(), { chooseTransactionMessages: i } = o, l = $(() => {
    const d = i.desiredMsisdnModal.description.isGold, c = i.desiredMsisdnModal.description.default, u = ms(t);
    return r ? a(d, { fee: u }) : a(c, { fee: u });
  }, [i.desiredMsisdnModal.description, r, t, a]);
  return /* @__PURE__ */ s.jsxs(
    qe,
    {
      name: "customNumber",
      id: `customNumber-${n}`,
      "data-o2-id": `customNumber-${n}`,
      "data-testid": `customNumber-${n}`,
      checked: e === n,
      value: n,
      className: "mb-2",
      children: [
        n,
        /* @__PURE__ */ s.jsx("div", { className: "fw-normal text-small text-secondary", children: l })
      ]
    }
  );
}, Td = ({ modalRef: t, setModalRef: e, customNumbers: n, modalKey: r }) => {
  const [o, a] = w(), { setFieldValue: i } = ee(), { unionText: l } = O(), { chooseTransactionMessages: d } = l, c = J(() => {
    var m, v;
    a(void 0), (v = (m = t == null ? void 0 : t.current) == null ? void 0 : m.querySelector(".modal-scrollable")) == null || v.scroll({ top: 0 });
  }, [t]), u = J(() => {
    var v;
    const m = n == null ? void 0 : n.find(({ msisdn: b }) => b === o);
    i("pickedMsisdn", Si(m)), i("punRequired", m.isAvailableForPUN), (v = t == null ? void 0 : t.current) == null || v.hide();
  }, [o, n, t, i]);
  return /* @__PURE__ */ s.jsxs(
    Ye,
    {
      size: "small",
      "data-testid": "transaction-activation-modal",
      heading: d.desiredMsisdnModal.heading,
      onRef: e,
      onHide: c,
      children: [
        n && /* @__PURE__ */ s.jsx(s.Fragment, { children: /* @__PURE__ */ s.jsx("div", { className: "keyForObserver" + r, children: /* @__PURE__ */ s.jsx(
          pn,
          {
            "data-o2-id": "customNumber",
            "data-testid": "customNumber",
            id: "custom-number",
            name: "customNumber",
            onChange: (m) => a(m.target.value),
            required: !0,
            children: n.map(({ msisdn: m, status: v, isGold: b }) => /* @__PURE__ */ s.jsx(
              kd,
              {
                status: v,
                msisdn: m,
                isGold: b,
                checkedMsisdn: o
              },
              m
            ))
          }
        ) }) }),
        /* @__PURE__ */ s.jsx(
          ge,
          {
            id: "transaction-form-modal-cancel",
            "data-o2-id": "transactionFormModalCancel",
            "data-testid": "transactionFormModalCancel",
            name: "transactionFormModalCancel",
            fullwidth: !0,
            slot: "secondary",
            usage: "outlined",
            children: d.desiredMsisdnModal.cancel
          },
          "transaction-form-modal-cancel"
        ),
        /* @__PURE__ */ s.jsx(
          ge,
          {
            id: "transaction-form-modal-submit",
            "data-o2-id": "transactionFormModalSubmit",
            "data-testid": "transactionFormModalSubmit",
            name: "transactionFormModalSubmit",
            fullwidth: !0,
            disabled: !o,
            onClick: u,
            slot: "primary",
            children: d.desiredMsisdnModal.button
          },
          "transaction-form-modal-submit"
        )
      ]
    }
  );
}, wd = ({ setShowForm: t }) => {
  const { setFieldValue: e } = ee(), { isLoading: n } = P(Fe), { unionText: r } = O(), { chooseTransactionMessages: o } = r, a = J(() => {
    e("pickedMsisdn", null), e("desiredMsisdn", ""), e("desiredMsisdnQuery", ""), e("pun", ""), e("punRequired", !1), t(!1);
  }, [e, t]);
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsx("p", { children: /* @__PURE__ */ s.jsx("strong", { children: o.desiredMsisdnRandom.heading }) }),
    /* @__PURE__ */ s.jsx("p", { className: "text-small text-secondary", children: o.desiredMsisdnRandom.paragraph1 }),
    /* @__PURE__ */ s.jsx("p", { className: "text-small text-secondary", children: o.desiredMsisdnRandom.paragraph2 }),
    /* @__PURE__ */ s.jsx(
      ge,
      {
        id: "transaction-form-random-submit",
        "data-o2-id": "transactionFormRandomSubmit",
        "data-testid": "transactionFormRandomSubmit",
        name: "transactionFormRandomSubmit",
        disabled: n,
        onClick: a,
        usage: "outlined",
        children: o.desiredMsisdnRandom.button
      },
      "transaction-form-random-submit"
    )
  ] });
}, Id = ({ showDepositInfo: t, setShowForm: e }) => {
  var I, D;
  const { errors: n, values: r, setFieldError: o, setFieldValue: a } = ee(), { config: i } = P(K), { isLoading: l } = P(Fe), { unionText: d } = O(), { chooseTransactionMessages: c } = d, [u, m] = w(), [v, b] = w(), [f, k] = w(), [h, p] = w(0), [x, y] = w(!1);
  S(() => {
    y(!0);
  }, [r.desiredMsisdnQuery]);
  const {
    data: g,
    loading: T,
    error: C,
    fetcher: _
  } = ve(
    `${i.chooseTransactionModelUrl}/query-msisdns?desiredMsisdn=${cn(r.desiredMsisdnQuery)}`,
    {
      method: "GET",
      manual: !0
    }
  ), z = J(
    (M) => {
      if (r.transaction !== X.ACTIVATION || !M || r.pickedMsisdn)
        return;
      if (!M.match(/^\d*$/g))
        return c.desiredMsisdnValidations.format;
      if (M.length < 3)
        return c.desiredMsisdnValidations.minLength;
      if (M.length > 10)
        return c.desiredMsisdnValidations.maxLength;
      if (g && !g.desiredMsisdns.length && g.cleanPattern === M)
        return c.desiredMsisdnValidations.notAvailable;
      const N = M.replace(/^0/g, "");
      if (N.length > 8)
        return Ts(N);
    },
    [
      c.desiredMsisdnValidations.format,
      c.desiredMsisdnValidations.maxLength,
      c.desiredMsisdnValidations.minLength,
      c.desiredMsisdnValidations.notAvailable,
      g,
      r.pickedMsisdn,
      r.transaction
    ]
  ), E = J(() => {
    if (!n.desiredMsisdn)
      return r.pickedMsisdn && f && f.length > 0 ? u.current.show() : _();
  }, [n.desiredMsisdn, u, r.pickedMsisdn, _, f]);
  return S(() => {
    const M = (j) => {
      j.detail.key === "Enter" && r.desiredMsisdnQuery && r.desiredMsisdnQuery.length >= 3 && !T && E();
    }, N = v == null ? void 0 : v.current;
    return N && (N.removeEventListener("o2Keyup", M), N.addEventListener("o2Keyup", M)), () => {
      N == null || N.removeEventListener("o2Keyup", M);
    };
  }, [v, r, T, E]), S(() => {
    (() => {
      var M;
      if (C)
        return o("desiredMsisdn", c.desiredMsisdnValidations.notAvailable);
      g && (a(
        "punRequired",
        ((M = g.desiredMsisdns) == null ? void 0 : M.length) === 1 && g.desiredMsisdns[0].isAvailableForPUN
      ), k(g.desiredMsisdns));
    })();
  }, [
    c.desiredMsisdnValidations.notAvailable,
    C,
    g,
    o,
    a
  ]), Ds(() => {
    const M = (j, U) => {
      u.current.querySelector("#custom-number").clientHeight !== 0 && (u.current.show(), U.disconnect());
    }, N = () => {
      new MutationObserver(M).observe(u.current, {
        attributes: !0,
        childList: !0,
        subtree: !0
      });
    };
    u && f && f.length > 0 && (N(), p((j) => j + 1));
  }, [u, f]), S(() => {
    var M;
    if ((M = r.pickedMsisdn) != null && M.msisdn && (v != null && v.current) && x) {
      const N = r.desiredMsisdnQuery;
      v.current.value = us(r.pickedMsisdn.msisdn), a("desiredMsisdnQuery", N), y(!1);
    }
  }, [v, x, a, r.desiredMsisdnQuery, (I = r.pickedMsisdn) == null ? void 0 : I.msisdn]), /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsxs("div", { className: "d-flex gap-3", children: [
      /* @__PURE__ */ s.jsx(
        Oe,
        {
          as: Xt,
          name: "desiredMsisdn",
          id: "desiredMsisdn",
          "data-o2-id": "desiredMsisdn",
          "data-testid": "desiredMsisdn",
          label: c.desiredMsisdnInput,
          placeholder: c.desiredMsisdnInputPlaceholder,
          required: r.transaction === X.ACTIVATION,
          validate: z,
          disabled: !!r.pickedMsisdn || l,
          onRef: b,
          onChange: (M) => a("desiredMsisdnQuery", M.target.value),
          styleFormField: { flexGrow: "1", marginBottom: "0" }
        }
      ),
      /* @__PURE__ */ s.jsx(
        ge,
        {
          id: "transaction-form-submit",
          "data-o2-id": "transactionFormSubmit",
          "data-testid": "transactionFormSubmit",
          name: "transactionFormSubmit",
          className: "icon-button field-aligner",
          onClick: E,
          disabled: !r.desiredMsisdnQuery || r.desiredMsisdnQuery.length < 3 || T || l,
          children: T ? /* @__PURE__ */ s.jsx(Q, { "data-testid": "loader", name: "loading" }) : /* @__PURE__ */ s.jsx(Q, { name: "chevron-right" })
        },
        `transaction-form-submit-${T ? "loading" : ""}`
      )
    ] }),
    /* @__PURE__ */ s.jsx(
      Td,
      {
        modalRef: u,
        setModalRef: m,
        customNumbers: f,
        modalKey: h
      }
    ),
    /* @__PURE__ */ s.jsx("hr", { className: "my-3" }),
    /* @__PURE__ */ s.jsx(wd, { setShowForm: e }),
    /* @__PURE__ */ s.jsx("hr", { className: "my-3" }),
    f && f.length > 0 && ((D = r.pickedMsisdn) == null ? void 0 : D.msisdn) && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      /* @__PURE__ */ s.jsx(jd, { customNumbers: f }),
      /* @__PURE__ */ s.jsx("hr", { className: "my-3" })
    ] }),
    t && /* @__PURE__ */ s.jsx(Is, {})
  ] });
}, Nd = () => {
  const { values: t } = ee(), { isLoading: e } = P(Fe), { unionText: n } = O(), { chooseTransactionMessages: r } = n, [o, a] = w(), i = J(
    (d) => {
      if (t.transaction === X.ACTIVATION && !(!d && !t.punRequired)) {
        if (!d)
          return ut(d);
        if (d.length > 8)
          return r.desiredMsisdnPun.maxLength;
        if (!d.match(/^[a-zA-Z0-9]*$/g))
          return r.desiredMsisdnPun.format;
      }
    },
    [
      r.desiredMsisdnPun.format,
      r.desiredMsisdnPun.maxLength,
      t.punRequired,
      t.transaction
    ]
  ), l = J(
    (d) => {
      o.current.value !== d.detail.value.toUpperCase() && (o.current.value = d.detail.value.toUpperCase());
    },
    [o]
  );
  return S(() => {
    const d = o == null ? void 0 : o.current;
    return d == null || d.addEventListener("o2Change", l), () => {
      d == null || d.removeEventListener("o2Change", l);
    };
  }, [l, o]), /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsx("h6", { children: r.desiredMsisdnPun.heading }),
    /* @__PURE__ */ s.jsx("p", { className: "text-small text-secondary", children: r.desiredMsisdnPun.description }),
    /* @__PURE__ */ s.jsx(
      Oe,
      {
        as: Xt,
        onRef: a,
        name: "pun",
        id: "pun",
        "data-o2-id": "pun",
        "data-testid": "pun",
        disabled: e,
        label: r.desiredMsisdnPun.input,
        required: t.transaction === X.ACTIVATION && t.punRequired,
        validate: i
      }
    )
  ] });
}, Sd = ({ errorParams: t, showForm: e, setShowForm: n, showDepositInfo: r }) => {
  const { values: o, setFieldValue: a, setFieldError: i } = ee(), { isLoading: l } = P(Fe), { unionText: d } = O(), { chooseTransactionMessages: c } = d;
  return S(() => {
    o.transaction !== X.ACTIVATION && (n(!1), a("pickedMsisdn", void 0), a("desiredMsisdn", ""), a("desiredMsisdnQuery", ""), a("pun", ""), a("punRequired", !1));
  }, [o.transaction, a, n]), S(() => {
    (t == null ? void 0 : t.reasonCode) === "RESERVED_MSISDN_FAILURE" && i("pun", c.desiredMsisdnPun.incorrect);
  }, [c.desiredMsisdnPun.incorrect, t == null ? void 0 : t.reasonCode, i]), /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsxs(
      Oe,
      {
        as: qe,
        value: X.ACTIVATION,
        name: "transaction",
        id: "transaction.activation",
        disabled: l,
        "data-o2-id": "transaction.activation",
        "data-testid": "transaction.activation",
        checked: o.transaction === X.ACTIVATION,
        children: [
          c.desiredMsisdn,
          /* @__PURE__ */ s.jsx("div", { className: "fw-normal text-small text-secondary", children: c.desiredMsisdnDesc })
        ]
      }
    ),
    o.transaction === X.ACTIVATION && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      !e && /* @__PURE__ */ s.jsx(
        ge,
        {
          id: "show-transaction-form",
          "data-o2-id": "showTransactionForm",
          "data-testid": "showTransactionForm",
          name: "showTransactionForm",
          className: "ms-5 mt-2",
          onClick: () => n(!0),
          usage: "outlined",
          children: c.desiredMsisdnButton
        }
      ),
      /* @__PURE__ */ s.jsx("div", { className: "radio-content", children: /* @__PURE__ */ s.jsxs(
        lr,
        {
          howItWorks: c.desiredMsisdnHowItWorks,
          anchorId: "new-modal",
          description: c.desiredMsisdnModalDesc,
          children: [
            r && !e && /* @__PURE__ */ s.jsx(Is, {}),
            e && /* @__PURE__ */ s.jsx(Id, { showDepositInfo: r, setShowForm: n })
          ]
        }
      ) }),
      o.punRequired && /* @__PURE__ */ s.jsx(Nd, {})
    ] })
  ] });
}, Od = ({ chooseTransactionModel: t }) => {
  const { values: e } = ee(), { unionText: n, withParams: r } = O(), { chooseTransactionMessages: o } = n, a = [
    "O4:POP:TARIF:SG_B",
    "O4:POP:TARIF:SG_C",
    "O4:POP:TARIF:SG_D",
    "O4:POP:TARIF:SG_F",
    "O4:POP:TARIF:DATA_MODRE",
    "O4:POP:TARIF:DATA_STRIEBORNE",
    "O4:POP:TARIF:DATA_ZLATE",
    "O4:POP:TARIF:PAUSAL_MODRY",
    "O4:POP:TARIF:PAUSAL_STRIEBORNY_NEOB",
    "O4:POP:TARIF:PAUSAL_ZLATY"
  ];
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsxs(
      Oe,
      {
        as: qe,
        value: X.CHANGE,
        name: "transaction",
        id: "transaction.change",
        "data-o2-id": "transaction.change",
        "data-testid": "transaction.change",
        checked: e.transaction === X.CHANGE,
        children: [
          o.changeTariff,
          /* @__PURE__ */ s.jsx("div", { className: "fw-normal text-small text-secondary", children: t.subscriberMsisdn + " | " + t.subscriberTariffName })
        ]
      }
    ),
    e.transaction === X.CHANGE && /* @__PURE__ */ s.jsxs("div", { className: "radio-content", children: [
      t.selectedTariff === t.subscriberTariff && /* @__PURE__ */ s.jsxs(
        xt,
        {
          background: "orange-light",
          heading: "",
          "data-o2-id": "transaction-change-already-active-box",
          "data-testid": "transaction-change-already-active-box",
          children: [
            /* @__PURE__ */ s.jsx("span", { className: "text-warning", children: r(o.alreadyActive, {
              tariff: t.subscriberTariffName
            }) }),
            o.alreadyActiveDesc
          ]
        }
      ),
      t.selectedTariff !== t.subscriberTariff && (!a.includes(t.subscriberTariff) && /* @__PURE__ */ s.jsx(
        lr,
        {
          howItWorks: o.alreadyActiveHowItWorks,
          anchorId: "change-modal",
          description: t.showTariffDowngradeInfo ? o.alreadyActiveModalTariffDowngradeDesc : o.alreadyActiveModalDesc,
          hint: o.alreadyActiveModalHint
        }
      ) || a.includes(t.subscriberTariff) && /* @__PURE__ */ s.jsxs(
        xt,
        {
          background: "blue-light",
          heading: "",
          className: "mb-4",
          "data-o2-id": "transaction-change-fenix-box",
          "data-testid": "transaction-change-fenix-box",
          children: [
            /* @__PURE__ */ s.jsx("div", { className: "mb-1", children: o.fenixHowItWorks }),
            /* @__PURE__ */ s.jsxs(
              "a",
              {
                href: "/moje-o2/nove-pausaly",
                className: "text-small",
                id: "fenix-migration",
                "data-o2-id": "fenix-migration",
                "data-testid": "fenix-migration",
                children: [
                  o.learnMore,
                  " ",
                  /* @__PURE__ */ s.jsx(Q, { name: "info-circle" })
                ]
              }
            )
          ]
        }
      ))
    ] })
  ] });
}, Pd = () => {
  const { isLoading: t } = P(Fe), { setFieldValue: e } = ee(), { unionText: n } = O(), { chooseTransactionMessages: r } = n, o = (a) => {
    if (a.target.value) {
      const i = Ha(a.target.value);
      e("portinBuyoutIban", i);
    }
  };
  return /* @__PURE__ */ s.jsx(
    Oe,
    {
      as: Xt,
      name: "portinBuyoutIban",
      placeholder: r.portinBuyout.ibanPlaceholder,
      id: "buyout-iban",
      "data-o2-id": "buyout-iban",
      "data-testid": "buyout-iban",
      disabled: t,
      label: r.portinBuyout.ibanlabel,
      validate: (a) => {
        const i = ws(a);
        if (i)
          return a ? r.portinBuyout.ibanInvalid : i;
      },
      maxLength: 29,
      onChange: o,
      required: !0
    }
  );
}, Ns = ({ chooseBuyOut: t }) => {
  var a;
  const { values: e } = ee(), { isLoading: n } = P(Fe), { unionText: r } = O(), { chooseTransactionMessages: o } = r;
  return /* @__PURE__ */ s.jsx(s.Fragment, { children: (a = t.buyOuts) == null ? void 0 : a.map((i, l) => /* @__PURE__ */ s.jsxs(It, { children: [
    /* @__PURE__ */ s.jsx("hr", { className: "divider" }),
    /* @__PURE__ */ s.jsx(
      Oe,
      {
        as: qe,
        value: i.seoId,
        disabled: n,
        name: "portinBuyOut",
        id: "portinBuyOut." + i.seoId,
        "data-o2-id": "portinBuyOut." + i.seoId,
        "data-testid": "portinBuyOut." + i.seoId,
        checked: e.portinBuyOut === i.seoId,
        children: i.displayName
      }
    ),
    i.seoId === "preplatit-zmluvnu-pokutu" && e.portinBuyOut === "preplatit-zmluvnu-pokutu" && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      /* @__PURE__ */ s.jsx("p", { className: "text-secondary mt-3 mb-3", children: o.portinBuyout.description }),
      /* @__PURE__ */ s.jsx(Pd, {})
    ] })
  ] }, "buyOutOption" + l)) });
}, Md = ({ chooseBuyOut: t }) => {
  const { unionText: e } = O(), { chooseTransactionMessages: n } = e, [r, o] = w();
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsx("h6", { className: "mb-1", children: n.portinBuyOutTitle }),
    /* @__PURE__ */ s.jsx("p", { className: "text-secondary", children: n.portinBuyOutDescription }),
    /* @__PURE__ */ s.jsxs(
      "a",
      {
        className: "no-href",
        id: "buyout-modal",
        "data-o2-id": "buyout-modal",
        "data-testid": "buyout-modal",
        onClick: (a) => {
          var i;
          a == null || a.preventDefault(), (i = r == null ? void 0 : r.current) == null || i.show();
        },
        children: [
          n.portinBuyOutModal.moreDetail,
          " ",
          /* @__PURE__ */ s.jsx(Q, { name: "info-circle" })
        ]
      }
    ),
    /* @__PURE__ */ s.jsx(Ye, { size: "small", heading: n.portinBuyOutModal.title, onRef: o, children: /* @__PURE__ */ s.jsxs("ol", { children: [
      /* @__PURE__ */ s.jsx(
        "li",
        {
          className: "mb-1",
          dangerouslySetInnerHTML: {
            __html: n.portinBuyOutModal.firstPoint
          }
        }
      ),
      /* @__PURE__ */ s.jsx(
        "li",
        {
          className: "mb-1",
          dangerouslySetInnerHTML: {
            __html: n.portinBuyOutModal.secondPoint
          }
        }
      ),
      /* @__PURE__ */ s.jsx(
        "li",
        {
          className: "mb-1",
          dangerouslySetInnerHTML: {
            __html: n.portinBuyOutModal.thirdPoint
          }
        }
      )
    ] }) }),
    /* @__PURE__ */ s.jsx(Ns, { chooseBuyOut: t })
  ] });
}, Cd = ({
  errorParams: t,
  validatePortin: e,
  showBuyOutForm: n,
  setShowBuyOutForm: r
}) => {
  const { unregisterField: o, validateForm: a } = ee(), { isLoading: i } = P(Fe), { unionText: l } = O(), { chooseTransactionMessages: d } = l;
  return S(() => () => {
    o("portinMsisdn"), a();
  }, [o, a]), /* @__PURE__ */ s.jsx("div", { className: "radio-content", children: /* @__PURE__ */ s.jsxs(
    lr,
    {
      howItWorks: d.portinHowItWorks,
      anchorId: "portin-modal",
      description: d.portinModalDesc,
      hint: d.portinModalHint,
      children: [
        /* @__PURE__ */ s.jsx(
          Oe,
          {
            as: Xt,
            disabled: n || i,
            name: "portinMsisdn",
            placeholder: "09** *** ***",
            id: "portinMsisdn",
            "data-o2-id": "portinMsisdn",
            "data-testid": "portinMsisdn",
            label: d.portinMsisdn,
            validate: (c) => t != null && t.portinError ? e(c, t.reasonCode, t.portinMsisdn) : e(c),
            required: !0
          }
        ),
        n && /* @__PURE__ */ s.jsx(
          ge,
          {
            id: "change-portin-msisdn",
            "data-o2-id": "change-portin-msisdn",
            "data-testid": "change-portin-msisdn",
            name: "change-portin-msisdn",
            disabled: i,
            onClick: () => r(!1),
            usage: "outlined",
            children: d.portinChangeMsisdn
          }
        ),
        /* @__PURE__ */ s.jsx("hr", {})
      ]
    }
  ) });
}, Ed = ({ errorParams: t, setShowBuyOutForm: e, chooseBuyOutModel: n, showBuyOutForm: r }) => {
  const { validateField: o, values: a, setFieldValue: i } = ee(), { isLoading: l } = P(Fe), { unionText: d } = O(), { chooseTransactionMessages: c } = d;
  S(() => {
    a.portinBuyOut && a.transaction !== "PORTIN" && (i("portinBuyOut", null, !1), i("portinBuyoutIban", null, !1));
  }, [a, i]);
  const u = (m, v, b) => {
    if (!m)
      return c.required;
    if (v && b === m)
      switch (v) {
        case "O2_CUSTOMER":
          return c.portinError.O2_CUSTOMER;
        case "VIRTUAL_PORTIN_NOT_ALLOWED":
          return c.portinError.VIRTUAL_PORTIN_NOT_ALLOWED;
        case "O2BS_CUSTOMER":
          return c.portinError.O2BS_CUSTOMER;
        case "MULTIPLE_OPERATORS":
          return c.portinError.MULTIPLE_OPERATORS;
        case "PORTIN_ALREADY_REQUESTED":
          return c.portinError.PORTIN_ALREADY_REQUESTED;
        case "OPERATOR_NOT_FOUND":
          return c.portinError.OPERATOR_NOT_FOUND;
        default:
          return c.portinError.DEFAULT;
      }
    return Ts(m.trim());
  };
  return S(() => {
    t != null && t.portinError && o("portinMsisdn");
  }, [t, o]), /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsxs(
      Oe,
      {
        as: qe,
        value: X.PORTIN,
        name: "transaction",
        id: "transaction.portin",
        "data-o2-id": "transaction.portin",
        "data-testid": "transaction.portin",
        disabled: l,
        checked: a.transaction === X.PORTIN,
        children: [
          c.portin,
          /* @__PURE__ */ s.jsx("div", { className: "fw-normal text-small text-secondary", children: c.portinDesc })
        ]
      }
    ),
    a.transaction === X.PORTIN && /* @__PURE__ */ s.jsx(
      Cd,
      {
        validatePortin: u,
        errorParams: t,
        showBuyOutForm: r,
        setShowBuyOutForm: e
      }
    ),
    a.transaction === X.PORTIN && r && n && /* @__PURE__ */ s.jsx(Md, { chooseBuyOut: n })
  ] });
}, _d = ({ chooseTransactionModel: t, showActivationForm: e, showBuyOutForm: n }) => {
  const { values: r, isSubmitting: o, isValid: a } = ee(), { isLoading: i } = P(Fe), { unionText: l } = O(), { chooseTransactionMessages: d } = l, c = $(() => !!(o || i || !a || !r.transaction || r.transaction === X.CHANGE && t.selectedTariff === t.subscriberTariff || r.transaction === X.ACTIVATION && r.pickedMsisdn === void 0 && e || r.transaction === X.ACTIVATION && r.punRequired && !r.pun || r.transaction === X.PORTIN && n && !r.portinBuyOut), [
    n,
    r,
    e,
    t.selectedTariff,
    t.subscriberTariff,
    o,
    a,
    i
  ]);
  return /* @__PURE__ */ s.jsxs(
    ge,
    {
      disabled: c,
      "data-o2-id": "submit-choose-transaction",
      "data-testid": "submit-choose-transaction",
      "data-o2-role": "action-submit",
      id: "submit-choose-transaction",
      name: "submit-choose-transaction",
      type: "submit",
      fullwidth: !0,
      children: [
        !r.transaction && d.continue,
        r.transaction && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
          o || i ? /* @__PURE__ */ s.jsx(Q, { name: "loading", color: "white" }, "loading") : /* @__PURE__ */ s.jsx(Q, { name: "checkout", color: "white" }, "checkout"),
          /* @__PURE__ */ s.jsx("span", { className: "ms-2", children: d.addToCart })
        ] })
      ]
    }
  );
}, Ad = ({
  chooseTransactionModel: t,
  showActivationForm: e,
  showBuyOutForm: n,
  hasBuyoutOptions: r,
  setShowBuyOutForm: o
}) => {
  const { isValid: a, values: i, setFieldError: l } = ee(), { config: d } = P(K), { unionText: c } = O(), { chooseTransactionMessages: u } = c, m = $(() => r && !n && i.transaction === X.PORTIN, [r, n, i]), {
    fetcher: v,
    loading: b,
    error: f,
    successCount: k
  } = ve(d.validatePortinUrl, {
    method: "POST",
    manual: !0
  });
  return S(() => {
    k && o(!0);
  }, [k, o]), S(() => {
    var h, p;
    if (f)
      switch ((p = (h = f.validationResults) == null ? void 0 : h[0]) == null ? void 0 : p.reasonCode) {
        case "O2_CUSTOMER":
          l("portinMsisdn", u.portinError.O2_CUSTOMER);
          break;
        case "VIRTUAL_PORTIN_NOT_ALLOWED":
          l("portinMsisdn", u.portinError.VIRTUAL_PORTIN_NOT_ALLOWED);
          break;
        case "O2BS_CUSTOMER":
          l("portinMsisdn", u.portinError.O2BS_CUSTOMER);
          break;
        case "MULTIPLE_OPERATORS":
          l("portinMsisdn", u.portinError.MULTIPLE_OPERATORS);
          break;
        case "PORTIN_ALREADY_REQUESTED":
          l("portinMsisdn", u.portinError.PORTIN_ALREADY_REQUESTED);
          break;
        case "OPERATOR_NOT_FOUND":
          l("portinMsisdn", u.portinError.OPERATOR_NOT_FOUND);
          break;
        default:
          l("portinMsisdn", u.portinError.DEFAULT);
          break;
      }
  }, [
    u.portinError.DEFAULT,
    u.portinError.MULTIPLE_OPERATORS,
    u.portinError.O2BS_CUSTOMER,
    u.portinError.O2_CUSTOMER,
    u.portinError.OPERATOR_NOT_FOUND,
    u.portinError.PORTIN_ALREADY_REQUESTED,
    u.portinError.VIRTUAL_PORTIN_NOT_ALLOWED,
    l,
    f
  ]), /* @__PURE__ */ s.jsx("div", { className: "row justify-content-center", children: /* @__PURE__ */ s.jsx("div", { className: "col-12 col-md-8 col-lg-6", children: m ? /* @__PURE__ */ s.jsx(
    ge,
    {
      disabled: !a || b,
      "data-o2-id": "show-buyout-options",
      "data-testid": "show-buyout-options",
      id: "show-buyout-options",
      name: "show-buyout-options",
      fullwidth: !0,
      onClick: () => v({ msisdnForPortIn: i.portinMsisdn }, { type: "text" }),
      children: u.continue
    }
  ) : /* @__PURE__ */ s.jsx(
    _d,
    {
      chooseTransactionModel: t,
      showActivationForm: e,
      showBuyOutForm: n
    }
  ) }) });
}, Rd = ({ type: t }) => {
  var d;
  const { unionText: e } = O(), { tvStandaloneMessages: n } = e, [r, o] = w(), { values: a } = ee(), c = (d = r == null ? void 0 : r.triggerProps) != null ? d : {}, { onPress: i } = c, l = en(c, ["onPress"]);
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsxs(
      Je,
      {
        getController: o,
        "data-testid": "radio.modal.info",
        heading: n.radioContent[t].modal.heading,
        children: [
          /* @__PURE__ */ s.jsx("p", { className: "mb-3", children: n.radioContent[t].modal.description.title }),
          /* @__PURE__ */ s.jsx("ul", { className: "ul text-gray-medium mx-2", children: n.radioContent[t].modal.description.points.map((u, m) => /* @__PURE__ */ s.jsx(
            "li",
            {
              dangerouslySetInnerHTML: {
                __html: u
              }
            },
            m
          )) })
        ]
      }
    ),
    /* @__PURE__ */ s.jsxs(F, { children: [
      /* @__PURE__ */ s.jsx("p", { children: n.radioContent[t].title }),
      /* @__PURE__ */ s.jsx("p", { className: "text-body-2 text-gray-medium", children: n.radioContent[t].description }),
      a.hardwareType === t && /* @__PURE__ */ s.jsx("a", G(H({ "data-testid": "radio.content.helper", onClick: r == null ? void 0 : r.open }, l), { children: /* @__PURE__ */ s.jsxs(B, { alignItems: "center", gap: 1, mt: 2, fs: "body2-strong", c: "blue-brand", children: [
        n.radioContent[t].helper,
        /* @__PURE__ */ s.jsx(pt, { size: 18 })
      ] }) }))
    ] })
  ] });
}, Ss = ({ setTopBoxIndex: t }) => {
  const { values: e, setFieldValue: n } = ee(), { tvBoxes: r } = e, { unionText: o } = O(), { tvStandaloneMessages: a } = o, i = r[t].amount, l = `tvBoxes.[${t}].amount`, d = e.tvBoxes.reduce((c, u) => +c + +u.amount, 0);
  return /* @__PURE__ */ s.jsxs(B, { gap: 1, children: [
    /* @__PURE__ */ s.jsx(
      On,
      {
        "aria-label": a.ariaLabels.decreaseCounterButton,
        "data-testid": `setTopBoxCounter.${t}.counter.decrease.button`,
        variant: "inverted",
        disabled: i <= 0,
        onPress: () => n(l, i - 1),
        children: /* @__PURE__ */ s.jsx(Hs, {})
      }
    ),
    /* @__PURE__ */ s.jsx(
      L,
      {
        style: {
          width: 48
        },
        children: /* @__PURE__ */ s.jsx(
          Pt,
          {
            as: vt,
            type: "number",
            inputMode: "numeric",
            name: l,
            disabled: !0,
            bg: "white",
            "aria-label": a.ariaLabels.seTopBoxCounterAmount,
            "data-testid": `setTopBoxCounter.${t}.counter.input`,
            validate: (c) => md(c == null ? void 0 : c.toString(), !0, !0),
            px: 0
          }
        )
      }
    ),
    /* @__PURE__ */ s.jsx(
      On,
      {
        "aria-label": a.ariaLabels.increaseCounterButton,
        "data-testid": `setTopBoxCounter.${t}.counter.increase.button`,
        variant: "inverted",
        disabled: d >= vo,
        onPress: () => n(l, i + 1),
        children: /* @__PURE__ */ s.jsx(Us, {})
      }
    )
  ] });
}, Os = ({ getModalControls: t, setTopBoxTexts: e }) => /* @__PURE__ */ s.jsx(Je, { getController: t, "data-testid": "setTopBox.card.infoModal", heading: e.name, children: /* @__PURE__ */ s.jsx("div", { dangerouslySetInnerHTML: { __html: e.benefits } }) }), Dd = ({ setTopBoxFormikIndex: t }) => {
  var m, v;
  const [e, n] = w(), { unionText: r } = O(), { tvStandaloneMessages: o } = r, { values: a } = ee(), { tvBoxes: i } = a, {
    alias: l,
    moreBody: d,
    moreHint: c
  } = (m = i[t]) != null ? m : {}, u = () => e == null ? void 0 : e.open();
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsx(
      Os,
      {
        getModalControls: n,
        setTopBoxTexts: { name: l, description: d, benefits: c }
      }
    ),
    /* @__PURE__ */ s.jsxs(
      B,
      {
        "data-testid": `tvStandalone.setTopBox.card.${t}`,
        mt: 3,
        bg: "blue-brand-light",
        direction: "row",
        w: "auto",
        h: "auto",
        children: [
          /* @__PURE__ */ s.jsxs(
            L,
            {
              "data-testid": `setTopBox.picture.${t}.infoButton`,
              id: `setTopBox.picture.${t}.infoButton`,
              w: 25,
              h: "auto",
              m: 3,
              style: { position: "relative", overflow: "hidden", width: 140 },
              bg: "white",
              "aria-label": o.ariaLabels.setTopBoxCardPicture,
              tabIndex: 0,
              onClick: u,
              role: "button",
              children: [
                /* @__PURE__ */ s.jsx(B, { justify: "center", h: 100, children: /* @__PURE__ */ s.jsx(
                  Et,
                  {
                    style: { objectFit: "contain" },
                    src: (v = i[t].imgUrl) != null ? v : "",
                    alt: "alt-text",
                    skipWebp: !0
                  }
                ) }),
                /* @__PURE__ */ s.jsx(
                  pt,
                  {
                    "aria-label": o.ariaLabels.setTopBoxCardInfoButton,
                    "data-testid": `picture.${t}.tooltip-button`,
                    color: "blue-brand",
                    size: Be,
                    style: {
                      position: "absolute",
                      top: 0,
                      right: 0,
                      width: Be,
                      minWidth: Be,
                      height: Be,
                      minHeight: Be
                    },
                    m: 1
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ s.jsx(F, { my: 3, children: /* @__PURE__ */ s.jsxs(B, { direction: "column", me: 3, h: 100, gap: 0, children: [
            /* @__PURE__ */ s.jsxs(B, { direction: "row", justify: "between", w: 100, h: 100, children: [
              /* @__PURE__ */ s.jsx("p", { children: i[t].alias }),
              /* @__PURE__ */ s.jsx(L, { className: "text-brand", flexShrink: 0, c: "blue-brand", fs: "body1-strong", children: /* @__PURE__ */ s.jsx(
                Ne,
                {
                  price: i[t].customPriceNum * i[t].amount,
                  chargePeriod: "MONTHLY"
                }
              ) })
            ] }),
            /* @__PURE__ */ s.jsx(L, { c: "gray-dark", mb: 3, children: /* @__PURE__ */ s.jsx(Ne, { price: i[t].customPriceNum, chargePeriod: "MONTHLY" }) }),
            /* @__PURE__ */ s.jsx(Ss, { setTopBoxIndex: t })
          ] }) })
        ]
      }
    )
  ] });
}, zd = ({ setTopBoxFormikIndex: t }) => {
  var m, v;
  const [e, n] = w(), { values: r } = ee(), { unionText: o } = O(), { tvStandaloneMessages: a } = o, { tvBoxes: i } = r, {
    alias: l,
    moreBody: d,
    moreHint: c
  } = (m = i[t]) != null ? m : {}, u = () => e == null ? void 0 : e.open();
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsx(
      Os,
      {
        getModalControls: n,
        setTopBoxTexts: { name: l, description: d, benefits: c }
      }
    ),
    /* @__PURE__ */ s.jsxs(B, { "data-testid": `tvStandalone.setTopBox.card.${t}`, mt: 3, bg: "blue-brand-light", direction: "column", children: [
      /* @__PURE__ */ s.jsxs(
        L,
        {
          "data-testid": `setTopBox.picture.${t}.infoButton`,
          id: `setTopBox.picture.${t}.infoButton`,
          w: "auto",
          m: 1,
          style: { position: "relative", overflow: "hidden", height: 172, width: 328 },
          bg: "white",
          "aria-label": a.ariaLabels.setTopBoxCardPicture,
          tabIndex: 0,
          onClick: u,
          role: "button",
          children: [
            /* @__PURE__ */ s.jsx(B, { justify: "center", h: 100, children: /* @__PURE__ */ s.jsx(
              Et,
              {
                style: { objectFit: "contain" },
                src: (v = i[t].imgUrl) != null ? v : "",
                alt: "alt-text",
                skipWebp: !0
              }
            ) }),
            /* @__PURE__ */ s.jsx(
              pt,
              {
                "aria-label": a.ariaLabels.setTopBoxCardInfoButton,
                "data-testid": `picture.${t}.tooltip-button`,
                color: "blue-brand",
                size: Be,
                style: {
                  position: "absolute",
                  top: 0,
                  right: 0,
                  width: Be,
                  minWidth: Be,
                  height: Be,
                  minHeight: Be
                },
                m: 1
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ s.jsx(F, { m: 3, children: /* @__PURE__ */ s.jsxs(B, { direction: "column", h: 100, children: [
        /* @__PURE__ */ s.jsxs(B, { direction: "row", alignItems: "center", justify: "between", mt: 2, w: 100, h: 100, children: [
          /* @__PURE__ */ s.jsx("p", { children: i[t].alias }),
          /* @__PURE__ */ s.jsx(L, { flexShrink: 0, c: "gray-dark", children: /* @__PURE__ */ s.jsx(Ne, { price: i[t].customPriceNum, chargePeriod: "MONTHLY" }) })
        ] }),
        /* @__PURE__ */ s.jsx("hr", { className: "my-3" }),
        /* @__PURE__ */ s.jsxs(B, { direction: "row", alignItems: "center", justify: "between", mt: 2, w: 100, h: 100, children: [
          /* @__PURE__ */ s.jsx(Ss, { setTopBoxIndex: t }),
          /* @__PURE__ */ s.jsx(L, { c: "blue-brand", fs: "body1-strong", children: /* @__PURE__ */ s.jsx(
            Ne,
            {
              price: i[t].customPriceNum * i[t].amount,
              chargePeriod: "MONTHLY"
            }
          ) })
        ] })
      ] }) })
    ] })
  ] });
}, Ld = () => {
  var k;
  const { namespace: t, config: e } = P(K), { quote: n } = P(ne), [r, o] = w(!1), { values: a, setFieldValue: i } = ee(), { unionText: l } = O(), { tvStandaloneMessages: d } = l, c = Ln(), u = ["base", "sm", "md"].includes(c), {
    fetcher: m,
    loading: v,
    data: b,
    error: f
  } = ve(e.chooseRouterModelUrl, {
    method: "POST",
    manual: !0
  });
  return S(() => {
    var h, p;
    (h = n == null ? void 0 : n.contextTariff) != null && h.seoId && m({
      contextTariff: { seoId: (p = n == null ? void 0 : n.contextTariff) == null ? void 0 : p.seoId },
      paymentMethod: Xe.O2_MOBIL
    });
  }, [m, (k = n == null ? void 0 : n.contextTariff) == null ? void 0 : k.seoId]), S(() => {
    b && (i(
      "tvBoxes",
      b.routers.map((h, p) => G(H({}, h), { amount: p > 0 ? 0 : 1 }))
    ), o(!0));
  }, [b, i]), S(() => {
    a.hardwareType === "modern" && r && (a.tvBoxes.reduce((h, p) => +h + +p.amount, 0) !== 1 || a.tvBoxes[0].amount !== 1) && i(
      "tvBoxes",
      a.tvBoxes.map((h, p) => G(H({}, h), { amount: p > 0 ? 0 : 1 }))
    );
  }, [r, i, a.hardwareType, a.tvBoxes]), /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    !v && f && /* @__PURE__ */ s.jsx(
      Ge,
      {
        closable: !0,
        color: "danger",
        "data-o2-portlet": t,
        "data-o2-role": "alert-system",
        "data-testid": "tvStandalone.radio.group.error",
        children: d.errors.setTopBoxData
      }
    ),
    /* @__PURE__ */ s.jsx(
      Pt,
      {
        as: Fn,
        "aria-label": d.ariaLabels.radioGroup,
        name: "hardwareType",
        direction: "column",
        "data-testid": "tvStandalone.radio.group",
        required: !0,
        children: go.map((h) => /* @__PURE__ */ s.jsxs("div", { children: [
          /* @__PURE__ */ s.jsx("hr", { className: "my-3" }),
          /* @__PURE__ */ s.jsx(Bn, { name: `element.hardwareType.${h}`, "data-testid": `radio.hardwareType.${h}`, value: h, children: /* @__PURE__ */ s.jsx(Rd, { type: h }) })
        ] }, `item-${h}`))
      }
    ),
    a.hardwareType === "old" && (u ? /* @__PURE__ */ s.jsx(Un, { pagination: !0, slidesPerView: 1, children: a.tvBoxes.map((h, p) => /* @__PURE__ */ s.jsxs($n, { children: [
      /* @__PURE__ */ s.jsx(zd, { setTopBoxFormikIndex: p }, p),
      /* @__PURE__ */ s.jsx("hr", { className: "divider-2 mb-2" })
    ] }, `swiper-slide-${p}`)) }) : a.tvBoxes.map((h, p) => /* @__PURE__ */ s.jsx(Dd, { setTopBoxFormikIndex: p }, p))),
    /* @__PURE__ */ s.jsx("hr", { className: "my-3" })
  ] });
}, dr = () => {
  const { unionText: t } = O(), { commonMessages: e } = t, [n, r] = w(), o = J((i) => {
    i.preventDefault(), history.back();
  }, []), a = J(() => {
    var i, l, d;
    (d = (l = (i = n == null ? void 0 : n.current) == null ? void 0 : i.shadowRoot) == null ? void 0 : l.querySelector("a")) == null || d.addEventListener(
      "click",
      o
    );
  }, [n, o]);
  return S(() => {
    const i = n == null ? void 0 : n.current;
    return i && (a(), i.addEventListener("o2Ready", a)), () => {
      i == null || i.removeEventListener("o2Ready", a);
    };
  }, [n, a]), /* @__PURE__ */ s.jsx(At, { children: /* @__PURE__ */ s.jsx(Rt, { onRef: r, href: "#back", "data-testid": "o2-breadcrumbs-item", children: e.breadcrumb }) });
};
const Fd = () => {
  const { loading: t } = ke(), { values: e, isSubmitting: n } = ee(), { unionText: r } = O(), { buyOutMessages: o } = r, a = $(() => n || t || !e.portinBuyOut || // isValid does not work well, when iban field is hidding
  e && e.portinBuyOut === "preplatit-zmluvnu-pokutu" && ws(e.portinBuyoutIban) !== void 0, [e, n, t]);
  return /* @__PURE__ */ s.jsx("div", { className: "row justify-content-center", children: /* @__PURE__ */ s.jsx("div", { className: "col-12 col-md-8 col-lg-6", children: /* @__PURE__ */ s.jsx("div", { className: "row justify-content-md-center", children: /* @__PURE__ */ s.jsx("div", { className: "col-md-10 col-lg-8", children: /* @__PURE__ */ s.jsx(
    ge,
    {
      id: "handle-next-step",
      className: "mb-3",
      fullwidth: !0,
      type: "submit",
      disabled: a,
      "data-o2-id": "handle-next-step",
      "data-testid": "handle-next-step",
      "data-o2-role": "action-submit",
      name: "handle-next-step",
      children: o.continue
    }
  ) }) }) }) });
}, Bd = () => {
  var T, C, _;
  const [t, e] = w(), [n, r] = w(), { config: o } = P(K), { getNextState: a, nextPage: i, redirectUrl: l, error: d, setError: c } = ke(), { quote: u, setQuote: m } = P(ne), { unionText: v, withParams: b } = O(), { buyOutMessages: f } = v, k = je(), { fetcher: h, data: p } = ve(
    o.chooseBuyOutModelUrl,
    {
      method: "POST",
      manual: !0
    }
  );
  S(() => {
    var z;
    h({
      contextTariff: (z = u == null ? void 0 : u.contextTariff) == null ? void 0 : z.seoId,
      transaction: u == null ? void 0 : u.transaction
    });
  }, [(T = u == null ? void 0 : u.contextTariff) == null ? void 0 : T.seoId, u == null ? void 0 : u.transaction, h]), S(() => {
    n != null && n.current && n.current.addEventListener(
      "click",
      (z) => {
        z.preventDefault(), k(-1);
      }
    );
  }, [n, k]), S(() => {
    i || l ? Ie(k, l, i) : we();
  }, [k, l, i]);
  const x = () => {
    t == null || t.current.show();
  }, y = (z) => ot(void 0, null, function* () {
    var E;
    u && m(
      G(H({}, u), {
        portinBuyOut: z.portinBuyOut,
        portinBuyoutIban: z.portinBuyOut === "preplatit-zmluvnu-pokutu" ? (E = z.portinBuyoutIban) == null ? void 0 : E.replace(/\s/g, "") : void 0
      }),
      () => a()
    );
  }), g = {
    portinBuyOut: (C = u == null ? void 0 : u.portinBuyOut) != null ? C : "",
    portinBuyoutIban: (_ = u == null ? void 0 : u.portinBuyoutIban) != null ? _ : ""
  };
  return /* @__PURE__ */ s.jsxs("div", { className: "choose-transaction", children: [
    /* @__PURE__ */ s.jsx(Ei, { onRef: e }),
    /* @__PURE__ */ s.jsx(Tt, { initialValues: g, onSubmit: y, children: /* @__PURE__ */ s.jsxs(
      Kt,
      {
        name: "chooseBuyoutForm",
        className: "form-horizontal",
        "data-o2-id": "chooseBuyoutForm",
        "data-testid": "chooseBuyoutForm",
        children: [
          /* @__PURE__ */ s.jsxs("div", { className: "flex-grow-1", children: [
            /* @__PURE__ */ s.jsx(At, { children: /* @__PURE__ */ s.jsx(Rt, { href: "#", onRef: r, "data-testid": "o2-breadcrumbs-item", children: f.breadcrumbs.back }) }),
            /* @__PURE__ */ s.jsx("div", { className: "row justify-content-center", children: /* @__PURE__ */ s.jsxs("div", { className: "col-12 col-md-8 col-lg-6", children: [
              /* @__PURE__ */ s.jsx("h1", { className: "text-center", children: f.title }),
              /* @__PURE__ */ s.jsx("p", { className: "text-lead text-secondary text-md-center mt-5 mb-2", children: p && b(f.fineAmount, { totalPrice: p.buyOutTotal }) }),
              /* @__PURE__ */ s.jsxs(
                "a",
                {
                  onClick: x,
                  id: "open-choose-transaction-info",
                  "data-testid": "open-choose-transaction-info-modal",
                  className: "mb-5 text-small d-flex justify-content-md-center gap-1",
                  children: [
                    f.learnMore,
                    " ",
                    /* @__PURE__ */ s.jsx(Q, { name: "info-circle", size: 18 })
                  ]
                }
              ),
              p && /* @__PURE__ */ s.jsx("div", { className: "radio-group", children: /* @__PURE__ */ s.jsx(Ns, { chooseBuyOut: p }) }),
              /* @__PURE__ */ s.jsx("hr", { className: "divider divider-gray" })
            ] }) })
          ] }),
          /* @__PURE__ */ s.jsx(Fd, {})
        ]
      }
    ) }),
    /* @__PURE__ */ s.jsx(or, { error: d, getNextState: a, setError: c })
  ] });
}, Hd = ({ device: t }) => {
  const { unionText: e } = O(), { chooseDeviceMessages: n } = e, [r, o] = w();
  return /* @__PURE__ */ s.jsxs("div", { className: "col-6 text-center o2-radio-box-vertical", children: [
    /* @__PURE__ */ s.jsxs(
      qe,
      {
        value: t.seoId,
        className: "d-inline-block border rounded",
        mx: 0,
        "data-o2-id": `device-${t.seoId}`,
        "data-testid": `device-${t.seoId}`,
        name: "radio--choose-router",
        children: [
          /* @__PURE__ */ s.jsx("div", { className: "mb-1 fw-bold", children: t.alias }),
          /* @__PURE__ */ s.jsx(Lr, { color: "blue", className: "mb-3", children: t.tag }),
          /* @__PURE__ */ s.jsx("p", { className: "fw-bold", children: t.customPrice }),
          /* @__PURE__ */ s.jsxs(
            "a",
            {
              onClick: () => r == null ? void 0 : r.current.show(),
              className: "text-small d-flex justify-content-center align-items-center gap-1",
              children: [
                n.learnMore,
                /* @__PURE__ */ s.jsx(Q, { name: "info-circle", size: 18 })
              ]
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ s.jsx(_i, { onRef: o, device: t })
  ] }, t.seoId);
};
const Ps = ({ extenders: t, selectedExtenders: e, setSelectedExtenders: n }) => {
  const { unionText: r } = O(), { chooseDeviceMessages: o } = r, a = be(), [i, l] = w(void 0);
  return /* @__PURE__ */ s.jsx(s.Fragment, { children: t && t.length > 0 && /* @__PURE__ */ s.jsxs("div", { id: "extenders-wizard-component", children: [
    /* @__PURE__ */ s.jsx(
      Ye,
      {
        id: "modal-install-method",
        "data-testid": "modal-install-method",
        size: "small",
        heading: i == null ? void 0 : i.name,
        o2Ref: a,
        children: /* @__PURE__ */ s.jsx("p", { children: i == null ? void 0 : i.description })
      }
    ),
    /* @__PURE__ */ s.jsx("h4", { className: "mb-0 mt-5 text-center", children: o.extenders.title }),
    /* @__PURE__ */ s.jsx("hr", { className: "divider divider-gray my-3" }),
    t.map((d, c) => /* @__PURE__ */ s.jsxs(It, { children: [
      /* @__PURE__ */ s.jsx(
        zr,
        {
          id: "extender-checkbox-" + c,
          name: "extenderCheckbox" + c,
          "data-o2-id": "extenderCheckbox" + c,
          "data-testid": "extenderCheckbox" + c,
          className: "alignItemsCenter",
          checked: e == null ? void 0 : e.includes(d.seoId),
          onChange: (u) => n((m) => {
            const v = m.filter((b) => b !== d.seoId);
            return u ? [...v, d.seoId] : v;
          }),
          children: /* @__PURE__ */ s.jsxs("div", { className: "row flex-nowrap", children: [
            /* @__PURE__ */ s.jsx("div", { className: "col-2", children: /* @__PURE__ */ s.jsx(B, { alignItems: "center", h: 100, children: d.imageUrl && /* @__PURE__ */ s.jsx(Et, { src: d.imageUrl, alt: d.name }) }) }),
            /* @__PURE__ */ s.jsx("div", { className: "col-7", children: /* @__PURE__ */ s.jsxs("div", { className: "extender__description", children: [
              /* @__PURE__ */ s.jsx("div", { className: "mb-1", children: d.name }),
              /* @__PURE__ */ s.jsx("div", { className: "mb-1 text-secondary", children: d.hint }),
              /* @__PURE__ */ s.jsxs(
                "a",
                {
                  className: "text-small d-flex align-items-center gap-1",
                  "data-testid": "open-extender-detail-popup",
                  onClick: (u) => {
                    var m;
                    u.preventDefault(), u.stopPropagation(), l(d), (m = a.current) == null || m.show();
                  },
                  children: [
                    o.extenders.more,
                    /* @__PURE__ */ s.jsx(pt, { size: 18 })
                  ]
                }
              )
            ] }) }),
            /* @__PURE__ */ s.jsx("div", { className: "col-3", children: /* @__PURE__ */ s.jsx("div", { className: "extender__price", children: d.price }) })
          ] })
        }
      ),
      /* @__PURE__ */ s.jsx("hr", { className: "divider divider-gray my-3" })
    ] }, "extender" + d.seoId + "_" + c))
  ] }) });
};
const Ud = () => {
  const { config: t, namespace: e } = P(K), { quote: n, setQuote: r } = P(ne), { unionText: o } = O(), { chooseDeviceMessages: a, commonMessages: i } = o, [l, d] = w(), [c, u] = w([]), [m, v] = w(!0);
  w({});
  const { getNextState: b, nextPage: f, redirectUrl: k, loading: h } = ke(), p = je(), {
    fetcher: x,
    loading: y,
    data: g,
    error: T
  } = ve(t.chooseRouterModelUrl, {
    method: "POST",
    manual: !0
  });
  S(() => {
    m && n && x(n);
  }, [x, n, m]);
  const C = $(() => {
    var E;
    return ((E = g == null ? void 0 : g.routers) == null ? void 0 : E.length) && g.routers.length > 0;
  }, [g]);
  S(() => {
    var I, D, M;
    if (!g)
      return;
    const E = (I = g.routers) == null ? void 0 : I.find(
      (N) => {
        var j, U;
        return (U = (j = n == null ? void 0 : n.contextHw) == null ? void 0 : j.seoIds) == null ? void 0 : U.includes(N.seoId);
      }
    );
    E ? d(E.seoId) : g.routers && d((D = g.routers[0]) == null ? void 0 : D.seoId), (M = g.extenders) != null && M.length && g.extenders.length > 0 && u(
      g.extenders.map((N) => N.seoId).filter((N) => {
        var j, U;
        return (U = (j = n == null ? void 0 : n.contextHw) == null ? void 0 : j.seoIds) == null ? void 0 : U.includes(N);
      })
    );
  }, [g, n == null ? void 0 : n.contextHw]), S(() => {
    f || k ? Ie(p, k, f) : we();
  }, [p, k, f]);
  const _ = $(() => {
    if (n != null && n.location) {
      const E = decodeURIComponent(escape(atob(n.location.substring(1)))), [I, D, M, N] = E.split("#"), j = new URLSearchParams({ lat: I, lng: D, address: M, crossId: N });
      return `${t.chooseInternetProgramUrl}?${j.toString()}`;
    }
    return t.chooseInternetUrl;
  }, [t.chooseInternetUrl, t.chooseInternetProgramUrl, n == null ? void 0 : n.location]), z = () => {
    if (!l)
      return;
    let E = n != null ? n : {};
    E = Ii(E, g == null ? void 0 : g.routers, l), E = ds(E, g == null ? void 0 : g.extenders, c), v(!1), r(E, () => b());
  };
  return /* @__PURE__ */ s.jsxs("div", { id: "choose-device-page", className: "content--wrapper", children: [
    !1,
    /* @__PURE__ */ s.jsxs("div", { className: "choose-hw", children: [
      /* @__PURE__ */ s.jsx(At, { children: /* @__PURE__ */ s.jsx(Rt, { href: _, children: a.breadcrumbs.backToChooseInternet }) }),
      /* @__PURE__ */ s.jsx("div", { className: "row justify-content-md-center", children: /* @__PURE__ */ s.jsxs("div", { className: "col-md-10 col-lg-8 col-xl-6", children: [
        /* @__PURE__ */ s.jsxs("div", { className: "text-center mb-5", children: [
          /* @__PURE__ */ s.jsx("h1", { children: a.title }),
          T && /* @__PURE__ */ s.jsx(ye, { color: "danger", "data-o2-role": "alert-system", "data-o2-portlet": e, children: i.error }),
          y && /* @__PURE__ */ s.jsx("div", { className: "center", children: /* @__PURE__ */ s.jsx(Q, { "data-testid": "loader", name: "loading", color: "blue-brand", size: 45 }) }),
          /* @__PURE__ */ s.jsx(Q, { name: "network-status", className: "mb-3", size: 48, color: "blue-brand" }),
          /* @__PURE__ */ s.jsx("div", { className: "h6 mb-1", children: g == null ? void 0 : g.program.displayName }),
          (g == null ? void 0 : g.program.priceDescription) && /* @__PURE__ */ s.jsx("div", { className: "text-secondary", children: g.program.priceDescription })
        ] }),
        !y && (g == null ? void 0 : g.routers) && !C && /* @__PURE__ */ s.jsx(ye, { color: "danger", "data-o2-role": "alert-system", "data-o2-portlet": e, children: a.noRoutersError }),
        C && /* @__PURE__ */ s.jsx(
          pn,
          {
            name: "radio--choose-hw",
            value: l,
            className: "radio--choose-hw",
            onChange: (E) => d(E.target.value),
            "data-o2-id": "select-router-device-radio-group",
            "data-testid": "select-router-device-radio-group",
            disabled: y || h,
            children: /* @__PURE__ */ s.jsx("div", { className: "row justify-content-center flex-grow-1", children: g == null ? void 0 : g.routers.map((E) => /* @__PURE__ */ s.jsx(Hd, { device: E }, E.seoId)) })
          }
        ),
        /* @__PURE__ */ s.jsx(
          Ps,
          {
            extenders: g == null ? void 0 : g.extenders,
            selectedExtenders: c,
            setSelectedExtenders: u
          }
        )
      ] }) })
    ] }),
    /* @__PURE__ */ s.jsx("div", { className: "row justify-content-md-center", children: /* @__PURE__ */ s.jsx("div", { className: "col-md-10 col-lg-8 col-xl-6", children: /* @__PURE__ */ s.jsx(
      ge,
      {
        fullwidth: !0,
        "data-o2-id": "go-next-step",
        "data-testid": "go-next-step",
        name: "go-next-step",
        onClick: z,
        disabled: h || y,
        children: a.nextStep
      }
    ) }) })
  ] });
}, $d = () => {
  const { unionText: t } = O(), { chooseDeviceMessages: e } = t;
  return /* @__PURE__ */ s.jsx(qt, { requiredQuote: !0, alertMessage: e.missingQuoteError, children: /* @__PURE__ */ s.jsx(Ud, {}) });
}, Vd = ["O2_MOBIL", "CASH", "OWN_DEVICE"], Gd = () => {
  var b;
  const t = be(), { getNextState: e, nextPage: n, redirectUrl: r, loading: o } = ke(), { quote: a, setQuote: i } = P(ne), { unionText: l } = O(), { chooseDevicePaymentsMessages: d } = l, c = je(), [u, m] = w(
    a != null && a.ownDevice ? "OWN_DEVICE" : (b = a == null ? void 0 : a.paymentMethod) != null ? b : "O2_MOBIL"
  );
  S(() => {
    t != null && t.current && t.current.addEventListener(
      "click",
      (f) => {
        f.preventDefault(), c(-1);
      }
    );
  }, [t, c]), S(() => {
    n || r ? Ie(c, r, n) : we();
  }, [c, r, n]);
  const v = () => {
    let f;
    switch (u) {
      case "OWN_DEVICE":
        f = Xe.CASH;
        break;
      case "CASH":
        f = Xe.CASH;
        break;
      case "O2_MOBIL":
        f = Xe.O2_MOBIL;
        break;
    }
    i(
      {
        paymentMethod: f,
        ownDevice: u === "OWN_DEVICE"
      },
      () => e()
    );
  };
  return /* @__PURE__ */ s.jsx("div", { id: "own-device-page", className: "content--wrapper", children: /* @__PURE__ */ s.jsxs("div", { className: "flex-grow-1", children: [
    /* @__PURE__ */ s.jsx(At, { className: "mb-0", children: /* @__PURE__ */ s.jsx(Rt, { href: "#", o2Ref: t, "data-testid": "o2-breadcrumbs-item", children: d.breadcrumbs.back }) }),
    /* @__PURE__ */ s.jsx("div", { className: "row justify-content-center", children: /* @__PURE__ */ s.jsxs("div", { className: "col-12 col-md-8 col-lg-6", children: [
      /* @__PURE__ */ s.jsx("h1", { className: "text-center", children: d.title }),
      /* @__PURE__ */ s.jsx("p", { className: "text-md-center mt-5 mb-1", children: d.subtitle }),
      /* @__PURE__ */ s.jsx(
        pn,
        {
          "data-o2-id": "devicePaymentMethodGroup",
          "data-testid": "devicePaymentMethodGroup",
          name: "devicePaymentMethodGroup",
          children: Vd.map((f) => /* @__PURE__ */ s.jsxs(It, { children: [
            /* @__PURE__ */ s.jsx("hr", { className: "divider" }),
            /* @__PURE__ */ s.jsx(
              qe,
              {
                value: f,
                name: "devicePaymentType",
                id: "devicePaymentType." + f,
                "data-o2-id": "devicePaymentType." + f,
                "data-testid": "devicePaymentType." + f,
                checked: u === f,
                onRadioChange: () => m(f),
                children: d.payments[f]
              }
            )
          ] }, "method" + f))
        }
      ),
      !1,
      /* @__PURE__ */ s.jsx("hr", { className: "divider divider-gray" }),
      /* @__PURE__ */ s.jsx("div", { className: "row justify-content-md-center", children: /* @__PURE__ */ s.jsx("div", { className: "col-md-10 col-lg-8 col-xl-6", children: /* @__PURE__ */ s.jsx(
        ge,
        {
          fullwidth: !0,
          "data-o2-id": "go-next-step",
          "data-testid": "go-next-step",
          name: "go-next-step",
          onClick: v,
          disabled: o,
          children: d.continue
        }
      ) }) })
    ] }) })
  ] }) });
}, Qd = "o2_center_icon__bLf8h", Wd = {
  center_icon: Qd
}, Yd = () => {
  var tt, nt, rt, Ze, Lt, ae, ze;
  const [t, e] = w(), { config: n, namespace: r } = P(K), { quote: o, initialized: a, setQuote: i } = P(ne), { unionText: l, withParams: d } = O(), { commonMessages: c, chooseTariffMessages: u, hwSliderMessages: m } = l, { getNextState: v, nextPage: b, redirectUrl: f, loading: k, error: h, setError: p } = ke(), x = je(), [y, g] = w(!0), [T, C] = w(), [_, z] = w(), [E, I] = w(!1), [D, M] = w(!1);
  S(() => {
    I(!0);
  }, [T]), S(() => {
    M(!0);
  }, [_]);
  const N = (o == null ? void 0 : o.transaction) === X.PORTIN, {
    data: j,
    fetcher: U,
    error: xe
  } = ve(n.chooseTariffModelUrl, {
    method: "POST",
    manual: !0
  }), [Te, Ae] = w(!1);
  S(() => {
    Ae(!0);
  }, [j]);
  const Re = J(
    (V, Se) => {
      var st;
      return V === lt.EXISTING_SIM ? Se === ((st = j == null ? void 0 : j.selectedTariff) == null ? void 0 : st.seoId) ? X.EXISTING : X.CHANGE : N ? X.PORTIN : X.ACTIVATION;
    },
    [(tt = j == null ? void 0 : j.selectedTariff) == null ? void 0 : tt.seoId, N]
  );
  S(() => {
    var V;
    T && E && (i({ operation: T, transaction: Re(T, (V = o == null ? void 0 : o.contextTariff) == null ? void 0 : V.seoId) }), g(!0), I(!1));
  }, [Re, E, T, (nt = o == null ? void 0 : o.contextTariff) == null ? void 0 : nt.seoId, i]), S(() => {
    _ && D && (i({
      contextTariff: { seoId: _ },
      transaction: Re(o == null ? void 0 : o.operation, _)
    }), g(!0), M(!1));
  }, [_, Re, D, o == null ? void 0 : o.operation, i]), S(() => {
    y && a && (U(o), g(!1));
  }, [y, U, a, o]), S(() => {
    if (j && Te) {
      const V = G(H({}, o), {
        contextTariff: { seoId: j.selectedTariff.seoId },
        operation: j.operation,
        transaction: j.transaction
      });
      i(V), Ae(!1);
    }
  }, [j, Te, o, i]), S(() => {
    b || f ? Ie(x, f, b) : we();
  }, [x, f, b]);
  const ht = $(
    () => j == null ? void 0 : j.tariffOptions.map((V) => ({
      text: V.displayName,
      value: V.seoId
    })),
    [j]
  ), ft = () => {
    v(void 0, void 0, void 0, (o == null ? void 0 : o.transaction) === "CHANGE");
  };
  return /* @__PURE__ */ s.jsxs("div", { id: "choose-tariff-page", children: [
    /* @__PURE__ */ s.jsx(dr, {}),
    /* @__PURE__ */ s.jsx("h1", { className: "text-center", children: u.title }),
    (xe || t && t.reasonCode !== "SUBSCRIBER_ALREADY_IN_ORDER") && /* @__PURE__ */ s.jsx(ye, { color: "danger", "data-o2-role": "alert-system", "data-o2-portlet": r, children: c.error }),
    !(xe || j) && /* @__PURE__ */ s.jsx("div", { className: "center", children: /* @__PURE__ */ s.jsx(Q, { "data-testid": "loader", name: "loading", color: "blue-brand", size: 45 }) }),
    j && /* @__PURE__ */ s.jsxs(It, { children: [
      /* @__PURE__ */ s.jsx("div", { className: "hw-products-wrapper", children: j.hwDevices && j.hwDevices.map((V) => /* @__PURE__ */ s.jsx(hs, { device: V, hidePrice: j.hidePrices }, V.id)) }),
      /* @__PURE__ */ s.jsx("div", { className: "row justify-content-md-center", children: /* @__PURE__ */ s.jsxs("div", { className: "col-12 col-md-10 col-lg-8 col-xl-6", children: [
        /* @__PURE__ */ s.jsxs(xt, { background: "blue-light", heading: "", "data-o2-id": "choose-tariff-box", "data-testid": "choose-tariff-box", children: [
          /* @__PURE__ */ s.jsx("div", { className: Wd.center_icon, children: /* @__PURE__ */ s.jsx(Q, { name: "plus-circle", color: "blue-brand", size: 24, solid: !0 }) }),
          j.subscriber !== void 0 && /* @__PURE__ */ s.jsxs(It, { children: [
            /* @__PURE__ */ s.jsx("div", { className: "choose-tariff--box mt-3", children: /* @__PURE__ */ s.jsxs(
              pn,
              {
                "data-o2-id": "operation-radio-button-group",
                "data-testid": "operation-radio-button-group",
                name: "operation",
                value: o == null ? void 0 : o.operation,
                className: "radio-group--subscriber-type",
                onChange: (V) => {
                  C(V.target.value);
                },
                children: [
                  /* @__PURE__ */ s.jsxs(
                    qe,
                    {
                      "data-o2-id": "operation-existing-sim",
                      "data-testid": "operation-existing-sim",
                      name: "operation",
                      value: lt.EXISTING_SIM,
                      disabled: k,
                      className: "mb-2",
                      children: [
                        u.existingSim,
                        /* @__PURE__ */ s.jsx("div", { className: "fw-normal text-small text-secondary", children: j.subscriber.msisdn })
                      ]
                    }
                  ),
                  /* @__PURE__ */ s.jsxs(
                    qe,
                    {
                      "data-o2-id": "operation-new-sim",
                      "data-testid": "operation-new-sim",
                      name: "operation",
                      value: lt.NEW_SIM,
                      disabled: k,
                      children: [
                        u.newSim,
                        /* @__PURE__ */ s.jsx("div", { className: "fw-normal text-small text-secondary", children: u.newCustomer })
                      ]
                    }
                  )
                ]
              }
            ) }),
            /* @__PURE__ */ s.jsx("hr", {})
          ] }),
          /* @__PURE__ */ s.jsx(
            qs,
            {
              "data-o2-id": "tariff-select",
              className: "mb-0",
              "data-testid": "tariff-select",
              id: "select-tariff",
              name: "selectTariff",
              label: u.tariff,
              dataOptions: ht,
              value: (rt = o == null ? void 0 : o.contextTariff) == null ? void 0 : rt.seoId,
              disabled: j.tariffOptions.length === 1 || k,
              onChange: (V) => {
                z(V.target.value);
              }
            },
            (Ze = o == null ? void 0 : o.contextTariff) == null ? void 0 : Ze.seoId
          ),
          /* @__PURE__ */ s.jsx("hr", { className: "mb-4" }),
          j.selectedTariff.longDescription && /* @__PURE__ */ s.jsx("div", { dangerouslySetInnerHTML: { __html: j.selectedTariff.longDescription } }),
          /* @__PURE__ */ s.jsx("hr", { className: "my-4" }),
          /* @__PURE__ */ s.jsx(yd, { setFetchNewModel: g })
        ] }),
        j.subscriber !== void 0 && (o == null ? void 0 : o.operation) === lt.EXISTING_SIM && j.selectedTariff.seoId !== j.subscriber.tariff.seoId && /* @__PURE__ */ s.jsxs(ye, { color: "warning", children: [
          /* @__PURE__ */ s.jsxs("div", { slot: "heading", children: [
            /* @__PURE__ */ s.jsx(Q, { name: "exclamation-circle", solid: !0, color: "orange" }),
            /* @__PURE__ */ s.jsx("span", { className: "ms-2", children: u.tariffChange })
          ] }),
          /* @__PURE__ */ s.jsxs("p", { children: [
            j.pricingInfo.sumOfBonusItems > 0 && d(u.budgetIncrease, {
              amount: me(j.pricingInfo.sumOfBonusItems)
            }),
            j.pricingInfo.sumOfBonusItems < 0 && d(u.budgetDecrease, {
              amount: me(j.pricingInfo.sumOfBonusItems * -1)
            })
          ] })
        ] }),
        j.pricingInfo.missingPriceForSuccessfulHirePurchase !== 0 && /* @__PURE__ */ s.jsx(ye, { color: "purple", heading: u.goodToKnow, children: /* @__PURE__ */ s.jsx("p", { children: d(u.buyMoreStuff, {
          amount: me(j.pricingInfo.missingPriceForSuccessfulHirePurchase)
        }) }) }),
        j.pricingInfo.missingPriceForSuccessfulHirePurchase === 0 && j.pricingInfo.canApplySliderLogic && /* @__PURE__ */ s.jsx(
          ye,
          {
            color: "purple",
            heading: j.hidePrices ? u.tripletsHeading : u.goodToKnow,
            children: /* @__PURE__ */ s.jsx("p", { "data-testid": "alert-prices", children: j.hidePrices ? u.tripletsText : u.canUseSliderText })
          }
        ),
        /* @__PURE__ */ s.jsx("div", { className: "divider" }),
        j.pricingInfo.missingPriceForSuccessfulHirePurchase === 0 && !j.hidePrices && /* @__PURE__ */ s.jsxs("div", { className: "price-calculator-list", children: [
          /* @__PURE__ */ s.jsxs("div", { className: "d-flex", children: [
            /* @__PURE__ */ s.jsxs("div", { className: "flex-grow-1", children: [
              /* @__PURE__ */ s.jsx("span", { className: "fw-bold", children: u.advancePayment }),
              /* @__PURE__ */ s.jsx("div", { className: "d-inline-flex", children: /* @__PURE__ */ s.jsx(tn, { content: u.advancePaymentTooltip, children: /* @__PURE__ */ s.jsx(Q, { className: "o2-icon--tooltip", name: "question-circle", solid: !0, size: 24 }) }) })
            ] }),
            /* @__PURE__ */ s.jsx("div", { className: "fw-bold", children: /* @__PURE__ */ s.jsx(Ne, { price: j.pricingInfo.chosenAdvancePayment }) })
          ] }),
          /* @__PURE__ */ s.jsxs(
            Fr,
            {
              type: "summary",
              heading: u.pricingDropdownHeading,
              headingRight: d(m.monthlyAmountValue, {
                amount: me(j.pricingInfo.pricingDropdown.monthlyPrice)
              }),
              children: [
                /* @__PURE__ */ s.jsx(Q, { slot: "icon", name: "chevron-down-circle", size: 22, solid: !0 }),
                j.pricingInfo.pricingDropdown.tariff && /* @__PURE__ */ s.jsxs("div", { className: "d-flex justify-content-between mb-1", children: [
                  /* @__PURE__ */ s.jsx("div", { children: j.pricingInfo.pricingDropdown.tariff.displayName }),
                  /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx(
                    Ne,
                    {
                      price: j.pricingInfo.pricingDropdown.tariff.amount,
                      chargePeriod: "MONTHLY"
                    }
                  ) })
                ] }),
                j.pricingInfo.pricingDropdown.installmentAmount && /* @__PURE__ */ s.jsxs("div", { className: "d-flex justify-content-between mb-1", children: [
                  /* @__PURE__ */ s.jsx("div", { children: j.pricingInfo.pricingDropdown.installmentAmount.displayName }),
                  /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx(
                    Ne,
                    {
                      price: j.pricingInfo.pricingDropdown.installmentAmount.amount,
                      chargePeriod: "MONTHLY"
                    }
                  ) })
                ] }),
                (Lt = j.pricingInfo.pricingDropdown.hwDevices) == null ? void 0 : Lt.map((V, Se) => /* @__PURE__ */ s.jsx("div", { className: "text-small text-secondary mb-2", children: V }, Se)),
                j.pricingInfo.pricingDropdown.newRegularBonus && /* @__PURE__ */ s.jsxs("div", { className: "d-flex justify-content-between mb-1", children: [
                  /* @__PURE__ */ s.jsx("div", { children: j.pricingInfo.pricingDropdown.newRegularBonus.displayName }),
                  /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx(
                    Ne,
                    {
                      price: j.pricingInfo.pricingDropdown.newRegularBonus.amount,
                      chargePeriod: "MONTHLY"
                    }
                  ) })
                ] }),
                (ae = j.pricingInfo.pricingDropdown.newExtraBonuses) == null ? void 0 : ae.map((V, Se) => /* @__PURE__ */ s.jsxs("div", { className: "d-flex justify-content-between mb-1", children: [
                  /* @__PURE__ */ s.jsx("div", { children: V.displayName }),
                  /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx(Ne, { price: V.amount, chargePeriod: "MONTHLY" }) })
                ] }, Se)),
                j.pricingInfo.pricingDropdown.appliedBudget && /* @__PURE__ */ s.jsxs("div", { className: "d-flex justify-content-between", children: [
                  /* @__PURE__ */ s.jsx("div", { children: j.pricingInfo.pricingDropdown.appliedBudget.displayName }),
                  /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx(
                    Ne,
                    {
                      price: j.pricingInfo.pricingDropdown.appliedBudget.amount,
                      chargePeriod: "MONTHLY"
                    }
                  ) })
                ] }),
                (ze = j.pricingInfo.pricingDropdown.hwInsurances) == null ? void 0 : ze.map((V, Se) => /* @__PURE__ */ s.jsxs("div", { className: "d-flex justify-content-between mb-1", children: [
                  /* @__PURE__ */ s.jsx("div", { children: V.displayName }),
                  /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx(Ne, { price: V.amount, chargePeriod: "MONTHLY" }) })
                ] }, "insurance_" + Se))
              ]
            }
          ),
          /* @__PURE__ */ s.jsx("div", { className: "divider" })
        ] }),
        /* @__PURE__ */ s.jsx("div", { className: "row justify-content-md-center", children: /* @__PURE__ */ s.jsx("div", { className: "col-12 col-sm-8", children: /* @__PURE__ */ s.jsx(
          ge,
          {
            disabled: k,
            id: "choose-tariff-submit-button",
            fullwidth: !0,
            "data-o2-id": "chooseTariff.submit",
            "data-testid": "chooseTariff.submit",
            name: "chooseTariff.submit",
            onClick: ft,
            children: (o == null ? void 0 : o.operation) === lt.EXISTING_SIM ? /* @__PURE__ */ s.jsxs(It, { children: [
              /* @__PURE__ */ s.jsx(Q, { name: "checkout", className: "me-2" }),
              /* @__PURE__ */ s.jsx("span", { children: u.addToCart })
            ] }) : u.continue
          }
        ) }) })
      ] }) }),
      /* @__PURE__ */ s.jsx(
        or,
        {
          error: h,
          setError: p,
          getNextState: v,
          tariffName: j.selectedTariff.displayName,
          onError: e
        }
      )
    ] })
  ] });
}, Zd = () => {
  const { unionText: t } = O(), { chooseTariffMessages: e } = t;
  return /* @__PURE__ */ s.jsx(qt, { requiredData: ["contextHw"], alertMessage: e.missingHwDevicesError, children: /* @__PURE__ */ s.jsx(Yd, {}) });
}, Xd = () => {
  var Te, Ae, Re, ht, ft, tt, nt, rt, Ze, Lt;
  const [t, e] = w(), { unionText: n, withParams: r } = O(), { commonMessages: o, chooseTransactionMessages: a } = n, i = je(), { getNextState: l, nextPage: d, redirectUrl: c, loading: u, error: m, setError: v } = ke(), { namespace: b, config: f } = P(K), { setIsLoading: k } = P(Fe), { quote: h, setQuote: p } = P(ne), x = (Te = h == null ? void 0 : h.contextTariff) == null ? void 0 : Te.seoId, { data: y, error: g } = ve(
    f.chooseTransactionModelUrl + "?contextTariff=" + ((Ae = h == null ? void 0 : h.contextTariff) == null ? void 0 : Ae.seoId) + "&hasContextHw=" + (h != null && h.contextHw ? "true" : "false")
  ), {
    data: T,
    fetcher: C,
    error: _
  } = ve(f.chooseBuyOutModelUrl, {
    method: "POST",
    manual: !0
  });
  S(() => {
    x && C({
      contextTariff: x,
      transaction: X.PORTIN
    });
  }, [x, C]);
  const z = $(() => {
    var ae, ze;
    if ((ae = T == null ? void 0 : T.buyOuts) != null && ae.length && ((ze = T == null ? void 0 : T.buyOuts) == null ? void 0 : ze.length) > 1)
      return T;
  }, [T]), E = $(
    () => !(h != null && h.contextHw) && (y == null ? void 0 : y.isChangeTariffVisible),
    [h == null ? void 0 : h.contextHw, y == null ? void 0 : y.isChangeTariffVisible]
  ), I = {
    transaction: (Re = h == null ? void 0 : h.transaction) != null ? Re : (
      /* Formik hack */
      ""
    ),
    portinMsisdn: (ht = h == null ? void 0 : h.portinMsisdn) != null ? ht : "",
    pickedMsisdn: h == null ? void 0 : h.pickedMsisdn,
    desiredMsisdn: us((ft = h == null ? void 0 : h.pickedMsisdn) == null ? void 0 : ft.msisdn),
    desiredMsisdnQuery: (tt = h == null ? void 0 : h.pickedMsisdn) == null ? void 0 : tt.pattern,
    pun: (rt = (nt = h == null ? void 0 : h.pickedMsisdn) == null ? void 0 : nt.pun) != null ? rt : "",
    punRequired: !!((Ze = h == null ? void 0 : h.pickedMsisdn) != null && Ze.pun),
    portinBuyOut: (Lt = h == null ? void 0 : h.portinBuyOut) != null ? Lt : "",
    portinBuyoutIban: ""
  }, [D, M] = w(!!I.pickedMsisdn), [N, j] = w(!1), U = (ae) => ot(void 0, null, function* () {
    var ze;
    if (h) {
      const V = ae.pickedMsisdn ? G(H({}, ae.pickedMsisdn), {
        msisdn: ae.pickedMsisdn.msisdn.replace(/\s/g, ""),
        pun: ae.pun.toUpperCase(),
        pattern: cn(ae.desiredMsisdnQuery)
      }) : ae.pickedMsisdn, Se = G(H({}, h), {
        transaction: ae.transaction,
        portinMsisdn: ae.transaction === X.PORTIN ? ae.portinMsisdn.trim() : h.portinMsisdn,
        pickedMsisdn: ae.transaction === X.ACTIVATION ? V : h.pickedMsisdn,
        portinBuyOut: ae.portinBuyOut,
        portinBuyoutIban: ae.portinBuyOut === "preplatit-zmluvnu-pokutu" ? (ze = ae.portinBuyoutIban) == null ? void 0 : ze.replace(/\s/g, "") : void 0
      });
      p(Se, (st) => l(void 0, void 0, void 0, (st == null ? void 0 : st.transaction) === "CHANGE"));
    }
  }), xe = $(() => {
    var ae, ze;
    if (g && g.validationResults) {
      const V = g.validationResults[0];
      if ((V == null ? void 0 : V.reasonCode) === "TARIFF_NOT_FOUND") {
        const Se = (ae = V.validationParams) == null ? void 0 : ae.find((st) => st.key === "TARIFF");
        return r(o.notFound, {
          entity: (ze = Se == null ? void 0 : Se.value) != null ? ze : ""
        });
      }
      return o.error;
    }
    return m && !t && !(m != null && m.skuCanBeLost) ? o.error : (t == null ? void 0 : t.reasonCode) === "CONFLICTING_GROUP_IN_QUOTE" || (t == null ? void 0 : t.reasonCode) === "SUBSCRIBER_ALREADY_IN_ORDER" || (t == null ? void 0 : t.reasonCode) === "NOT_ELIGIBLE_WITH_FIX_PROGRAM" || (t == null ? void 0 : t.reasonCode) === "DUPLICATED_PORTIN_MSISDN" || m != null && m.skuCanBeLost ? "" : (t == null ? void 0 : t.reasonCode) === "NOT_ELIGIBLE_TARIFF" ? a.error : (t == null ? void 0 : t.reasonCode) === "CAN_NOT_USE_PICKED_MSISDN" ? a.activationError : "";
  }, [
    g,
    a.activationError,
    a.error,
    o.error,
    o.notFound,
    m,
    t,
    r
  ]);
  return S(() => {
    d || c ? Ie(i, c, d) : we();
  }, [i, c, d]), S(() => {
    k(u);
  }, [u, k]), /* @__PURE__ */ s.jsx("div", { className: "choose-transaction", children: /* @__PURE__ */ s.jsxs("div", { className: "flex-grow-1", children: [
    /* @__PURE__ */ s.jsx(dr, {}),
    /* @__PURE__ */ s.jsx("div", { className: "row justify-content-center", children: /* @__PURE__ */ s.jsxs("div", { className: "col-12 col-md-8 col-lg-6", children: [
      /* @__PURE__ */ s.jsx("h1", { className: "text-center", children: a.heading }),
      /* @__PURE__ */ s.jsx("p", { className: "text-lead text-secondary text-center mb-5", children: a.description }),
      xe && /* @__PURE__ */ s.jsx(ye, { color: "danger", "data-o2-role": "alert-system", "data-o2-portlet": b, children: /* @__PURE__ */ s.jsx("div", { dangerouslySetInnerHTML: { __html: xe } }) }),
      y && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
        /* @__PURE__ */ s.jsx(Tt, { initialValues: I, onSubmit: U, children: /* @__PURE__ */ s.jsxs(
          Kt,
          {
            name: "chooseTransactionForm",
            className: "form-horizontal",
            "data-o2-id": "chooseTransactionForm",
            "data-testid": "chooseTransactionForm",
            children: [
              /* @__PURE__ */ s.jsxs("div", { className: "radio-group", children: [
                E && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
                  /* @__PURE__ */ s.jsx("hr", { className: "divider divider-gray" }),
                  /* @__PURE__ */ s.jsx(Od, { chooseTransactionModel: y })
                ] }),
                /* @__PURE__ */ s.jsx("hr", { className: "divider divider-gray" }),
                /* @__PURE__ */ s.jsx(
                  Sd,
                  {
                    errorParams: t,
                    setShowForm: M,
                    showForm: D,
                    showDepositInfo: y.showActivationDepositInfo
                  }
                ),
                /* @__PURE__ */ s.jsx("hr", { className: "divider divider-gray" }),
                _ && /* @__PURE__ */ s.jsx(ye, { color: "danger", "data-o2-role": "alert-system", "data-o2-portlet": b, children: o.error }),
                /* @__PURE__ */ s.jsx(
                  Ed,
                  {
                    errorParams: t,
                    setShowBuyOutForm: j,
                    chooseBuyOutModel: z,
                    showBuyOutForm: N
                  }
                ),
                /* @__PURE__ */ s.jsx("hr", { className: "divider divider-gray" })
              ] }),
              /* @__PURE__ */ s.jsx(
                Ad,
                {
                  chooseTransactionModel: y,
                  showActivationForm: D,
                  showBuyOutForm: N,
                  setShowBuyOutForm: j,
                  hasBuyoutOptions: !!z
                }
              )
            ]
          }
        ) }),
        /* @__PURE__ */ s.jsx(
          or,
          {
            error: m,
            setError: v,
            getNextState: l,
            tariffName: y.selectedTariffName,
            onError: e
          }
        )
      ] })
    ] }) })
  ] }) });
}, Kd = () => {
  const { unionText: t } = O(), { chooseTransactionMessages: e } = t;
  return /* @__PURE__ */ s.jsx(
    qt,
    {
      requiredQuote: !0,
      requiredData: ["contextTariff"],
      alertMessage: e.missingQuoteError,
      children: /* @__PURE__ */ s.jsx(Xd, {})
    }
  );
}, qd = {
  cardinalityLimitReached: !1,
  crossSell: {
    programs: [],
    devices: [],
    addons: [],
    cardinalityLimitReached: !1,
    containsDatahome: !1
  },
  refreshCrossSell: () => {
  },
  crossSellLoading: !1,
  hasOnlyPrograms: !1
}, Ms = mt(qd), Jd = ({
  cardinalityLimitReached: t,
  crossSell: e,
  refreshCrossSell: n,
  crossSellLoading: r,
  hasOnlyPrograms: o,
  children: a
}) => /* @__PURE__ */ s.jsx(
  Ms.Provider,
  {
    value: {
      cardinalityLimitReached: !!t,
      crossSell: e,
      refreshCrossSell: n,
      crossSellLoading: r,
      hasOnlyPrograms: o
    },
    children: a
  }
), ec = () => {
  const { crossSell: t, refreshCrossSell: e, crossSellLoading: n, hasOnlyPrograms: r } = P(Ms), { manuallyAddedPrograms: o } = P(Dt), i = [...o.filter(
    (l) => {
      var d;
      return !((d = t.programs) != null && d.map((c) => c.seoId).includes(l.seoId));
    }
  ), ...t.programs || []];
  return i.length === 0 ? null : /* @__PURE__ */ s.jsx(L, { as: "section", bg: "gray-ultra-light", children: /* @__PURE__ */ s.jsx(
    il,
    {
      programs: i,
      crossSell: t,
      refreshCrossSell: e,
      crossSellLoading: n,
      hasOnlyPrograms: r
    }
  ) });
};
const Ar = () => {
  var T, C, _;
  const t = be(null), e = be(null), n = be(!0), { config: r } = P(K), { getNextState: o, nextPage: a, redirectUrl: i, error: l } = ke(), { quote: d } = P(ne), c = $s(d), u = je(), {
    data: m,
    fetcher: v,
    loading: b,
    error: f
  } = ve(r.crossSellModelUrl, {
    method: "POST",
    manual: !0
  }), k = !!m, h = !!((T = m == null ? void 0 : m.programs) != null && T.length), p = !!((C = m == null ? void 0 : m.addons) != null && C.length), x = !!((_ = m == null ? void 0 : m.devices) != null && _.length), y = h && !p && !x, g = !!r.canAddMaterial;
  return S(() => {
    var z;
    d && !Qt(d, c || {}) && (v(d), (z = window.updateMiniCartItemCount) == null || z.call(window));
  }, [v, c, d]), S(() => {
    /* istanbul ignore else - @preserve */
    (a || i) && Ie(u, i, a);
  }, [u, i, a]), S(() => {
    m && n.current && (!h && !p && !x && !f ? o() : (we(), os({ crossSell: m })), n.current = !1);
  }, [m, f, o, p, x, h]), /* @__PURE__ */ s.jsxs("div", { id: "addons-page", className: "mt-4", children: [
    /* @__PURE__ */ s.jsxs(Do, { children: [
      /* @__PURE__ */ s.jsxs("section", { className: "bg-white", children: [
        /* @__PURE__ */ s.jsx(nl, { error: f || l }),
        k && /* @__PURE__ */ s.jsx(sl, { containsDatahome: m.containsDatahome, containsTv: m.containsTv }),
        g && /* @__PURE__ */ s.jsx(Ai, {})
      ] }),
      k && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
        /* @__PURE__ */ s.jsx(
          Jd,
          {
            cardinalityLimitReached: m.cardinalityLimitReached,
            crossSell: m,
            refreshCrossSell: v,
            crossSellLoading: b,
            hasOnlyPrograms: y,
            children: /* @__PURE__ */ s.jsx(ec, {})
          }
        ),
        /* @__PURE__ */ s.jsx(
          Lo,
          {
            crossSell: m,
            refreshCrossSell: v,
            crossSellLoading: b,
            children: /* @__PURE__ */ s.jsx(tl, {})
          }
        ),
        /* @__PURE__ */ s.jsx(
          ao,
          {
            crossSell: m,
            refreshCrossSell: v,
            crossSellLoading: b,
            children: /* @__PURE__ */ s.jsx(Vi, {})
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ s.jsx("div", { id: "stickyAreaDivider", ref: t }),
    /* @__PURE__ */ s.jsx("div", { ref: e, children: /* @__PURE__ */ s.jsx(
      ll,
      {
        observedRef: t,
        targetRef: e,
        containsDatahome: !!(m != null && m.containsDatahome),
        getNextState: o
      }
    ) })
  ] });
};
const tc = ({ error: t }) => {
  const { unionText: e, withParams: n } = O(), { commonMessages: r, errorMessages: o } = e, a = $(
    () => {
      var i;
      return (i = t == null ? void 0 : t.validationResults) == null ? void 0 : i.map((l) => {
        var d, c;
        if (l.reasonCode === "NOT_FOUND") {
          const u = (d = l.validationParams) == null ? void 0 : d.find((m) => m.key === "entityId");
          return n(r.notFound, {
            entity: (c = u == null ? void 0 : u.value) != null ? c : ""
          });
        }
        return o[l.reasonCode] || o.DEFAULT_MESSAGE;
      });
    },
    [r.notFound, t == null ? void 0 : t.validationResults, o, n]
  );
  return /* @__PURE__ */ s.jsx(s.Fragment, { children: /* @__PURE__ */ s.jsxs("div", { className: "row justify-content-center", children: [
    /* @__PURE__ */ s.jsxs("div", { className: "col-12 col-lg-8 center", children: [
      /* @__PURE__ */ s.jsx("h1", { children: o.DEFAULT_MESSAGE_TITLE }),
      /* @__PURE__ */ s.jsx("div", { className: "errors-wrapper", children: a == null ? void 0 : a.map((i, l) => /* @__PURE__ */ s.jsx("p", { dangerouslySetInnerHTML: { __html: i } }, l)) })
    ] }),
    /* @__PURE__ */ s.jsx(
      Vn,
      {
        src: "https://www.o2.sk/documents/2355222/180577834/item-failed-in-basket.png",
        skipWebp: !0,
        className: "text-center"
      }
    ),
    /* @__PURE__ */ s.jsx("div", { className: "col-12 col-lg-8 center", children: /* @__PURE__ */ s.jsx("div", { className: "row justify-content-center", children: /* @__PURE__ */ s.jsx("div", { className: "col-12 col-sm-6 center", children: /* @__PURE__ */ s.jsx(
      ge,
      {
        id: "continue-btn",
        "data-o2-id": "wizard.error.page.continue",
        "data-testid": "wizard.error.page.continue",
        name: "wizard.error.page.continue",
        onClick: () => {
          history.back();
        },
        fullwidth: !0,
        children: o.DEFAULT_BUTTON_TEXT
      }
    ) }) }) })
  ] }) });
}, nc = () => {
  const { config: t, namespace: e } = P(K), { unionText: n, withParams: r } = O(), { commonMessages: o, hwSliderMessages: a } = n, [i, l] = w([]), [d, c] = w(-1), [u, m] = w("primary"), [v, b] = w("purple"), [f, k] = w(""), [h, p] = w(!0), [x, y] = w(!1);
  S(() => {
    y(!0);
  }, [d]);
  const {
    data: g,
    fetcher: T,
    error: C
  } = ve(t.hwSliderModelUrl, {
    method: "GET",
    manual: !0
  }), {
    data: _,
    fetcher: z,
    error: E
  } = ve(t.processItemsChangeUrl, {
    method: "POST",
    manual: !0
  });
  S(() => {
    const j = window.location.href;
    history.pushState(null, "", `${window.location.pathname}#${q.CART}`), history.pushState(null, "", j);
  }, []), S(() => {
    _ != null && _.redirectUrl && window.liferayRedirect(_.redirectUrl);
  }, [_]), S(() => {
    g && (g.redirectUrl ? window.liferayRedirect(g.redirectUrl) : (c(g.chosenAdvancePayment), we()));
  }, [g]);
  const I = J(() => {
    const j = as(g.hwDevices) - d;
    return Math.round((j + Number.EPSILON) * 100) / 100;
  }, [d, g]), D = J(() => {
    const j = I() / g.installmentCount;
    return Math.round((j + Number.EPSILON) * 100) / 100;
  }, [I, g]);
  S(() => {
    g && !g.redirectUrl && x && (b(d < g.defaultAdvancePayment ? "warning" : "purple"), m(d < g.defaultAdvancePayment ? "warning" : "primary"), l(bi(g.availableBonuses, D())), k(yi(g, d, a)), y(!1));
  }, [d, D, g, x, a]), S(() => {
    var j;
    h && (T(), (j = window.updateMiniCartItemCount) == null || j.call(window), p(!1));
  }, [T, h]);
  const M = () => i.reduce((j, U) => j + U.amount, 0), N = () => {
    z({
      orderItemId: g == null ? void 0 : g.orderItemId,
      chosenAdvancePayment: d
    });
  };
  return /* @__PURE__ */ s.jsxs("div", { className: "mt-4", children: [
    (C || E) && /* @__PURE__ */ s.jsx(ye, { color: "danger", "data-o2-role": "alert-system", "data-o2-portlet": e, children: o.error }),
    !(C || E || g) && /* @__PURE__ */ s.jsx("div", { className: "center", children: /* @__PURE__ */ s.jsx(Q, { "data-testid": "loader", name: "loading", color: "blue-brand", size: 45 }) }),
    g && !g.redirectUrl && /* @__PURE__ */ s.jsxs("div", { id: "hw-slider-page", children: [
      /* @__PURE__ */ s.jsx("h1", { className: "text-center", children: a.title }),
      /* @__PURE__ */ s.jsx("p", { className: "text-subtitle text-center text-secondary", children: a.subTitle }),
      /* @__PURE__ */ s.jsx("div", { className: "hw-products-wrapper", children: g.hwDevices && g.hwDevices.map((j) => /* @__PURE__ */ s.jsx(hs, { device: j, hidePrice: !1 }, j.id)) }),
      /* @__PURE__ */ s.jsx("div", { className: "divider divider-gray d-none d-md-block" }),
      /* @__PURE__ */ s.jsx("div", { className: "row justify-content-md-center", children: /* @__PURE__ */ s.jsxs("div", { className: "col-md-8 col-lg-6 col-xl-6", children: [
        /* @__PURE__ */ s.jsxs("div", { className: "price-calculator-list", children: [
          /* @__PURE__ */ s.jsxs("div", { className: "d-flex", children: [
            /* @__PURE__ */ s.jsxs("div", { className: "flex-grow-1", children: [
              /* @__PURE__ */ s.jsx("span", { className: "fw-bold", children: a.instalationAmountText }),
              /* @__PURE__ */ s.jsx("span", { id: "installation-amount", children: /* @__PURE__ */ s.jsx(Q, { name: "question-circle", solid: !0, size: 24, className: "o2-icon--tooltip ms-1" }) }),
              /* @__PURE__ */ s.jsx(
                tn,
                {
                  htmlFor: "installation-amount",
                  content: r(a.instalationAmountTooltip, {
                    installmentCount: `${g.installmentCount}`,
                    installmentValue: `${12 / g.installmentCount}`
                  })
                }
              ),
              /* @__PURE__ */ s.jsx("div", { className: "text-secondary text-small fw-normal mt-1", children: r(a.instalationTotalPriceText, {
                installmentTotalPrice: me(I()),
                installmentCount: `${g.installmentCount}`
              }) })
            ] }),
            /* @__PURE__ */ s.jsx("div", { className: "fw-bold", children: /* @__PURE__ */ s.jsx(Ne, { price: D(), chargePeriod: "MONTHLY" }) })
          ] }),
          M() > 0 && /* @__PURE__ */ s.jsxs(
            Fr,
            {
              type: "summary",
              headingRight: r(a.bonusAmount, {
                amount: me(M())
              }),
              disabled: i.length <= 1,
              open: !1,
              children: [
                /* @__PURE__ */ s.jsx(Q, { slot: "icon", name: "chevron-down-circle", size: 22, solid: !0 }),
                /* @__PURE__ */ s.jsxs("div", { slot: "heading", children: [
                  a.sumOfUsedBonusesText,
                  /* @__PURE__ */ s.jsx("span", { id: "used-bonuses", children: /* @__PURE__ */ s.jsx(Q, { name: "question-circle", solid: !0, size: 24, className: "o2-icon--tooltip ms-1" }) }),
                  /* @__PURE__ */ s.jsx(tn, { htmlFor: "used-bonuses", content: a.usedBonusesTooltip })
                ] }),
                i.length > 1 && i.sort((j, U) => j.displayOrder > U.displayOrder ? 1 : -1).map((j, U) => /* @__PURE__ */ s.jsxs("div", { className: "d-flex justify-content-between", children: [
                  /* @__PURE__ */ s.jsx("div", { children: j.displayName }),
                  /* @__PURE__ */ s.jsx("div", { children: r(a.bonusAmount, { amount: me(j.amount) }) })
                ] }, U))
              ]
            }
          ),
          /* @__PURE__ */ s.jsxs("div", { className: "d-flex mt-3", children: [
            /* @__PURE__ */ s.jsxs("div", { className: "flex-grow-1", children: [
              /* @__PURE__ */ s.jsx("span", { className: "fw-bold", children: a.chosenAdvancePayment }),
              /* @__PURE__ */ s.jsx("span", { id: "advance-payment", children: /* @__PURE__ */ s.jsx(Q, { name: "question-circle", solid: !0, size: 24, className: "o2-icon--tooltip ms-1" }) }),
              /* @__PURE__ */ s.jsx(tn, { htmlFor: "advance-payment", content: a.chosenAdvancePaymentTooltip })
            ] }),
            /* @__PURE__ */ s.jsx("div", { className: "fw-bold", id: "dynamic-price", children: /* @__PURE__ */ s.jsx(Gt, { portlet: e, children: /* @__PURE__ */ s.jsx(Ne, { price: d }) }) })
          ] })
        ] }),
        /* @__PURE__ */ s.jsx(Gt, { portlet: e, children: /* @__PURE__ */ s.jsx(
          bd,
          {
            hwSliderModel: g,
            color: u,
            advancePayment: d,
            onUpdate: c
          }
        ) }),
        /* @__PURE__ */ s.jsx(ye, { color: v, heading: a.hintHeading, children: /* @__PURE__ */ s.jsx("p", { children: f }) }),
        /* @__PURE__ */ s.jsx("div", { className: "row justify-content-center", children: /* @__PURE__ */ s.jsx("div", { className: "col-12 col-sm-8", children: /* @__PURE__ */ s.jsx(
          ge,
          {
            id: "hw-slider-submit-button",
            fullwidth: !0,
            "data-o2-id": "hwSliderPage.submit",
            "data-testid": "hwSliderPage.submit",
            name: "hwSliderPage.submit",
            onClick: N,
            children: a.submitText
          }
        ) }) })
      ] }) })
    ] })
  ] });
}, rc = () => {
  const { config: t, namespace: e } = P(K), { quote: n, setQuote: r } = P(ne), { unionText: o } = O(), { installationMethodMessages: a } = o, [i, l] = w(
    n == null ? void 0 : n.installationType
  ), [d, c] = w(!0);
  w({});
  const { getNextState: u, nextPage: m, redirectUrl: v, loading: b } = ke(), f = je(), {
    fetcher: k,
    loading: h,
    data: p,
    error: x
  } = ve(t.installationMethodModelUrl, {
    method: "POST",
    manual: !0
  });
  S(() => {
    d && n && k(n);
  }, [k, n, d]), S(() => {
    m || v ? Ie(f, v, m) : we();
  }, [f, v, m]);
  const y = $(() => {
    if (n != null && n.location) {
      const T = decodeURIComponent(escape(atob(n.location.substring(1)))), [C, _, z, E] = T.split("#"), I = new URLSearchParams({ lat: C, lng: _, address: z, crossId: E });
      return `${t.chooseInternetProgramUrl}?${I.toString()}`;
    }
    return t.chooseInternetUrl;
  }, [t.chooseInternetUrl, t.chooseInternetProgramUrl, n == null ? void 0 : n.location]), g = () => {
    let T = n != null ? n : {};
    T = Ti(T, i), c(!1), r(T, () => u());
  };
  return /* @__PURE__ */ s.jsx(qt, { requiredQuote: !0, alertMessage: a.missingQuoteError, children: /* @__PURE__ */ s.jsxs("div", { id: "installation-method-page", className: "content--wrapper", children: [
    /* @__PURE__ */ s.jsx(At, { children: /* @__PURE__ */ s.jsx(Rt, { href: y, children: a.breadcrumbs.backToChooseInternet }) }),
    !1,
    /* @__PURE__ */ s.jsx(W, { justify: "center", children: /* @__PURE__ */ s.jsxs(F, { span: { md: 10, lg: 8, xl: 6 }, children: [
      /* @__PURE__ */ s.jsxs("div", { className: "text-center mb-5", children: [
        /* @__PURE__ */ s.jsx("h1", { children: a.title }),
        x && /* @__PURE__ */ s.jsx(ye, { color: "danger", "data-o2-role": "alert-system", "data-o2-portlet": e, children: Qn.error }),
        h && /* @__PURE__ */ s.jsx("div", { className: "center", children: /* @__PURE__ */ s.jsx(Q, { "data-testid": "loader", name: "loading" }) })
      ] }),
      !h && /* @__PURE__ */ s.jsx(
        cl,
        {
          occs: p == null ? void 0 : p.occs,
          programType: p == null ? void 0 : p.programType,
          selectedInstallationType: i,
          setSelectedInstallationType: l,
          loading: h || b
        }
      ),
      /* @__PURE__ */ s.jsx(W, { justify: "center", children: /* @__PURE__ */ s.jsx(F, { span: { md: 10, lg: 8, xl: 6 }, children: /* @__PURE__ */ s.jsx(
        ge,
        {
          fullwidth: !0,
          "data-o2-id": "go-next-step",
          "data-testid": "go-next-step",
          name: "go-next-step",
          onClick: g,
          disabled: b || h || !i,
          children: a.nextStep
        }
      ) }) })
    ] }) })
  ] }) });
}, sc = () => {
  const { nextPage: t, redirectUrl: e } = ke(), { quote: n } = P(ne), { unionText: r } = O(), { internetErrorMessages: o } = r, a = je();
  return S(() => {
    t || e ? Ie(a, e, t) : we();
  }, [a, e, t]), /* @__PURE__ */ s.jsx("div", { id: "internet-error-page", className: "content--wrapper", children: /* @__PURE__ */ s.jsxs("div", { className: "flex-grow-1", children: [
    /* @__PURE__ */ s.jsx(De, { children: /* @__PURE__ */ s.jsx(
      De.Item,
      {
        onPress: () => {
          a(-1);
        },
        "data-testid": "o2-breadcrumbs-item",
        children: o.breadcrumbs.back
      }
    ) }),
    /* @__PURE__ */ s.jsx(W, { justify: "center", children: /* @__PURE__ */ s.jsxs(F, { span: { base: 12, md: 8, lg: 6 }, children: [
      /* @__PURE__ */ s.jsx("h1", { className: "text-center mt-5 mb-5", children: o.title }),
      /* @__PURE__ */ s.jsx(xn, { quote: n }),
      /* @__PURE__ */ s.jsx("h4", { className: "text-center mt-5 mb-5", children: o.contactUsTitle }),
      /* @__PURE__ */ s.jsx("p", { className: "text-center", dangerouslySetInnerHTML: { __html: o.contactUsText } }),
      /* @__PURE__ */ s.jsxs(W, { children: [
        /* @__PURE__ */ s.jsx(F, { span: { md: 6 }, children: /* @__PURE__ */ s.jsx(
          ie,
          {
            "aria-label": o.buttonStoresAria,
            usage: "outlined",
            fullwidth: !0,
            type: "button",
            "data-testid": "go-next-step",
            name: "go-next-step",
            className: "mt-5",
            onPress: () => {
              window.location.href = "/podpora/centrum-podpory/kontakty/o2-predajne";
            },
            children: o.buttonStores
          }
        ) }),
        /* @__PURE__ */ s.jsx(F, { span: { md: 6 }, children: /* @__PURE__ */ s.jsx(
          ie,
          {
            "aria-label": o.buttonContactUsAria,
            fullwidth: !0,
            type: "button",
            "data-testid": "go-next-step",
            name: "go-next-step",
            className: "mt-5",
            onPress: () => {
              window.location.href = "/podpora/centrum-podpory/kontakty";
            },
            children: o.buttonContactUs
          }
        ) })
      ] })
    ] }) })
  ] }) });
}, oc = () => {
  const { getNextState: t, nextPage: e, redirectUrl: n } = ke(), { quote: r, setQuote: o } = P(ne), { unionText: a } = O(), { internetErrorAssistantMessages: i } = a, l = je();
  S(() => {
    e || n ? Ie(l, n, e) : we();
  }, [l, n, e]);
  const d = () => {
    o(
      {
        internetPortIn: G(H({}, r == null ? void 0 : r.internetPortIn), { portInType: "PORT_IN" })
      },
      () => t()
    );
  };
  return /* @__PURE__ */ s.jsx("div", { id: "internet-error-assistant-page", className: "content--wrapper", children: /* @__PURE__ */ s.jsxs("div", { className: "flex-grow-1", children: [
    /* @__PURE__ */ s.jsx(De, { children: /* @__PURE__ */ s.jsx(
      De.Item,
      {
        onPress: () => {
          l(-1);
        },
        "data-testid": "o2-breadcrumbs-item",
        children: i.breadcrumbs.back
      }
    ) }),
    /* @__PURE__ */ s.jsx(W, { justify: "center", children: /* @__PURE__ */ s.jsxs(F, { span: { base: 12, md: 8, lg: 6 }, children: [
      /* @__PURE__ */ s.jsx("h1", { className: "text-center mt-5 mb-5", children: i.title }),
      /* @__PURE__ */ s.jsx(xn, { quote: r }),
      /* @__PURE__ */ s.jsx("h4", { className: "text-center mt-5 mb-5", children: i.subtitle }),
      /* @__PURE__ */ s.jsxs("div", { children: [
        /* @__PURE__ */ s.jsx("b", { children: i.checkAddress.title }),
        /* @__PURE__ */ s.jsx("div", { className: "text-secondary mt-2 mb-2", children: i.checkAddress.text }),
        /* @__PURE__ */ s.jsx("a", { href: "/ponuka/pre-domacnost/o2-internet", children: i.checkAddress.link })
      ] }),
      /* @__PURE__ */ s.jsxs("div", { className: "mt-4", children: [
        /* @__PURE__ */ s.jsx("b", { children: i.portation.title }),
        /* @__PURE__ */ s.jsx("div", { className: "text-secondary mt-2 mb-2", children: i.portation.text }),
        /* @__PURE__ */ s.jsx("a", { href: "#", onClick: d, children: i.portation.link })
      ] })
    ] }) })
  ] }) });
}, ac = () => {
  var x, y, g;
  const { getNextState: t, nextPage: e, redirectUrl: n, loading: r } = ke(), { quote: o, setQuote: a } = P(ne), { unionText: i } = O(), { internetMoreInfoMessages: l } = i, d = je(), [c, u] = w(!1), [m, v] = w(""), [b, f] = w(""), k = {
    floor: (x = o == null ? void 0 : o.floor) != null ? x : "",
    apartment: (y = o == null ? void 0 : o.apartment) != null ? y : "",
    eic: (g = o == null ? void 0 : o.eicCode) != null ? g : ""
  };
  S(() => {
    e || n ? Ie(d, n, e) : we();
  }, [d, n, e]);
  const h = (T, C) => {
    v(T), f(C), u(!0);
  }, p = (T) => {
    var C, _, z, E;
    a(
      {
        floor: (C = o == null ? void 0 : o.internetMoreInfoData) != null && C.askForFloor ? T.floor : o == null ? void 0 : o.floor,
        apartment: (_ = o == null ? void 0 : o.internetMoreInfoData) != null && _.askForFloor && ((z = o == null ? void 0 : o.internetMoreInfoData) != null && z.askForApartment) ? T.apartment : o == null ? void 0 : o.apartment,
        eicCode: (E = o == null ? void 0 : o.internetMoreInfoData) != null && E.askForEic ? T.eic : o == null ? void 0 : o.eicCode
      },
      () => t()
    );
  };
  return /* @__PURE__ */ s.jsxs("div", { id: "internet-port-in-page", className: "content--wrapper", children: [
    /* @__PURE__ */ s.jsx(
      Je,
      {
        "data-testid": "modal",
        open: c,
        onHide: () => u(!1),
        heading: m,
        children: b
      }
    ),
    /* @__PURE__ */ s.jsxs("div", { className: "flex-grow-1", children: [
      /* @__PURE__ */ s.jsx(De, { children: /* @__PURE__ */ s.jsx(
        De.Item,
        {
          onPress: () => {
            d(-1);
          },
          "data-testid": "o2-breadcrumbs-item",
          children: l.breadcrumbs.back
        }
      ) }),
      /* @__PURE__ */ s.jsx(Tt, { initialValues: k, onSubmit: p, children: ({ values: T }) => {
        var C, _, z, E, I, D, M, N;
        return /* @__PURE__ */ s.jsx(Kt, { id: "user-form", name: "userForm", "data-o2-id": "userForm", "data-testid": "userForm", children: /* @__PURE__ */ s.jsx(W, { justify: "center", children: /* @__PURE__ */ s.jsxs(F, { span: { base: 12, md: 8, lg: 6 }, children: [
          /* @__PURE__ */ s.jsx("h1", { id: "h1_label", className: "text-center mt-5 mb-5", children: l.title }),
          /* @__PURE__ */ s.jsx(xn, { quote: o }),
          ((C = o == null ? void 0 : o.internetMoreInfoData) == null ? void 0 : C.askForFloor) && !((_ = o == null ? void 0 : o.internetMoreInfoData) != null && _.askForApartment) && /* @__PURE__ */ s.jsx(hd, { floors: (z = o == null ? void 0 : o.internetMoreInfoData) == null ? void 0 : z.floors }),
          ((E = o == null ? void 0 : o.internetMoreInfoData) == null ? void 0 : E.askForFloor) && ((I = o == null ? void 0 : o.internetMoreInfoData) == null ? void 0 : I.askForApartment) && /* @__PURE__ */ s.jsx(fd, {}),
          ((D = o == null ? void 0 : o.internetMoreInfoData) == null ? void 0 : D.askForEic) && /* @__PURE__ */ s.jsx(pd, { showModal: h }),
          /* @__PURE__ */ s.jsx(W, { justify: "center", children: /* @__PURE__ */ s.jsx(F, { span: { md: 10, lg: 8, xl: 6 }, children: /* @__PURE__ */ s.jsx(
            ie,
            {
              "aria-label": l.continueAria,
              fullwidth: !0,
              type: "submit",
              "data-testid": "go-next-step",
              name: "go-next-step",
              className: "mt-5",
              disabled: r || ((M = o == null ? void 0 : o.internetMoreInfoData) == null ? void 0 : M.askForFloor) && !T.floor || ((N = o == null ? void 0 : o.internetMoreInfoData) == null ? void 0 : N.askForEic) && !T.eic,
              children: l.continue
            }
          ) }) })
        ] }) }) });
      } })
    ] })
  ] });
}, ic = () => {
  var T, C;
  const { getNextState: t, nextPage: e, redirectUrl: n, loading: r } = ke(), { config: o } = P(K), { quote: a, setQuote: i } = P(ne), { unionText: l } = O(), { internetPortInMessages: d } = l, c = je(), [u, m] = w(!1), [v, b] = w(""), [f, k] = w(""), { data: h, fetcher: p } = ve(
    o.internetPortInUrl,
    {
      method: "POST",
      manual: !0,
      payload: a
    }
  ), x = {
    portInType: (C = (T = a == null ? void 0 : a.internetPortIn) == null ? void 0 : T.portInType) != null ? C : ""
  };
  S(() => {
    e || n ? Ie(c, n, e) : we();
  }, [c, n, e]);
  const y = (_, z) => {
    b(_), k(z), m(!0);
  }, g = (_) => {
    i(
      {
        internetPortIn: {
          portInType: _.portInType === "" ? void 0 : _.portInType
        }
      },
      () => t()
    );
  };
  return S(() => {
    a && p(a);
  }, [p, a]), /* @__PURE__ */ s.jsxs("div", { id: "internet-port-in-page", className: "content--wrapper", children: [
    /* @__PURE__ */ s.jsx(
      Je,
      {
        "data-testid": "modal",
        open: u,
        onHide: () => m(!1),
        heading: v,
        children: f
      }
    ),
    /* @__PURE__ */ s.jsxs("div", { className: "flex-grow-1", children: [
      /* @__PURE__ */ s.jsx(De, { children: /* @__PURE__ */ s.jsx(
        De.Item,
        {
          onPress: () => {
            c(-1);
          },
          "data-testid": "o2-breadcrumbs-item",
          children: d.breadcrumbs.back
        }
      ) }),
      /* @__PURE__ */ s.jsx(Tt, { initialValues: x, onSubmit: g, children: ({ values: _ }) => /* @__PURE__ */ s.jsx(Kt, { id: "user-form", name: "userForm", "data-o2-id": "userForm", "data-testid": "userForm", children: /* @__PURE__ */ s.jsx(W, { justify: "center", children: /* @__PURE__ */ s.jsxs(F, { span: { base: 12, md: 8, lg: 6 }, children: [
        /* @__PURE__ */ s.jsx("h1", { id: "h1_label", className: "text-center mt-5 mb-5", children: d.title }),
        /* @__PURE__ */ s.jsx(xn, { quote: a }),
        /* @__PURE__ */ s.jsx(gd, { portInData: h, loading: r, showModal: y }),
        /* @__PURE__ */ s.jsx(W, { justify: "center", children: /* @__PURE__ */ s.jsx(F, { span: { md: 10, lg: 8, xl: 6 }, children: /* @__PURE__ */ s.jsx(
          ie,
          {
            "aria-label": d.continueAria,
            fullwidth: !0,
            type: "submit",
            "data-testid": "go-next-step",
            name: "go-next-step",
            className: "mt-5",
            disabled: r || !_.portInType,
            children: d.continue
          }
        ) }) })
      ] }) }) }) })
    ] })
  ] });
}, lc = () => {
  var b, f, k, h, p, x;
  const { getNextState: t, nextPage: e, redirectUrl: n, loading: r } = ke(), { config: o } = P(K), { quote: a, setQuote: i } = P(ne), { unionText: l } = O(), { internetPortInOperatorMessages: d } = l, c = je(), { data: u } = ve(o.internetPortInOperatorUrl, {
    method: "GET",
    manual: !1
  }), m = {
    donorCode: (f = (b = a == null ? void 0 : a.internetPortIn) == null ? void 0 : b.donorCode) != null ? f : "",
    donorServiceId: (h = (k = a == null ? void 0 : a.internetPortIn) == null ? void 0 : k.donorServiceId) != null ? h : "",
    donorBillingProfileId: (x = (p = a == null ? void 0 : a.internetPortIn) == null ? void 0 : p.donorBillingProfileId) != null ? x : ""
  };
  S(() => {
    e || n ? Ie(c, n, e) : we();
  }, [c, n, e]);
  const v = (y) => {
    var g;
    i(
      {
        internetPortIn: {
          portInType: (g = a == null ? void 0 : a.internetPortIn) == null ? void 0 : g.portInType,
          donorCode: y.donorCode,
          donorServiceId: y == null ? void 0 : y.donorServiceId,
          donorBillingProfileId: y.donorBillingProfileId ? y.donorBillingProfileId : void 0
        }
      },
      () => t()
    );
  };
  return /* @__PURE__ */ s.jsx("div", { id: "internet-port-in-page", className: "content--wrapper", children: /* @__PURE__ */ s.jsxs("div", { className: "flex-grow-1", children: [
    /* @__PURE__ */ s.jsx(De, { children: /* @__PURE__ */ s.jsx(
      De.Item,
      {
        onPress: () => {
          c(-1);
        },
        "data-testid": "o2-breadcrumbs-item",
        children: d.breadcrumbs.back
      }
    ) }),
    /* @__PURE__ */ s.jsx(Tt, { initialValues: m, onSubmit: v, children: ({ values: y }) => {
      var g;
      return /* @__PURE__ */ s.jsx(Kt, { id: "user-form", name: "userForm", "data-o2-id": "userForm", "data-testid": "userForm", children: /* @__PURE__ */ s.jsx(W, { justify: "center", children: /* @__PURE__ */ s.jsxs(F, { span: { base: 12, md: 8, lg: 6 }, children: [
        /* @__PURE__ */ s.jsx("h1", { id: "h1_label", className: "text-center mt-5 mb-5", children: d.title }),
        /* @__PURE__ */ s.jsx(
          xd,
          {
            operators: u == null ? void 0 : u.operators,
            portInOperatorData: a == null ? void 0 : a.internetPortInData
          }
        ),
        /* @__PURE__ */ s.jsx(W, { justify: "center", children: /* @__PURE__ */ s.jsx(F, { span: { md: 10, lg: 8, xl: 6 }, children: /* @__PURE__ */ s.jsx(
          ie,
          {
            "aria-label": d.continueAria,
            fullwidth: !0,
            type: "submit",
            "data-testid": "go-next-step",
            name: "go-next-step",
            className: "mt-5",
            disabled: r || !y.donorCode || !y.donorServiceId || !((g = y.donorBillingProfileIdValid) != null && g) || Dn(a == null ? void 0 : a.internetPortInData, y),
            children: d.continue
          }
        ) }) })
      ] }) }) });
    } })
  ] }) });
}, dc = () => {
  const { setAskedForLogin: t } = P($r), { config: e } = P(K), { unionText: n } = O(), { loginMessages: r } = n, [o] = mn(), a = J(() => {
    t(!0);
  }, [t]), i = J(() => {
    localStorage.setItem("askedForLogin", "true"), Authentication.authenticate({
      redirect_url: ji(window.location.href)
    });
  }, []), {
    data: l,
    loading: d,
    fetcher: c
  } = ve(e.hideButtonsUrl, {
    method: "POST",
    manual: !0
  });
  return S(() => {
    if (o) {
      const u = Object.entries(q).map(([b, f]) => [f, b]), v = {
        currentPage: Object.fromEntries(u)[location.pathname],
        referrer: document.referrer,
        nextPage: void 0,
        redirectUrl: void 0,
        contextQuote: ls(o)
      };
      c(v);
    }
  }, [c, o]), /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsx(dr, {}),
    /* @__PURE__ */ s.jsxs("div", { className: "row justify-content-center", children: [
      /* @__PURE__ */ s.jsxs("div", { className: "col-12 col-lg-8 center", children: [
        /* @__PURE__ */ s.jsx("h1", { children: r.heading }),
        /* @__PURE__ */ s.jsx("p", { children: r.description })
      ] }),
      /* @__PURE__ */ s.jsx(Vn, { src: "https://www.o2.sk/documents/2355222/180577834/login.png", skipWebp: !0, className: "text-center" }),
      /* @__PURE__ */ s.jsx("div", { className: "col-12 col-lg-8 center", children: d ? /* @__PURE__ */ s.jsx("div", { className: "center", children: /* @__PURE__ */ s.jsx(Q, { "data-testid": "loader", name: "loading", color: "blue-brand", size: 45 }) }) : /* @__PURE__ */ s.jsxs("div", { className: "row", children: [
        !(l != null && l.hideExistingCustomerButton) && /* @__PURE__ */ s.jsx(
          "div",
          {
            className: l != null && l.hideNewCustomerButton ? "col-12 col-sm-12 center" : "col-12 col-sm-6 center",
            children: /* @__PURE__ */ s.jsx(
              ge,
              {
                id: "authenticate-btn",
                "data-o2-id": "login.authenticate",
                "data-testid": "login.authenticate",
                name: "login.authenticate",
                onClick: i,
                fullwidth: !0,
                className: "mb-2 mb-md-0",
                children: r.submit
              }
            )
          }
        ),
        !(l != null && l.hideNewCustomerButton) && /* @__PURE__ */ s.jsx(
          "div",
          {
            className: l != null && l.hideExistingCustomerButton ? "col-12 col-sm-12 center" : "col-12 col-sm-6 center",
            children: /* @__PURE__ */ s.jsx(
              ge,
              {
                id: "cancel-btn",
                usage: "outlined",
                "data-o2-id": "login.cancel",
                "data-testid": "login.cancel",
                name: "login.cancel",
                "data-o2-role": "action-cancel",
                onClick: a,
                fullwidth: !0,
                children: r.cancel
              }
            )
          }
        )
      ] }) })
    ] })
  ] });
}, cc = () => {
  var N;
  const { config: t, namespace: e } = P(K), { quote: n, setQuote: r } = P(ne), { unionText: o } = O(), { ownDeviceMessages: a } = o, [i, l] = w([]), [d, c] = w(!0), [u, m] = w((N = n == null ? void 0 : n.ownDeviceSerialNumber) != null ? N : ""), [v, b] = w(""), { getNextState: f, nextPage: k, redirectUrl: h, loading: p } = ke(), x = je(), {
    fetcher: y,
    loading: g,
    data: T,
    error: C
  } = ve(t.ownDeviceModelUrl, {
    method: "POST",
    manual: !0
  }), {
    fetcher: _,
    loading: z,
    data: E,
    error: I
  } = ve($a(t.ownDeviceSerialNumberUrl, { serialNumber: u }), {
    method: "GET",
    manual: !0
  });
  S(() => {
    u && _();
  }, [_, u]), S(() => {
    E != null && E.code ? b(a.serialNumber.validations[E.code]) : I && b(a.serialNumber.validationError);
  }, [
    E,
    I,
    a.serialNumber.validationError,
    a.serialNumber.validations
  ]), S(() => {
    d && n && y(n);
  }, [y, n, d]), S(() => {
    k || h ? Ie(x, h, k) : we();
  }, [x, h, k]);
  const D = $(() => {
    if (n != null && n.location) {
      const j = decodeURIComponent(escape(atob(n.location.substring(1)))), [U, xe, Te, Ae] = j.split("#"), Re = new URLSearchParams({ lat: U, lng: xe, address: Te, crossId: Ae });
      return `${t.chooseInternetProgramUrl}?${Re.toString()}`;
    }
    return t.chooseInternetUrl;
  }, [t.chooseInternetUrl, t.chooseInternetProgramUrl, n == null ? void 0 : n.location]), M = () => {
    let j = n != null ? n : {};
    j = wi(j, u), j = ds(j, T == null ? void 0 : T.extenders, i), c(!1), r(j, () => f());
  };
  return /* @__PURE__ */ s.jsx(qt, { requiredQuote: !0, alertMessage: a.missingQuoteError, children: /* @__PURE__ */ s.jsxs("div", { id: "own-device-page", className: "content--wrapper", children: [
    /* @__PURE__ */ s.jsx(At, { children: /* @__PURE__ */ s.jsx(Rt, { href: D, children: a.breadcrumbs.backToChooseInternet }) }),
    /* @__PURE__ */ s.jsx("div", { className: "row justify-content-md-center", children: /* @__PURE__ */ s.jsxs("div", { className: "col-md-10 col-lg-8 col-xl-6", children: [
      /* @__PURE__ */ s.jsxs("div", { className: "text-center mb-5", children: [
        /* @__PURE__ */ s.jsx("h1", { children: a.title }),
        C && /* @__PURE__ */ s.jsx(ye, { color: "danger", "data-o2-role": "alert-system", "data-o2-portlet": e, children: Qn.error }),
        g && /* @__PURE__ */ s.jsx("div", { className: "center", children: /* @__PURE__ */ s.jsx(Q, { "data-testid": "loader", name: "loading" }) }),
        /* @__PURE__ */ s.jsx(Q, { name: "network-status", className: "mb-3", size: 48, color: "blue-brand" }),
        /* @__PURE__ */ s.jsx("div", { className: "h6 mb-1", children: T == null ? void 0 : T.program.displayName }),
        (T == null ? void 0 : T.program.priceDescription) && /* @__PURE__ */ s.jsx("div", { className: "text-secondary", children: T.program.priceDescription })
      ] }),
      /* @__PURE__ */ s.jsx(
        xt,
        {
          background: "blue-light",
          "data-o2-id": "box-own-device-serial-number",
          "data-testid": "box-own-device-serial-number",
          children: /* @__PURE__ */ s.jsx(
            Xt,
            {
              label: a.serialNumber.label,
              "data-o2-id": "material-ean-sn-input",
              "data-testid": "material-ean-sn-input",
              name: "materialEanSnInput",
              onChange: (j) => {
                j.target.value ? m(j.target.value) : (m(""), b(a.serialNumber.required));
              },
              color: v ? "danger" : "default",
              required: !0,
              help: v || void 0
            }
          )
        }
      ),
      /* @__PURE__ */ s.jsx(
        Ps,
        {
          extenders: T == null ? void 0 : T.extenders,
          selectedExtenders: i,
          setSelectedExtenders: l
        }
      )
    ] }) }),
    /* @__PURE__ */ s.jsx("div", { className: "row justify-content-md-center", children: /* @__PURE__ */ s.jsx("div", { className: "col-md-10 col-lg-8 col-xl-6", children: /* @__PURE__ */ s.jsx(
      ge,
      {
        fullwidth: !0,
        "data-o2-id": "go-next-step",
        "data-testid": "go-next-step",
        name: "go-next-step",
        onClick: M,
        disabled: p || g || z || !!v || !u,
        children: a.nextStep
      }
    ) }) })
  ] }) });
}, uc = {
  hardwareType: "modern",
  tvBoxes: []
}, mc = () => {
  const { namespace: t } = P(K), { getNextState: e, nextPage: n, redirectUrl: r, loading: o, error: a } = ke(), { quote: i, setQuote: l } = P(ne), { unionText: d } = O(), { tvStandaloneMessages: c } = d, u = je(), m = Ln(), v = ["base", "sm", "md"].includes(m), b = (f) => {
    var k;
    l(
      {
        contextTariff: {
          seoId: (k = i == null ? void 0 : i.contextTariff) == null ? void 0 : k.seoId
        },
        tvStandaloneHardware: Oi(f)
      },
      () => e()
    );
  };
  return S(() => {
    n || r ? Ie(u, r, n) : we();
  }, [u, r, n]), /* @__PURE__ */ s.jsxs(W, { justify: "center", "data-testid": "tvStandalone.chooseHardware", children: [
    /* @__PURE__ */ s.jsx(De, { children: /* @__PURE__ */ s.jsx(De.Item, { onPress: () => u(-1), "data-testid": "o2.breadcrumbs.backItem", children: c.breadcrumbs.back }) }),
    a && /* @__PURE__ */ s.jsx(
      Ge,
      {
        closable: !0,
        color: "danger",
        "data-o2-portlet": t,
        "data-o2-role": "alert-system",
        "data-testid": "tvStandalone.chooseHardware.alert",
        children: c.errors.nextStepSubmit
      }
    ),
    /* @__PURE__ */ s.jsxs(F, { span: v ? 12 : 6, children: [
      /* @__PURE__ */ s.jsx(B, { mb: 4, children: /* @__PURE__ */ s.jsx("h1", { className: "text-center", children: c.heading }) }),
      /* @__PURE__ */ s.jsx(Tt, { initialValues: uc, onSubmit: b, children: ({ values: f }) => /* @__PURE__ */ s.jsxs(Rr, { id: "tvStandalone.form", name: "tvStandaloneForm", "data-testid": "tvStandalone.form", children: [
        /* @__PURE__ */ s.jsx(Ld, {}),
        /* @__PURE__ */ s.jsx(B, { justify: "center", children: /* @__PURE__ */ s.jsx(F, { span: v ? 12 : 6, children: /* @__PURE__ */ s.jsx(
          ie,
          {
            "aria-label": c.button.submitAria,
            w: 100,
            type: "submit",
            "data-testid": "goNextStep",
            name: "go-next-step",
            className: "mt-4",
            disabled: o || f.hardwareType === "old" && f.tvBoxes.reduce((k, h) => +k + +h.amount, 0) === 0,
            children: c.button.submit
          }
        ) }) })
      ] }) })
    ] })
  ] });
}, pc = ({ children: t }) => {
  const { initialized: e, quote: n, setQuote: r } = Pi();
  return /* @__PURE__ */ s.jsx(ne.Provider, { value: { initialized: e, quote: n, setQuote: r }, children: t });
}, hc = ({ children: t }) => {
  const [e, n] = w(!1);
  return /* @__PURE__ */ s.jsx(Fe.Provider, { value: { isLoading: e, setIsLoading: (r) => n(r) }, children: t });
}, fc = () => {
  const { initialized: t, quote: e } = P(ne), { getNextState: n, nextPage: r, redirectUrl: o, loading: a, error: i } = ke(), l = je(), c = Hn().pathname === "/";
  return S(() => {
    c && t && !r && !o && n();
  }, [t, n, e, o, c, r]), S(() => {
    c && Ie(l, o, r, { replace: !0 });
  }, [l, r, o, c]), /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    i && /* @__PURE__ */ s.jsx(Pn, { children: /* @__PURE__ */ s.jsx(fe, { path: "*", element: /* @__PURE__ */ s.jsx(tc, { error: i }) }) }),
    a && /* @__PURE__ */ s.jsx("div", { className: "center", children: /* @__PURE__ */ s.jsx(Q, { name: "loading", color: "blue-brand", size: 45 }) }),
    (r || !c) && /* @__PURE__ */ s.jsxs(Pn, { children: [
      /* @__PURE__ */ s.jsx(
        fe,
        {
          path: q.CHOOSE_TARIFF,
          element: /* @__PURE__ */ s.jsx(te, { children: /* @__PURE__ */ s.jsx(Zd, {}) })
        }
      ),
      /* @__PURE__ */ s.jsx(
        fe,
        {
          path: q.CHOOSE_TRANSACTION,
          element: /* @__PURE__ */ s.jsx(te, { children: /* @__PURE__ */ s.jsx(Kd, {}) })
        }
      ),
      /* @__PURE__ */ s.jsx(
        fe,
        {
          path: q.HW_SLIDER,
          element: /* @__PURE__ */ s.jsx(te, { children: /* @__PURE__ */ s.jsx(nc, {}) })
        }
      ),
      /* @__PURE__ */ s.jsx(
        fe,
        {
          path: q.CART,
          element: /* @__PURE__ */ s.jsx(te, { children: /* @__PURE__ */ s.jsx(Mi, {}) })
        }
      ),
      /* @__PURE__ */ s.jsx(
        fe,
        {
          path: q.CHOOSE_DEVICE_PAYMENT,
          element: /* @__PURE__ */ s.jsx(te, { children: /* @__PURE__ */ s.jsx(Gd, {}) })
        }
      ),
      /* @__PURE__ */ s.jsx(
        fe,
        {
          path: q.OWN_DEVICE,
          element: /* @__PURE__ */ s.jsx(te, { children: /* @__PURE__ */ s.jsx(cc, {}) })
        }
      ),
      /* @__PURE__ */ s.jsx(
        fe,
        {
          path: q.INSTALLATION_METHOD,
          element: /* @__PURE__ */ s.jsx(te, { children: /* @__PURE__ */ s.jsx(rc, {}) })
        }
      ),
      /* @__PURE__ */ s.jsx(
        fe,
        {
          path: q.CHOOSE_ROUTER,
          element: /* @__PURE__ */ s.jsx(te, { children: /* @__PURE__ */ s.jsx($d, {}) })
        }
      ),
      /* @__PURE__ */ s.jsx(fe, { path: q.ADDONS, element: /* @__PURE__ */ s.jsx(Ar, {}) }),
      /* @__PURE__ */ s.jsx(fe, { path: q.CROSS_SELL, element: /* @__PURE__ */ s.jsx(Ar, {}) }),
      /* @__PURE__ */ s.jsx(
        fe,
        {
          path: q.CHOOSE_BUYOUT,
          element: /* @__PURE__ */ s.jsx(te, { children: /* @__PURE__ */ s.jsx(Bd, {}) })
        }
      ),
      /* @__PURE__ */ s.jsx(
        fe,
        {
          path: q.INTERNET_PORT_IN,
          element: /* @__PURE__ */ s.jsx(te, { children: /* @__PURE__ */ s.jsx(ic, {}) })
        }
      ),
      /* @__PURE__ */ s.jsx(
        fe,
        {
          path: q.INTERNET_PORT_IN_OPERATOR,
          element: /* @__PURE__ */ s.jsx(te, { children: /* @__PURE__ */ s.jsx(lc, {}) })
        }
      ),
      /* @__PURE__ */ s.jsx(
        fe,
        {
          path: q.INTERNET_MORE_INFO,
          element: /* @__PURE__ */ s.jsx(te, { children: /* @__PURE__ */ s.jsx(ac, {}) })
        }
      ),
      /* @__PURE__ */ s.jsx(
        fe,
        {
          path: q.INTERNET_ERROR,
          element: /* @__PURE__ */ s.jsx(te, { children: /* @__PURE__ */ s.jsx(sc, {}) })
        }
      ),
      /* @__PURE__ */ s.jsx(
        fe,
        {
          path: q.INTERNET_ERROR_ASSISTANT,
          element: /* @__PURE__ */ s.jsx(te, { children: /* @__PURE__ */ s.jsx(oc, {}) })
        }
      ),
      /* @__PURE__ */ s.jsx(
        fe,
        {
          path: q.TV_STANDALONE_CHOOSE_HARDWARE,
          element: /* @__PURE__ */ s.jsx(te, { children: /* @__PURE__ */ s.jsx(mc, {}) })
        }
      ),
      /* @__PURE__ */ s.jsx(fe, { path: "/", element: /* @__PURE__ */ s.jsx("div", {}) })
    ] })
  ] });
}, gc = () => /* @__PURE__ */ s.jsx(Pn, { children: /* @__PURE__ */ s.jsx(
  fe,
  {
    path: "*",
    element: /* @__PURE__ */ s.jsx(te, { children: /* @__PURE__ */ s.jsx(dc, {}) })
  }
) }), vc = () => {
  const { askedForLogin: t, setAskedForLogin: e } = Fo(), n = localStorage.getItem("signed") === "true", r = !t && !n;
  return /* @__PURE__ */ s.jsxs($r.Provider, { value: { askedForLogin: t, setAskedForLogin: e }, children: [
    r && /* @__PURE__ */ s.jsx(gc, {}),
    !r && /* @__PURE__ */ s.jsx(pc, { children: /* @__PURE__ */ s.jsx(hc, { children: /* @__PURE__ */ s.jsx(fc, {}) }) })
  ] });
};
const xc = {
  errorMessages: Mn,
  loginMessages: Po,
  commonMessages: Qn,
  addonsMessages: io,
  buyOutMessages: lo,
  hwSliderMessages: ko,
  crossSellMessages: Qe,
  hwDevicesMessages: jo,
  ownDeviceMessages: Mo,
  chargePeriodMessages: co,
  chooseDeviceMessages: uo,
  installationMethodMessages: To,
  chooseTariffMessages: po,
  chooseTransactionMessages: ho,
  chooseDevicePaymentsMessages: mo,
  internetMoreInfoMessages: No,
  internetPortInMessages: So,
  internetPortInOperatorMessages: Oo,
  internetErrorMessages: wo,
  internetErrorAssistantMessages: Io,
  tvStandaloneMessages: Ao
}, Oc = ({ namespace: t, data: e }) => {
  const { synced: n, loading: r, error: o } = Vs();
  return S(() => {
    var a, i;
    r ? (a = window.ePortalInitStartOverlay) == null || a.call(window) : (i = window.ePortalInitStopOverlay) == null || i.call(window);
  }, [r]), /* @__PURE__ */ s.jsx(Gs, { portlet: t, initialTexts: xc, children: ({ unionText: a }) => /* @__PURE__ */ s.jsxs(K.Provider, { value: { namespace: t, config: e }, children: [
    o && /* @__PURE__ */ s.jsx(te, { children: /* @__PURE__ */ s.jsx(Ge, { color: "danger", "data-o2-portlet": t, "data-o2-role": "alert-system", children: a.commonMessages.error }) }),
    n && /* @__PURE__ */ s.jsx(Ws, { children: /* @__PURE__ */ s.jsx(Qs, { portlet: t, children: /* @__PURE__ */ s.jsx(vc, {}) }) })
  ] }) });
};
export {
  Oc as EshopWizardPortlet
};
//# sourceMappingURL=index.js.map
